// Codici Belfiore di tutti i comuni italiani (fonte ISTAT/ANPR, ~7900 comuni).
// Generato automaticamente. Se un comune non esiste o la nascita e' all'estero (codice Z),
// la verifica del luogo di nascita viene saltata senza falsi allarmi.

const BELFIORE = {
  "ABANO TERME": "A001",
  "ABBADIA CERRETO": "A004",
  "ABBADIA LARIANA": "A005",
  "ABBADIA SAN SALVATORE": "A006",
  "ABBASANTA": "A007",
  "ABBATEGGIO": "A008",
  "ABBIATEGRASSO": "A010",
  "ABETONE CUTIGLIANO": "M376",
  "ABRIOLA": "A013",
  "ACATE": "A014",
  "ACCADIA": "A015",
  "ACCEGLIO": "A016",
  "ACCETTURA": "A017",
  "ACCIANO": "A018",
  "ACCUMOLI": "A019",
  "ACERENZA": "A020",
  "ACERNO": "A023",
  "ACERRA": "A024",
  "ACI BONACCORSI": "A025",
  "ACI CASTELLO": "A026",
  "ACI CATENA": "A027",
  "ACI SANTANTONIO": "A029",
  "ACIREALE": "A028",
  "ACQUAFONDATA": "A032",
  "ACQUAFORMOSA": "A033",
  "ACQUAFREDDA": "A034",
  "ACQUALAGNA": "A035",
  "ACQUANEGRA CREMONESE": "A039",
  "ACQUANEGRA SUL CHIESE": "A038",
  "ACQUAPENDENTE": "A040",
  "ACQUAPPESA": "A041",
  "ACQUARO": "A043",
  "ACQUASANTA TERME": "A044",
  "ACQUASPARTA": "A045",
  "ACQUAVIVA COLLECROCE": "A050",
  "ACQUAVIVA DELLE FONTI": "A048",
  "ACQUAVIVA DISERNIA": "A051",
  "ACQUAVIVA PICENA": "A047",
  "ACQUAVIVA PLATANI": "A049",
  "ACQUEDOLCI": "M211",
  "ACQUI TERME": "A052",
  "ACRI": "A053",
  "ACUTO": "A054",
  "ADELFIA": "A055",
  "ADRANO": "A056",
  "ADRARA SAN MARTINO": "A057",
  "ADRARA SAN ROCCO": "A058",
  "ADRIA": "A059",
  "ADRO": "A060",
  "AFFI": "A061",
  "AFFILE": "A062",
  "AFRAGOLA": "A064",
  "AFRICO": "A065",
  "AGAZZANO": "A067",
  "AGEROLA": "A068",
  "AGGIUS": "A069",
  "AGIRA": "A070",
  "AGLIANA": "A071",
  "AGLIANO TERME": "A072",
  "AGLIE": "A074",
  "AGLIENTU": "H848",
  "AGNA": "A075",
  "AGNADELLO": "A076",
  "AGNANA CALABRA": "A077",
  "AGNONE": "A080",
  "AGNOSINE": "A082",
  "AGORDO": "A083",
  "AGOSTA": "A084",
  "AGRA": "A085",
  "AGRATE BRIANZA": "A087",
  "AGRATE CONTURBIA": "A088",
  "AGRIGENTO": "A089",
  "AGROPOLI": "A091",
  "AGUGLIANO": "A092",
  "AGUGLIARO": "A093",
  "AICURZIO": "A096",
  "AIDOMAGGIORE": "A097",
  "AIDONE": "A098",
  "AIELLI": "A100",
  "AIELLO CALABRO": "A102",
  "AIELLO DEL FRIULI": "A103",
  "AIELLO DEL SABATO": "A101",
  "AIETA": "A105",
  "AILANO": "A106",
  "AILOCHE": "A107",
  "AIRASCA": "A109",
  "AIROLA": "A110",
  "AIROLE": "A111",
  "AIRUNO": "A112",
  "AISONE": "A113",
  "ALA": "A116",
  "ALA DEI SARDI": "A115",
  "ALA DI STURA": "A117",
  "ALAGNA": "A118",
  "ALAGNA VALSESIA": "A119",
  "ALANNO": "A120",
  "ALANO DI PIAVE": "A121",
  "ALASSIO": "A122",
  "ALATRI": "A123",
  "ALBA": "A124",
  "ALBA ADRIATICA": "A125",
  "ALBAGIARA": "A126",
  "ALBAIRATE": "A127",
  "ALBANELLA": "A128",
  "ALBANO DI LUCANIA": "A131",
  "ALBANO LAZIALE": "A132",
  "ALBANO SANTALESSANDRO": "A129",
  "ALBANO VERCELLESE": "A130",
  "ALBAREDO ARNABOLDI": "A134",
  "ALBAREDO DADIGE": "A137",
  "ALBAREDO PER SAN MARCO": "A135",
  "ALBARETO": "A138",
  "ALBARETTO DELLA TORRE": "A139",
  "ALBAVILLA": "A143",
  "ALBENGA": "A145",
  "ALBERA LIGURE": "A146",
  "ALBEROBELLO": "A149",
  "ALBERONA": "A150",
  "ALBESE CON CASSANO": "A153",
  "ALBETTONE": "A154",
  "ALBI": "A155",
  "ALBIANO": "A158",
  "ALBIANO DIVREA": "A157",
  "ALBIATE": "A159",
  "ALBIDONA": "A160",
  "ALBIGNASEGO": "A161",
  "ALBINEA": "A162",
  "ALBINO": "A163",
  "ALBIOLO": "A164",
  "ALBISOLA SUPERIORE": "A166",
  "ALBISSOLA MARINA": "A165",
  "ALBIZZATE": "A167",
  "ALBONESE": "A171",
  "ALBOSAGGIA": "A172",
  "ALBUGNANO": "A173",
  "ALBUZZANO": "A175",
  "ALCAMO": "A176",
  "ALCARA LI FUSI": "A177",
  "ALDENO": "A178",
  "ALDINO": "A179",
  "ALES": "A180",
  "ALESSANDRIA": "A182",
  "ALESSANDRIA DEL CARRETTO": "A183",
  "ALESSANDRIA DELLA ROCCA": "A181",
  "ALESSANO": "A184",
  "ALEZIO": "A185",
  "ALFANO": "A186",
  "ALFEDENA": "A187",
  "ALFIANELLO": "A188",
  "ALFIANO NATTA": "A189",
  "ALFONSINE": "A191",
  "ALGHERO": "A192",
  "ALGUA": "A193",
  "ALI": "A194",
  "ALI TERME": "A201",
  "ALIA": "A195",
  "ALIANO": "A196",
  "ALICE BEL COLLE": "A197",
  "ALICE CASTELLO": "A198",
  "ALIFE": "A200",
  "ALIMENA": "A202",
  "ALIMINUSA": "A203",
  "ALLAI": "A204",
  "ALLEGHE": "A206",
  "ALLEIN": "A205",
  "ALLERONA": "A207",
  "ALLISTE": "A208",
  "ALLUMIERE": "A210",
  "ALLUVIONI PIOVERA": "M397",
  "ALME": "A214",
  "ALMENNO SAN BARTOLOMEO": "A216",
  "ALMENNO SAN SALVATORE": "A217",
  "ALMESE": "A218",
  "ALONTE": "A220",
  "ALPAGO": "M375",
  "ALPETTE": "A221",
  "ALPIGNANO": "A222",
  "ALSENO": "A223",
  "ALSERIO": "A224",
  "ALTA VAL TIDONE": "M386",
  "ALTA VALLE INTELVI": "M383",
  "ALTAMURA": "A225",
  "ALTARE": "A226",
  "ALTAVALLE": "M349",
  "ALTAVILLA IRPINA": "A228",
  "ALTAVILLA MILICIA": "A229",
  "ALTAVILLA MONFERRATO": "A227",
  "ALTAVILLA SILENTINA": "A230",
  "ALTAVILLA VICENTINA": "A231",
  "ALTIDONA": "A233",
  "ALTILIA": "A234",
  "ALTINO": "A235",
  "ALTISSIMO": "A236",
  "ALTIVOLE": "A237",
  "ALTO": "A238",
  "ALTO RENO TERME": "M369",
  "ALTO SERMENZA": "M389",
  "ALTOFONTE": "A239",
  "ALTOMONTE": "A240",
  "ALTOPASCIO": "A241",
  "ALTOPIANO DELLA VIGOLANA": "M350",
  "ALVIANO": "A242",
  "ALVIGNANO": "A243",
  "ALVITO": "A244",
  "ALZANO LOMBARDO": "A246",
  "ALZANO SCRIVIA": "A245",
  "ALZATE BRIANZA": "A249",
  "AMALFI": "A251",
  "AMANDOLA": "A252",
  "AMANTEA": "A253",
  "AMARO": "A254",
  "AMARONI": "A255",
  "AMASENO": "A256",
  "AMATO": "A257",
  "AMATRICE": "A258",
  "AMBIVERE": "A259",
  "AMBLAR-DON": "M351",
  "AMEGLIA": "A261",
  "AMELIA": "A262",
  "AMENDOLARA": "A263",
  "AMENO": "A264",
  "AMOROSI": "A265",
  "AMPEZZO": "A267",
  "ANACAPRI": "A268",
  "ANAGNI": "A269",
  "ANCARANO": "A270",
  "ANCONA": "A271",
  "ANDALI": "A272",
  "ANDALO": "A274",
  "ANDALO VALTELLINO": "A273",
  "ANDEZENO": "A275",
  "ANDORA": "A278",
  "ANDORNO MICCA": "A280",
  "ANDRANO": "A281",
  "ANDRATE": "A282",
  "ANDREIS": "A283",
  "ANDRETTA": "A284",
  "ANDRIA": "A285",
  "ANDRIANO": "A286",
  "ANELA": "A287",
  "ANFO": "A288",
  "ANGERA": "A290",
  "ANGHIARI": "A291",
  "ANGIARI": "A292",
  "ANGOLO TERME": "A293",
  "ANGRI": "A294",
  "ANGROGNA": "A295",
  "ANGUILLARA SABAZIA": "A297",
  "ANGUILLARA VENETA": "A296",
  "ANNICCO": "A299",
  "ANNONE DI BRIANZA": "A301",
  "ANNONE VENETO": "A302",
  "ANOIA": "A303",
  "ANTEGNATE": "A304",
  "ANTERIVO": "A306",
  "ANTEY-SAINT-ANDRE": "A305",
  "ANTICOLI CORRADO": "A309",
  "ANTIGNANO": "A312",
  "ANTILLO": "A313",
  "ANTONIMINA": "A314",
  "ANTRODOCO": "A315",
  "ANTRONA SCHIERANCO": "A317",
  "ANVERSA DEGLI ABRUZZI": "A318",
  "ANZANO DEL PARCO": "A319",
  "ANZANO DI PUGLIA": "A320",
  "ANZI": "A321",
  "ANZIO": "A323",
  "ANZOLA DELLEMILIA": "A324",
  "ANZOLA DOSSOLA": "A325",
  "AOSTA": "A326",
  "APECCHIO": "A327",
  "APICE": "A328",
  "APIRO": "A329",
  "APOLLOSA": "A330",
  "APPIANO GENTILE": "A333",
  "APPIANO SULLA STRADA DEL VINO": "A332",
  "APPIGNANO": "A334",
  "APPIGNANO DEL TRONTO": "A335",
  "APRICA": "A337",
  "APRICALE": "A338",
  "APRICENA": "A339",
  "APRIGLIANO": "A340",
  "APRILIA": "A341",
  "AQUARA": "A343",
  "AQUILA DARROSCIA": "A344",
  "AQUILEIA": "A346",
  "AQUILONIA": "A347",
  "AQUINO": "A348",
  "ARADEO": "A350",
  "ARAGONA": "A351",
  "ARAMENGO": "A352",
  "ARBA": "A354",
  "ARBOREA": "A357",
  "ARBORIO": "A358",
  "ARBUS": "A359",
  "ARCADE": "A360",
  "ARCE": "A363",
  "ARCENE": "A365",
  "ARCEVIA": "A366",
  "ARCHI": "A367",
  "ARCIDOSSO": "A369",
  "ARCINAZZO ROMANO": "A370",
  "ARCISATE": "A371",
  "ARCO": "A372",
  "ARCOLA": "A373",
  "ARCOLE": "A374",
  "ARCONATE": "A375",
  "ARCORE": "A376",
  "ARCUGNANO": "A377",
  "ARDARA": "A379",
  "ARDAULI": "A380",
  "ARDEA": "M213",
  "ARDENNO": "A382",
  "ARDESIO": "A383",
  "ARDORE": "A385",
  "ARENA": "A386",
  "ARENA PO": "A387",
  "ARENZANO": "A388",
  "ARESE": "A389",
  "AREZZO": "A390",
  "ARGEGNO": "A391",
  "ARGELATO": "A392",
  "ARGENTA": "A393",
  "ARGENTERA": "A394",
  "ARGUELLO": "A396",
  "ARGUSTO": "A397",
  "ARI": "A398",
  "ARIANO IRPINO": "A399",
  "ARIANO NEL POLESINE": "A400",
  "ARICCIA": "A401",
  "ARIELLI": "A402",
  "ARIENZO": "A403",
  "ARIGNANO": "A405",
  "ARITZO": "A407",
  "ARIZZANO": "A409",
  "ARLENA DI CASTRO": "A412",
  "ARLUNO": "A413",
  "ARMENO": "A414",
  "ARMENTO": "A415",
  "ARMO": "A418",
  "ARMUNGIA": "A419",
  "ARNAD": "A424",
  "ARNARA": "A421",
  "ARNASCO": "A422",
  "ARNESANO": "A425",
  "AROLA": "A427",
  "ARONA": "A429",
  "AROSIO": "A430",
  "ARPAIA": "A431",
  "ARPAISE": "A432",
  "ARPINO": "A433",
  "ARQUA PETRARCA": "A434",
  "ARQUA POLESINE": "A435",
  "ARQUATA DEL TRONTO": "A437",
  "ARQUATA SCRIVIA": "A436",
  "ARRE": "A438",
  "ARRONE": "A439",
  "ARSAGO SEPRIO": "A441",
  "ARSIE": "A443",
  "ARSIERO": "A444",
  "ARSITA": "A445",
  "ARSOLI": "A446",
  "ARTA TERME": "A447",
  "ARTEGNA": "A448",
  "ARTENA": "A449",
  "ARTOGNE": "A451",
  "ARVIER": "A452",
  "ARZACHENA": "A453",
  "ARZAGO DADDA": "A440",
  "ARZANA": "A454",
  "ARZANO": "A455",
  "ARZERGRANDE": "A458",
  "ARZIGNANO": "A459",
  "ASCEA": "A460",
  "ASCIANO": "A461",
  "ASCOLI PICENO": "A462",
  "ASCOLI SATRIANO": "A463",
  "ASCREA": "A464",
  "ASIAGO": "A465",
  "ASIGLIANO VENETO": "A467",
  "ASIGLIANO VERCELLESE": "A466",
  "ASOLA": "A470",
  "ASOLO": "A471",
  "ASSAGO": "A473",
  "ASSEMINI": "A474",
  "ASSISI": "A475",
  "ASSO": "A476",
  "ASSOLO": "A477",
  "ASSORO": "A478",
  "ASTI": "A479",
  "ASUNI": "A480",
  "ATELETA": "A481",
  "ATELLA": "A482",
  "ATENA LUCANA": "A484",
  "ATESSA": "A485",
  "ATINA": "A486",
  "ATRANI": "A487",
  "ATRI": "A488",
  "ATRIPALDA": "A489",
  "ATTIGLIANO": "A490",
  "ATTIMIS": "A491",
  "ATZARA": "A492",
  "AUGUSTA": "A494",
  "AULETTA": "A495",
  "AULLA": "A496",
  "AURANO": "A497",
  "AURIGO": "A499",
  "AURONZO DI CADORE": "A501",
  "AUSONIA": "A502",
  "AUSTIS": "A503",
  "AVEGNO": "A506",
  "AVELENGO": "A507",
  "AVELLA": "A508",
  "AVELLINO": "A509",
  "AVERARA": "A511",
  "AVERSA": "A512",
  "AVETRANA": "A514",
  "AVEZZANO": "A515",
  "AVIANO": "A516",
  "AVIATICO": "A517",
  "AVIGLIANA": "A518",
  "AVIGLIANO": "A519",
  "AVIGLIANO UMBRO": "M258",
  "AVIO": "A520",
  "AVISE": "A521",
  "AVOLA": "A522",
  "AVOLASCA": "A523",
  "AYAS": "A094",
  "AYMAVILLES": "A108",
  "AZEGLIO": "A525",
  "AZZANELLO": "A526",
  "AZZANO DASTI": "A527",
  "AZZANO DECIMO": "A530",
  "AZZANO MELLA": "A529",
  "AZZANO SAN PAOLO": "A528",
  "AZZATE": "A531",
  "AZZIO": "A532",
  "AZZONE": "A533",
  "BACENO": "A534",
  "BACOLI": "A535",
  "BADALUCCO": "A536",
  "BADESI": "M214",
  "BADIA": "A537",
  "BADIA CALAVENA": "A540",
  "BADIA PAVESE": "A538",
  "BADIA POLESINE": "A539",
  "BADIA TEDALDA": "A541",
  "BADOLATO": "A542",
  "BAGALADI": "A544",
  "BAGHERIA": "A546",
  "BAGNACAVALLO": "A547",
  "BAGNARA CALABRA": "A552",
  "BAGNARA DI ROMAGNA": "A551",
  "BAGNARIA": "A550",
  "BAGNARIA ARSA": "A553",
  "BAGNASCO": "A555",
  "BAGNATICA": "A557",
  "BAGNI DI LUCCA": "A560",
  "BAGNO A RIPOLI": "A564",
  "BAGNO DI ROMAGNA": "A565",
  "BAGNOLI DEL TRIGNO": "A567",
  "BAGNOLI DI SOPRA": "A568",
  "BAGNOLI IRPINO": "A566",
  "BAGNOLO CREMASCO": "A570",
  "BAGNOLO DEL SALENTO": "A572",
  "BAGNOLO DI PO": "A574",
  "BAGNOLO IN PIANO": "A573",
  "BAGNOLO MELLA": "A569",
  "BAGNOLO PIEMONTE": "A571",
  "BAGNOLO SAN VITO": "A575",
  "BAGNONE": "A576",
  "BAGNOREGIO": "A577",
  "BAGOLINO": "A578",
  "BAIA E LATINA": "A579",
  "BAIANO": "A580",
  "BAIRO": "A584",
  "BAISO": "A586",
  "BAJARDO": "A581",
  "BALANGERO": "A587",
  "BALDICHIERI DASTI": "A588",
  "BALDISSERO CANAVESE": "A590",
  "BALDISSERO DALBA": "A589",
  "BALDISSERO TORINESE": "A591",
  "BALESTRATE": "A592",
  "BALESTRINO": "A593",
  "BALLABIO": "A594",
  "BALLAO": "A597",
  "BALME": "A599",
  "BALMUCCIA": "A600",
  "BALOCCO": "A601",
  "BALSORANO": "A603",
  "BALVANO": "A604",
  "BALZOLA": "A605",
  "BANARI": "A606",
  "BANCHETTE": "A607",
  "BANNIO ANZINO": "A610",
  "BANZI": "A612",
  "BAONE": "A613",
  "BARADILI": "A614",
  "BARAGIANO": "A615",
  "BARANELLO": "A616",
  "BARANO DISCHIA": "A617",
  "BARANZATE": "A618",
  "BARASSO": "A619",
  "BARATILI SAN PIETRO": "A621",
  "BARBANIA": "A625",
  "BARBARA": "A626",
  "BARBARANO MOSSANO": "M401",
  "BARBARANO ROMANO": "A628",
  "BARBARESCO": "A629",
  "BARBARIGA": "A630",
  "BARBATA": "A631",
  "BARBERINO DI MUGELLO": "A632",
  "BARBERINO TAVARNELLE": "M408",
  "BARBIANELLO": "A634",
  "BARBIANO": "A635",
  "BARBONA": "A637",
  "BARCELLONA POZZO DI GOTTO": "A638",
  "BARCIS": "A640",
  "BARD": "A643",
  "BARDELLO": "A645",
  "BARDI": "A646",
  "BARDINETO": "A647",
  "BARDOLINO": "A650",
  "BARDONECCHIA": "A651",
  "BAREGGIO": "A652",
  "BARENGO": "A653",
  "BARESSA": "A655",
  "BARETE": "A656",
  "BARGA": "A657",
  "BARGAGLI": "A658",
  "BARGE": "A660",
  "BARGHE": "A661",
  "BARI": "A662",
  "BARI SARDO": "A663",
  "BARIANO": "A664",
  "BARICELLA": "A665",
  "BARILE": "A666",
  "BARISCIANO": "A667",
  "BARLASSINA": "A668",
  "BARLETTA": "A669",
  "BARNI": "A670",
  "BAROLO": "A671",
  "BARONE CANAVESE": "A673",
  "BARONISSI": "A674",
  "BARRAFRANCA": "A676",
  "BARRALI": "A677",
  "BARREA": "A678",
  "BARUMINI": "A681",
  "BARZAGO": "A683",
  "BARZANA": "A684",
  "BARZANO": "A686",
  "BARZIO": "A687",
  "BASALUZZO": "A689",
  "BASCAPE": "A690",
  "BASCHI": "A691",
  "BASCIANO": "A692",
  "BASELGA DI PINE": "A694",
  "BASELICE": "A696",
  "BASIANO": "A697",
  "BASICO": "A698",
  "BASIGLIO": "A699",
  "BASILIANO": "A700",
  "BASSANO BRESCIANO": "A702",
  "BASSANO DEL GRAPPA": "A703",
  "BASSANO IN TEVERINA": "A706",
  "BASSANO ROMANO": "A704",
  "BASSIANO": "A707",
  "BASSIGNANA": "A708",
  "BASTIA MONDOVI": "A709",
  "BASTIA UMBRA": "A710",
  "BASTIDA PANCARANA": "A712",
  "BASTIGLIA": "A713",
  "BATTAGLIA TERME": "A714",
  "BATTIFOLLO": "A716",
  "BATTIPAGLIA": "A717",
  "BATTUDA": "A718",
  "BAUCINA": "A719",
  "BAULADU": "A721",
  "BAUNEI": "A722",
  "BAVENO": "A725",
  "BEDERO VALCUVIA": "A728",
  "BEDIZZOLE": "A729",
  "BEDOLLO": "A730",
  "BEDONIA": "A731",
  "BEDULITA": "A732",
  "BEE": "A733",
  "BEINASCO": "A734",
  "BEINETTE": "A735",
  "BELCASTRO": "A736",
  "BELFIORE": "A737",
  "BELFORTE ALLISAURO": "A740",
  "BELFORTE DEL CHIENTI": "A739",
  "BELFORTE MONFERRATO": "A738",
  "BELGIOIOSO": "A741",
  "BELGIRATE": "A742",
  "BELLA": "A743",
  "BELLAGIO": "M335",
  "BELLANO": "A745",
  "BELLANTE": "A746",
  "BELLARIA-IGEA MARINA": "A747",
  "BELLEGRA": "A749",
  "BELLINO": "A750",
  "BELLINZAGO LOMBARDO": "A751",
  "BELLINZAGO NOVARESE": "A752",
  "BELLIZZI": "M294",
  "BELLONA": "A755",
  "BELLOSGUARDO": "A756",
  "BELLUNO": "A757",
  "BELLUSCO": "A759",
  "BELMONTE CALABRO": "A762",
  "BELMONTE CASTELLO": "A763",
  "BELMONTE DEL SANNIO": "A761",
  "BELMONTE IN SABINA": "A765",
  "BELMONTE MEZZAGNO": "A764",
  "BELMONTE PICENO": "A760",
  "BELPASSO": "A766",
  "BELSITO": "A768",
  "BELVEDERE DI SPINELLO": "A772",
  "BELVEDERE LANGHE": "A774",
  "BELVEDERE MARITTIMO": "A773",
  "BELVEDERE OSTRENSE": "A769",
  "BELVEGLIO": "A770",
  "BELVI": "A776",
  "BEMA": "A777",
  "BENE LARIO": "A778",
  "BENE VAGIENNA": "A779",
  "BENESTARE": "A780",
  "BENETUTTI": "A781",
  "BENEVELLO": "A782",
  "BENEVENTO": "A783",
  "BENNA": "A784",
  "BENTIVOGLIO": "A785",
  "BERBENNO": "A786",
  "BERBENNO DI VALTELLINA": "A787",
  "BERCETO": "A788",
  "BERCHIDDA": "A789",
  "BEREGAZZO CON FIGLIARO": "A791",
  "BEREGUARDO": "A792",
  "BERGAMASCO": "A793",
  "BERGAMO": "A794",
  "BERGANTINO": "A795",
  "BERGEGGI": "A796",
  "BERGOLO": "A798",
  "BERLINGO": "A799",
  "BERNALDA": "A801",
  "BERNAREGGIO": "A802",
  "BERNATE TICINO": "A804",
  "BERNEZZO": "A805",
  "BERTINORO": "A809",
  "BERTIOLO": "A810",
  "BERTONICO": "A811",
  "BERZANO DI SAN PIETRO": "A812",
  "BERZANO DI TORTONA": "A813",
  "BERZO DEMO": "A816",
  "BERZO INFERIORE": "A817",
  "BERZO SAN FERMO": "A815",
  "BESANA IN BRIANZA": "A818",
  "BESANO": "A819",
  "BESATE": "A820",
  "BESENELLO": "A821",
  "BESENZONE": "A823",
  "BESNATE": "A825",
  "BESOZZO": "A826",
  "BESSUDE": "A827",
  "BETTOLA": "A831",
  "BETTONA": "A832",
  "BEURA-CARDEZZA": "A834",
  "BEVAGNA": "A835",
  "BEVERINO": "A836",
  "BEVILACQUA": "A837",
  "BIANCAVILLA": "A841",
  "BIANCHI": "A842",
  "BIANCO": "A843",
  "BIANDRATE": "A844",
  "BIANDRONNO": "A845",
  "BIANZANO": "A846",
  "BIANZE": "A847",
  "BIANZONE": "A848",
  "BIASSONO": "A849",
  "BIBBIANO": "A850",
  "BIBBIENA": "A851",
  "BIBBONA": "A852",
  "BIBIANA": "A853",
  "BICCARI": "A854",
  "BICINICCO": "A855",
  "BIDONI": "A856",
  "BIELLA": "A859",
  "BIENNO": "A861",
  "BIENO": "A863",
  "BIENTINA": "A864",
  "BINAGO": "A870",
  "BINASCO": "A872",
  "BINETTO": "A874",
  "BIOGLIO": "A876",
  "BIONAZ": "A877",
  "BIONE": "A878",
  "BIRORI": "A880",
  "BISACCIA": "A881",
  "BISACQUINO": "A882",
  "BISCEGLIE": "A883",
  "BISEGNA": "A884",
  "BISENTI": "A885",
  "BISIGNANO": "A887",
  "BISTAGNO": "A889",
  "BISUSCHIO": "A891",
  "BITETTO": "A892",
  "BITONTO": "A893",
  "BITRITTO": "A894",
  "BITTI": "A895",
  "BIVONA": "A896",
  "BIVONGI": "A897",
  "BIZZARONE": "A898",
  "BLEGGIO SUPERIORE": "A902",
  "BLELLO": "A903",
  "BLERA": "A857",
  "BLESSAGNO": "A904",
  "BLEVIO": "A905",
  "BLUFI": "M268",
  "BOARA PISANI": "A906",
  "BOBBIO": "A909",
  "BOBBIO PELLICE": "A910",
  "BOCA": "A911",
  "BOCCHIGLIERO": "A912",
  "BOCCIOLETO": "A914",
  "BOCENAGO": "A916",
  "BODIO LOMNAGO": "A918",
  "BOFFALORA DADDA": "A919",
  "BOFFALORA SOPRA TICINO": "A920",
  "BOGLIASCO": "A922",
  "BOGNANCO": "A925",
  "BOGOGNO": "A929",
  "BOISSANO": "A931",
  "BOJANO": "A930",
  "BOLANO": "A932",
  "BOLGARE": "A937",
  "BOLLATE": "A940",
  "BOLLENGO": "A941",
  "BOLOGNA": "A944",
  "BOLOGNANO": "A945",
  "BOLOGNETTA": "A946",
  "BOLOGNOLA": "A947",
  "BOLOTANA": "A948",
  "BOLSENA": "A949",
  "BOLTIERE": "A950",
  "BOLZANO": "A952",
  "BOLZANO NOVARESE": "A953",
  "BOLZANO VICENTINO": "A954",
  "BOMARZO": "A955",
  "BOMBA": "A956",
  "BOMPENSIERE": "A957",
  "BOMPIETRO": "A958",
  "BOMPORTO": "A959",
  "BONARCADO": "A960",
  "BONASSOLA": "A961",
  "BONATE SOPRA": "A963",
  "BONATE SOTTO": "A962",
  "BONAVIGO": "A964",
  "BONDENO": "A965",
  "BONDONE": "A968",
  "BONEA": "A970",
  "BONEFRO": "A971",
  "BONEMERSE": "A972",
  "BONIFATI": "A973",
  "BONITO": "A975",
  "BONNANARO": "A976",
  "BONO": "A977",
  "BONORVA": "A978",
  "BONVICINO": "A979",
  "BORBONA": "A981",
  "BORCA DI CADORE": "A982",
  "BORDANO": "A983",
  "BORDIGHERA": "A984",
  "BORDOLANO": "A986",
  "BORE": "A987",
  "BORETTO": "A988",
  "BORGARELLO": "A989",
  "BORGARO TORINESE": "A990",
  "BORGETTO": "A991",
  "BORGHETTO DARROSCIA": "A993",
  "BORGHETTO DI BORBERA": "A998",
  "BORGHETTO DI VARA": "A992",
  "BORGHETTO LODIGIANO": "A995",
  "BORGHETTO SANTO SPIRITO": "A999",
  "BORGHI": "B001",
  "BORGIA": "B002",
  "BORGIALLO": "B003",
  "BORGIO VEREZZI": "B005",
  "BORGO A MOZZANO": "B007",
  "BORGO CHIESE": "M352",
  "BORGO DALE": "B009",
  "BORGO DANAUNIA": "M429",
  "BORGO DI TERZO": "B010",
  "BORGO LARES": "M353",
  "BORGO MANTOVANO": "M396",
  "BORGO PACE": "B026",
  "BORGO PRIOLO": "B028",
  "BORGO SAN DALMAZZO": "B033",
  "BORGO SAN GIACOMO": "B035",
  "BORGO SAN GIOVANNI": "B017",
  "BORGO SAN LORENZO": "B036",
  "BORGO SAN MARTINO": "B037",
  "BORGO SAN SIRO": "B038",
  "BORGO TICINO": "B043",
  "BORGO TOSSIGNANO": "B044",
  "BORGO VAL DI TARO": "B042",
  "BORGO VALBELLUNA": "M421",
  "BORGO VALSUGANA": "B006",
  "BORGO VELINO": "A996",
  "BORGO VENETO": "M402",
  "BORGO VERCELLI": "B046",
  "BORGO VIRGILIO": "M340",
  "BORGOCARBONARA": "M406",
  "BORGOFRANCO DIVREA": "B015",
  "BORGOLAVEZZARO": "B016",
  "BORGOMALE": "B018",
  "BORGOMANERO": "B019",
  "BORGOMARO": "B020",
  "BORGOMASINO": "B021",
  "BORGOMEZZAVALLE": "M370",
  "BORGONE SUSA": "B024",
  "BORGONOVO VAL TIDONE": "B025",
  "BORGORATTO ALESSANDRINO": "B029",
  "BORGORATTO MORMOROLO": "B030",
  "BORGORICCO": "B031",
  "BORGOROSE": "B008",
  "BORGOSATOLLO": "B040",
  "BORGOSESIA": "B041",
  "BORMIDA": "B048",
  "BORMIO": "B049",
  "BORNASCO": "B051",
  "BORNO": "B054",
  "BORONEDDU": "B055",
  "BORORE": "B056",
  "BORRELLO": "B057",
  "BORRIANA": "B058",
  "BORSO DEL GRAPPA": "B061",
  "BORTIGALI": "B062",
  "BORTIGIADAS": "B063",
  "BORUTTA": "B064",
  "BORZONASCA": "B067",
  "BOSA": "B068",
  "BOSARO": "B069",
  "BOSCHI SANTANNA": "B070",
  "BOSCO CHIESANUOVA": "B073",
  "BOSCO MARENGO": "B071",
  "BOSCONERO": "B075",
  "BOSCOREALE": "B076",
  "BOSCOTRECASE": "B077",
  "BOSIA": "B079",
  "BOSIO": "B080",
  "BOSISIO PARINI": "B081",
  "BOSNASCO": "B082",
  "BOSSICO": "B083",
  "BOSSOLASCO": "B084",
  "BOTRICELLO": "B085",
  "BOTRUGNO": "B086",
  "BOTTANUCO": "B088",
  "BOTTICINO": "B091",
  "BOTTIDDA": "B094",
  "BOVA": "B097",
  "BOVA MARINA": "B099",
  "BOVALINO": "B098",
  "BOVEGNO": "B100",
  "BOVES": "B101",
  "BOVEZZO": "B102",
  "BOVILLE ERNICA": "A720",
  "BOVINO": "B104",
  "BOVISIO-MASCIAGO": "B105",
  "BOVOLENTA": "B106",
  "BOVOLONE": "B107",
  "BOZZOLE": "B109",
  "BOZZOLO": "B110",
  "BRA": "B111",
  "BRACCA": "B112",
  "BRACCIANO": "B114",
  "BRACIGLIANO": "B115",
  "BRAIES": "B116",
  "BRALLO DI PREGOLA": "B117",
  "BRANCALEONE": "B118",
  "BRANDICO": "B120",
  "BRANDIZZO": "B121",
  "BRANZI": "B123",
  "BRAONE": "B124",
  "BREBBIA": "B126",
  "BREDA DI PIAVE": "B128",
  "BREGANO": "B131",
  "BREGANZE": "B132",
  "BREGNANO": "B134",
  "BREMBATE": "B137",
  "BREMBATE DI SOPRA": "B138",
  "BREMBIO": "B141",
  "BREME": "B142",
  "BRENDOLA": "B143",
  "BRENNA": "B144",
  "BRENNERO": "B145",
  "BRENO": "B149",
  "BRENTA": "B150",
  "BRENTINO BELLUNO": "B152",
  "BRENTONICO": "B153",
  "BRENZONE SUL GARDA": "B154",
  "BRESCELLO": "B156",
  "BRESCIA": "B157",
  "BRESIMO": "B158",
  "BRESSANA BOTTARONE": "B159",
  "BRESSANONE": "B160",
  "BRESSANVIDO": "B161",
  "BRESSO": "B162",
  "BREZZO DI BEDERO": "B166",
  "BRIAGLIA": "B167",
  "BRIATICO": "B169",
  "BRICHERASIO": "B171",
  "BRIENNO": "B172",
  "BRIENZA": "B173",
  "BRIGA ALTA": "B175",
  "BRIGA NOVARESE": "B176",
  "BRIGNANO GERA DADDA": "B178",
  "BRIGNANO-FRASCATA": "B179",
  "BRINDISI": "B180",
  "BRINDISI MONTAGNA": "B181",
  "BRINZIO": "B182",
  "BRIONA": "B183",
  "BRIONE": "B184",
  "BRIOSCO": "B187",
  "BRISIGHELLA": "B188",
  "BRISSAGO-VALTRAVAGLIA": "B191",
  "BRISSOGNE": "B192",
  "BRITTOLI": "B193",
  "BRIVIO": "B194",
  "BROCCOSTELLA": "B195",
  "BROGLIANO": "B196",
  "BROGNATURO": "B197",
  "BROLO": "B198",
  "BRONDELLO": "B200",
  "BRONI": "B201",
  "BRONTE": "B202",
  "BRONZOLO": "B203",
  "BROSSASCO": "B204",
  "BROSSO": "B205",
  "BROVELLO-CARPUGNINO": "B207",
  "BROZOLO": "B209",
  "BRUGHERIO": "B212",
  "BRUGINE": "B213",
  "BRUGNATO": "B214",
  "BRUGNERA": "B215",
  "BRUINO": "B216",
  "BRUMANO": "B217",
  "BRUNATE": "B218",
  "BRUNELLO": "B219",
  "BRUNICO": "B220",
  "BRUNO": "B221",
  "BRUSAPORTO": "B223",
  "BRUSASCO": "B225",
  "BRUSCIANO": "B227",
  "BRUSIMPIANO": "B228",
  "BRUSNENGO": "B229",
  "BRUSSON": "B230",
  "BRUZOLO": "B232",
  "BRUZZANO ZEFFIRIO": "B234",
  "BUBBIANO": "B235",
  "BUBBIO": "B236",
  "BUCCHERI": "B237",
  "BUCCHIANICO": "B238",
  "BUCCIANO": "B239",
  "BUCCINASCO": "B240",
  "BUCCINO": "B242",
  "BUCINE": "B243",
  "BUDDUSO": "B246",
  "BUDOIA": "B247",
  "BUDONI": "B248",
  "BUDRIO": "B249",
  "BUGGERRU": "B250",
  "BUGGIANO": "B251",
  "BUGLIO IN MONTE": "B255",
  "BUGNARA": "B256",
  "BUGUGGIATE": "B258",
  "BUJA": "B259",
  "BULCIAGO": "B261",
  "BULGAROGRASSO": "B262",
  "BULTEI": "B264",
  "BULZI": "B265",
  "BUONABITACOLO": "B266",
  "BUONALBERGO": "B267",
  "BUONCONVENTO": "B269",
  "BUONVICINO": "B270",
  "BURAGO DI MOLGORA": "B272",
  "BURCEI": "B274",
  "BURGIO": "B275",
  "BURGOS": "B276",
  "BURIASCO": "B278",
  "BUROLO": "B279",
  "BURONZO": "B280",
  "BUSACHI": "B281",
  "BUSALLA": "B282",
  "BUSANO": "B284",
  "BUSCA": "B285",
  "BUSCATE": "B286",
  "BUSCEMI": "B287",
  "BUSETO PALIZZOLO": "B288",
  "BUSNAGO": "B289",
  "BUSSERO": "B292",
  "BUSSETO": "B293",
  "BUSSI SUL TIRINO": "B294",
  "BUSSO": "B295",
  "BUSSOLENGO": "B296",
  "BUSSOLENO": "B297",
  "BUSTO ARSIZIO": "B300",
  "BUSTO GAROLFO": "B301",
  "BUTERA": "B302",
  "BUTI": "B303",
  "BUTTAPIETRA": "B304",
  "BUTTIGLIERA ALTA": "B305",
  "BUTTIGLIERA DASTI": "B306",
  "BUTTRIO": "B309",
  "CABELLA LIGURE": "B311",
  "CABIATE": "B313",
  "CABRAS": "B314",
  "CACCAMO": "B315",
  "CACCURI": "B319",
  "CADEGLIANO-VICONAGO": "B326",
  "CADELBOSCO DI SOPRA": "B328",
  "CADEO": "B332",
  "CADERZONE TERME": "B335",
  "CADONEGHE": "B345",
  "CADORAGO": "B346",
  "CADREZZATE CON OSMATE": "M425",
  "CAERANO DI SAN MARCO": "B349",
  "CAFASSE": "B350",
  "CAGGIANO": "B351",
  "CAGLI": "B352",
  "CAGLIARI": "B354",
  "CAGLIO": "B355",
  "CAGNANO AMITERNO": "B358",
  "CAGNANO VARANO": "B357",
  "CAIANELLO": "B361",
  "CAIAZZO": "B362",
  "CAINES": "B364",
  "CAINO": "B365",
  "CAIOLO": "B366",
  "CAIRANO": "B367",
  "CAIRATE": "B368",
  "CAIRO MONTENOTTE": "B369",
  "CAIVANO": "B371",
  "CALABRITTO": "B374",
  "CALALZO DI CADORE": "B375",
  "CALAMANDRANA": "B376",
  "CALAMONACI": "B377",
  "CALANGIANUS": "B378",
  "CALANNA": "B379",
  "CALASCA-CASTIGLIONE": "B380",
  "CALASCIBETTA": "B381",
  "CALASCIO": "B382",
  "CALASETTA": "B383",
  "CALATABIANO": "B384",
  "CALATAFIMI-SEGESTA": "B385",
  "CALCATA": "B388",
  "CALCERANICA AL LAGO": "B389",
  "CALCI": "B390",
  "CALCIANO": "B391",
  "CALCINAIA": "B392",
  "CALCINATE": "B393",
  "CALCINATO": "B394",
  "CALCIO": "B395",
  "CALCO": "B396",
  "CALDARO SULLA STRADA DEL VINO": "B397",
  "CALDAROLA": "B398",
  "CALDERARA DI RENO": "B399",
  "CALDES": "B400",
  "CALDIERO": "B402",
  "CALDOGNO": "B403",
  "CALDONAZZO": "B404",
  "CALENDASCO": "B405",
  "CALENZANO": "B406",
  "CALESTANO": "B408",
  "CALICE AL CORNOVIGLIO": "B410",
  "CALICE LIGURE": "B409",
  "CALIMERA": "B413",
  "CALITRI": "B415",
  "CALIZZANO": "B416",
  "CALLABIANA": "B417",
  "CALLIANO": "B419",
  "CALOLZIOCORTE": "B423",
  "CALOPEZZATI": "B424",
  "CALOSSO": "B425",
  "CALOVETO": "B426",
  "CALTABELLOTTA": "B427",
  "CALTAGIRONE": "B428",
  "CALTANISSETTA": "B429",
  "CALTAVUTURO": "B430",
  "CALTIGNAGA": "B431",
  "CALTO": "B432",
  "CALTRANO": "B433",
  "CALUSCO DADDA": "B434",
  "CALUSO": "B435",
  "CALVAGESE DELLA RIVIERA": "B436",
  "CALVANICO": "B437",
  "CALVATONE": "B439",
  "CALVELLO": "B440",
  "CALVENE": "B441",
  "CALVENZANO": "B442",
  "CALVERA": "B443",
  "CALVI": "B444",
  "CALVI DELLUMBRIA": "B446",
  "CALVI RISORTA": "B445",
  "CALVIGNANO": "B447",
  "CALVIGNASCO": "B448",
  "CALVISANO": "B450",
  "CALVIZZANO": "B452",
  "CAMAGNA MONFERRATO": "B453",
  "CAMAIORE": "B455",
  "CAMANDONA": "B457",
  "CAMASTRA": "B460",
  "CAMBIAGO": "B461",
  "CAMBIANO": "B462",
  "CAMBIASCA": "B463",
  "CAMBURZANO": "B465",
  "CAMERANA": "B467",
  "CAMERANO": "B468",
  "CAMERANO CASASCO": "B469",
  "CAMERATA CORNELLO": "B471",
  "CAMERATA NUOVA": "B472",
  "CAMERATA PICENA": "B470",
  "CAMERI": "B473",
  "CAMERINO": "B474",
  "CAMEROTA": "B476",
  "CAMIGLIANO": "B477",
  "CAMINI": "B481",
  "CAMINO": "B482",
  "CAMINO AL TAGLIAMENTO": "B483",
  "CAMISANO": "B484",
  "CAMISANO VICENTINO": "B485",
  "CAMMARATA": "B486",
  "CAMOGLI": "B490",
  "CAMPAGNA": "B492",
  "CAMPAGNA LUPIA": "B493",
  "CAMPAGNANO DI ROMA": "B496",
  "CAMPAGNATICO": "B497",
  "CAMPAGNOLA CREMASCA": "B498",
  "CAMPAGNOLA EMILIA": "B499",
  "CAMPANA": "B500",
  "CAMPARADA": "B501",
  "CAMPEGINE": "B502",
  "CAMPELLO SUL CLITUNNO": "B504",
  "CAMPERTOGNO": "B505",
  "CAMPI BISENZIO": "B507",
  "CAMPI SALENTINA": "B506",
  "CAMPIGLIA CERVO": "M373",
  "CAMPIGLIA DEI BERICI": "B511",
  "CAMPIGLIA MARITTIMA": "B509",
  "CAMPIGLIONE FENILE": "B512",
  "CAMPIONE DITALIA": "B513",
  "CAMPITELLO DI FASSA": "B514",
  "CAMPLI": "B515",
  "CAMPO CALABRO": "B516",
  "CAMPO DI GIOVE": "B526",
  "CAMPO DI TRENS": "B529",
  "CAMPO LIGURE": "B538",
  "CAMPO NELLELBA": "B553",
  "CAMPO SAN MARTINO": "B564",
  "CAMPO TURES": "B570",
  "CAMPOBASSO": "B519",
  "CAMPOBELLO DI LICATA": "B520",
  "CAMPOBELLO DI MAZARA": "B521",
  "CAMPOCHIARO": "B522",
  "CAMPODARSEGO": "B524",
  "CAMPODENNO": "B525",
  "CAMPODIMELE": "B527",
  "CAMPODIPIETRA": "B528",
  "CAMPODOLCINO": "B530",
  "CAMPODORO": "B531",
  "CAMPOFELICE DI FITALIA": "B533",
  "CAMPOFELICE DI ROCCELLA": "B532",
  "CAMPOFILONE": "B534",
  "CAMPOFIORITO": "B535",
  "CAMPOFORMIDO": "B536",
  "CAMPOFRANCO": "B537",
  "CAMPOGALLIANO": "B539",
  "CAMPOLATTARO": "B541",
  "CAMPOLI APPENNINO": "B543",
  "CAMPOLI DEL MONTE TABURNO": "B542",
  "CAMPOLIETO": "B544",
  "CAMPOLONGO MAGGIORE": "B546",
  "CAMPOLONGO TAPOGLIANO": "M311",
  "CAMPOMAGGIORE": "B549",
  "CAMPOMARINO": "B550",
  "CAMPOMORONE": "B551",
  "CAMPONOGARA": "B554",
  "CAMPORA": "B555",
  "CAMPOREALE": "B556",
  "CAMPORGIANO": "B557",
  "CAMPOROSSO": "B559",
  "CAMPOROTONDO DI FIASTRONE": "B562",
  "CAMPOROTONDO ETNEO": "B561",
  "CAMPOSAMPIERO": "B563",
  "CAMPOSANO": "B565",
  "CAMPOSANTO": "B566",
  "CAMPOSPINOSO": "B567",
  "CAMPOTOSTO": "B569",
  "CAMUGNANO": "B572",
  "CANAL SAN BOVO": "B577",
  "CANALE": "B573",
  "CANALE DAGORDO": "B574",
  "CANALE MONTERANO": "B576",
  "CANARO": "B578",
  "CANAZEI": "B579",
  "CANCELLARA": "B580",
  "CANCELLO ED ARNONE": "B581",
  "CANDA": "B582",
  "CANDELA": "B584",
  "CANDELO": "B586",
  "CANDIA CANAVESE": "B588",
  "CANDIA LOMELLINA": "B587",
  "CANDIANA": "B589",
  "CANDIDA": "B590",
  "CANDIDONI": "B591",
  "CANDIOLO": "B592",
  "CANEGRATE": "B593",
  "CANELLI": "B594",
  "CANEPINA": "B597",
  "CANEVA": "B598",
  "CANICATTI": "B602",
  "CANICATTINI BAGNI": "B603",
  "CANINO": "B604",
  "CANISCHIO": "B605",
  "CANISTRO": "B606",
  "CANNA": "B607",
  "CANNALONGA": "B608",
  "CANNARA": "B609",
  "CANNERO RIVIERA": "B610",
  "CANNETO PAVESE": "B613",
  "CANNETO SULLOGLIO": "B612",
  "CANNOBIO": "B615",
  "CANNOLE": "B616",
  "CANOLO": "B617",
  "CANONICA DADDA": "B618",
  "CANOSA DI PUGLIA": "B619",
  "CANOSA SANNITA": "B620",
  "CANOSIO": "B621",
  "CANOSSA": "C669",
  "CANSANO": "B624",
  "CANTAGALLO": "B626",
  "CANTALICE": "B627",
  "CANTALUPA": "B628",
  "CANTALUPO IN SABINA": "B631",
  "CANTALUPO LIGURE": "B629",
  "CANTALUPO NEL SANNIO": "B630",
  "CANTARANA": "B633",
  "CANTELLO": "B634",
  "CANTERANO": "B635",
  "CANTIANO": "B636",
  "CANTOIRA": "B637",
  "CANTU": "B639",
  "CANZANO": "B640",
  "CANZO": "B641",
  "CAORLE": "B642",
  "CAORSO": "B643",
  "CAPACCIO PAESTUM": "B644",
  "CAPACI": "B645",
  "CAPALBIO": "B646",
  "CAPANNOLI": "B647",
  "CAPANNORI": "B648",
  "CAPENA": "B649",
  "CAPERGNANICA": "B650",
  "CAPESTRANO": "B651",
  "CAPIAGO INTIMIANO": "B653",
  "CAPISTRANO": "B655",
  "CAPISTRELLO": "B656",
  "CAPITIGNANO": "B658",
  "CAPIZZI": "B660",
  "CAPIZZONE": "B661",
  "CAPO DI PONTE": "B664",
  "CAPO DORLANDO": "B666",
  "CAPODIMONTE": "B663",
  "CAPODRISE": "B667",
  "CAPOLIVERI": "B669",
  "CAPOLONA": "B670",
  "CAPONAGO": "B671",
  "CAPORCIANO": "B672",
  "CAPOSELE": "B674",
  "CAPOTERRA": "B675",
  "CAPOVALLE": "B676",
  "CAPPADOCIA": "B677",
  "CAPPELLA CANTONE": "B679",
  "CAPPELLA DE PICENARDI": "B680",
  "CAPPELLA MAGGIORE": "B678",
  "CAPPELLE SUL TAVO": "B681",
  "CAPRACOTTA": "B682",
  "CAPRAIA E LIMITE": "B684",
  "CAPRAIA ISOLA": "B685",
  "CAPRALBA": "B686",
  "CAPRANICA": "B688",
  "CAPRANICA PRENESTINA": "B687",
  "CAPRARICA DI LECCE": "B690",
  "CAPRAROLA": "B691",
  "CAPRAUNA": "B692",
  "CAPRESE MICHELANGELO": "B693",
  "CAPREZZO": "B694",
  "CAPRI": "B696",
  "CAPRI LEONE": "B695",
  "CAPRIANA": "B697",
  "CAPRIANO DEL COLLE": "B698",
  "CAPRIATA DORBA": "B701",
  "CAPRIATE SAN GERVASIO": "B703",
  "CAPRIATI A VOLTURNO": "B704",
  "CAPRIE": "B705",
  "CAPRIGLIA IRPINA": "B706",
  "CAPRIGLIO": "B707",
  "CAPRILE": "B708",
  "CAPRINO BERGAMASCO": "B710",
  "CAPRINO VERONESE": "B709",
  "CAPRIOLO": "B711",
  "CAPRIVA DEL FRIULI": "B712",
  "CAPUA": "B715",
  "CAPURSO": "B716",
  "CARAFFA DEL BIANCO": "B718",
  "CARAFFA DI CATANZARO": "B717",
  "CARAGLIO": "B719",
  "CARAMAGNA PIEMONTE": "B720",
  "CARAMANICO TERME": "B722",
  "CARAPELLE": "B724",
  "CARAPELLE CALVISIO": "B725",
  "CARASCO": "B726",
  "CARASSAI": "B727",
  "CARATE BRIANZA": "B729",
  "CARATE URIO": "B730",
  "CARAVAGGIO": "B731",
  "CARAVATE": "B732",
  "CARAVINO": "B733",
  "CARAVONICA": "B734",
  "CARBOGNANO": "B735",
  "CARBONARA AL TICINO": "B741",
  "CARBONARA DI NOLA": "B740",
  "CARBONARA SCRIVIA": "B736",
  "CARBONATE": "B742",
  "CARBONE": "B743",
  "CARBONERA": "B744",
  "CARBONIA": "B745",
  "CARCARE": "B748",
  "CARCERI": "B749",
  "CARCOFORO": "B752",
  "CARDANO AL CAMPO": "B754",
  "CARDE": "B755",
  "CARDEDU": "M285",
  "CARDETO": "B756",
  "CARDINALE": "B758",
  "CARDITO": "B759",
  "CAREGGINE": "B760",
  "CAREMA": "B762",
  "CARENNO": "B763",
  "CARENTINO": "B765",
  "CARERI": "B766",
  "CARESANA": "B767",
  "CARESANABLOT": "B768",
  "CAREZZANO": "B769",
  "CARFIZZI": "B771",
  "CARGEGHE": "B772",
  "CARIATI": "B774",
  "CARIFE": "B776",
  "CARIGNANO": "B777",
  "CARIMATE": "B778",
  "CARINARO": "B779",
  "CARINI": "B780",
  "CARINOLA": "B781",
  "CARISIO": "B782",
  "CARISOLO": "B783",
  "CARLANTINO": "B784",
  "CARLAZZO": "B785",
  "CARLENTINI": "B787",
  "CARLINO": "B788",
  "CARLOFORTE": "B789",
  "CARLOPOLI": "B790",
  "CARMAGNOLA": "B791",
  "CARMIANO": "B792",
  "CARMIGNANO": "B794",
  "CARMIGNANO DI BRENTA": "B795",
  "CARNAGO": "B796",
  "CARNATE": "B798",
  "CAROBBIO DEGLI ANGELI": "B801",
  "CAROLEI": "B802",
  "CARONA": "B803",
  "CARONIA": "B804",
  "CARONNO PERTUSELLA": "B805",
  "CARONNO VARESINO": "B807",
  "CAROSINO": "B808",
  "CAROVIGNO": "B809",
  "CAROVILLI": "B810",
  "CARPANETO PIACENTINO": "B812",
  "CARPANZANO": "B813",
  "CARPEGNA": "B816",
  "CARPENEDOLO": "B817",
  "CARPENETO": "B818",
  "CARPI": "B819",
  "CARPIANO": "B820",
  "CARPIGNANO SALENTINO": "B822",
  "CARPIGNANO SESIA": "B823",
  "CARPINETI": "B825",
  "CARPINETO DELLA NORA": "B827",
  "CARPINETO ROMANO": "B828",
  "CARPINETO SINELLO": "B826",
  "CARPINO": "B829",
  "CARPINONE": "B830",
  "CARRARA": "B832",
  "CARRE": "B835",
  "CARREGA LIGURE": "B836",
  "CARRO": "B838",
  "CARRODANO": "B839",
  "CARROSIO": "B840",
  "CARRU": "B841",
  "CARSOLI": "B842",
  "CARTIGLIANO": "B844",
  "CARTIGNANO": "B845",
  "CARTOCETO": "B846",
  "CARTOSIO": "B847",
  "CARTURA": "B848",
  "CARUGATE": "B850",
  "CARUGO": "B851",
  "CARUNCHIO": "B853",
  "CARVICO": "B854",
  "CARZANO": "B856",
  "CASABONA": "B857",
  "CASACALENDA": "B858",
  "CASACANDITELLA": "B859",
  "CASAGIOVE": "B860",
  "CASAL CERMELLI": "B870",
  "CASAL DI PRINCIPE": "B872",
  "CASAL VELINO": "B895",
  "CASALANGUIDA": "B861",
  "CASALATTICO": "B862",
  "CASALBELTRAME": "B864",
  "CASALBORDINO": "B865",
  "CASALBORE": "B866",
  "CASALBORGONE": "B867",
  "CASALBUONO": "B868",
  "CASALBUTTANO ED UNITI": "B869",
  "CASALCIPRANO": "B871",
  "CASALDUNI": "B873",
  "CASALE CORTE CERRO": "B876",
  "CASALE CREMASCO-VIDOLASCO": "B881",
  "CASALE DI SCODOSIA": "B877",
  "CASALE LITTA": "B875",
  "CASALE MARITTIMO": "B878",
  "CASALE MONFERRATO": "B885",
  "CASALE SUL SILE": "B879",
  "CASALECCHIO DI RENO": "B880",
  "CASALEGGIO BOIRO": "B882",
  "CASALEGGIO NOVARA": "B883",
  "CASALEONE": "B886",
  "CASALETTO CEREDANO": "B889",
  "CASALETTO DI SOPRA": "B890",
  "CASALETTO LODIGIANO": "B887",
  "CASALETTO SPARTANO": "B888",
  "CASALETTO VAPRIO": "B891",
  "CASALFIUMANESE": "B892",
  "CASALGRANDE": "B893",
  "CASALGRASSO": "B894",
  "CASALI DEL MANCO": "M385",
  "CASALINCONTRADA": "B896",
  "CASALINO": "B897",
  "CASALMAGGIORE": "B898",
  "CASALMAIOCCO": "B899",
  "CASALMORANO": "B900",
  "CASALMORO": "B901",
  "CASALNOCETO": "B902",
  "CASALNUOVO DI NAPOLI": "B905",
  "CASALNUOVO MONTEROTARO": "B904",
  "CASALOLDO": "B907",
  "CASALPUSTERLENGO": "B910",
  "CASALROMANO": "B911",
  "CASALSERUGO": "B912",
  "CASALUCE": "B916",
  "CASALVECCHIO DI PUGLIA": "B917",
  "CASALVECCHIO SICULO": "B918",
  "CASALVIERI": "B919",
  "CASALVOLONE": "B920",
  "CASALZUIGNO": "B921",
  "CASAMARCIANO": "B922",
  "CASAMASSIMA": "B923",
  "CASAMICCIOLA TERME": "B924",
  "CASANDRINO": "B925",
  "CASANOVA ELVO": "B928",
  "CASANOVA LERRONE": "B927",
  "CASANOVA LONATI": "B929",
  "CASAPE": "B932",
  "CASAPESENNA": "M260",
  "CASAPINTA": "B933",
  "CASAPROTA": "B934",
  "CASAPULLA": "B935",
  "CASARANO": "B936",
  "CASARGO": "B937",
  "CASARILE": "B938",
  "CASARSA DELLA DELIZIA": "B940",
  "CASARZA LIGURE": "B939",
  "CASASCO": "B941",
  "CASATENOVO": "B943",
  "CASATISMA": "B945",
  "CASAVATORE": "B946",
  "CASAZZA": "B947",
  "CASCIA": "B948",
  "CASCIAGO": "B949",
  "CASCIANA TERME LARI": "M327",
  "CASCINA": "B950",
  "CASCINETTE DIVREA": "B953",
  "CASEI GEROLA": "B954",
  "CASELETTE": "B955",
  "CASELLA": "B956",
  "CASELLE IN PITTARI": "B959",
  "CASELLE LANDI": "B961",
  "CASELLE LURANI": "B958",
  "CASELLE TORINESE": "B960",
  "CASERTA": "B963",
  "CASIER": "B965",
  "CASIGNANA": "B966",
  "CASINA": "B967",
  "CASIRATE DADDA": "B971",
  "CASLINO DERBA": "B974",
  "CASNATE CON BERNATE": "B977",
  "CASNIGO": "B978",
  "CASOLA DI NAPOLI": "B980",
  "CASOLA IN LUNIGIANA": "B979",
  "CASOLA VALSENIO": "B982",
  "CASOLE DELSA": "B984",
  "CASOLI": "B985",
  "CASORATE PRIMO": "B988",
  "CASORATE SEMPIONE": "B987",
  "CASOREZZO": "B989",
  "CASORIA": "B990",
  "CASORZO": "B991",
  "CASPERIA": "A472",
  "CASPOGGIO": "B993",
  "CASSACCO": "B994",
  "CASSAGO BRIANZA": "B996",
  "CASSANO ALLIONIO": "C002",
  "CASSANO DADDA": "C003",
  "CASSANO DELLE MURGE": "B998",
  "CASSANO IRPINO": "B997",
  "CASSANO MAGNAGO": "C004",
  "CASSANO SPINOLA": "M388",
  "CASSANO VALCUVIA": "B999",
  "CASSARO": "C006",
  "CASSIGLIO": "C007",
  "CASSINA DE PECCHI": "C014",
  "CASSINA RIZZARDI": "C020",
  "CASSINA VALSASSINA": "C024",
  "CASSINASCO": "C022",
  "CASSINE": "C027",
  "CASSINELLE": "C030",
  "CASSINETTA DI LUGAGNANO": "C033",
  "CASSINO": "C034",
  "CASSOLA": "C037",
  "CASSOLNOVO": "C038",
  "CASTAGNARO": "C041",
  "CASTAGNETO CARDUCCI": "C044",
  "CASTAGNETO PO": "C045",
  "CASTAGNITO": "C046",
  "CASTAGNOLE DELLE LANZE": "C049",
  "CASTAGNOLE MONFERRATO": "C047",
  "CASTAGNOLE PIEMONTE": "C048",
  "CASTANA": "C050",
  "CASTANO PRIMO": "C052",
  "CASTEGGIO": "C053",
  "CASTEGNATO": "C055",
  "CASTEGNERO": "C056",
  "CASTEL BARONIA": "C058",
  "CASTEL BOGLIONE": "C064",
  "CASTEL BOLOGNESE": "C065",
  "CASTEL CAMPAGNANO": "B494",
  "CASTEL CASTAGNA": "C040",
  "CASTEL CONDINO": "C183",
  "CASTEL DAIANO": "C075",
  "CASTEL DARIO": "C076",
  "CASTEL DAZZANO": "C078",
  "CASTEL DEL GIUDICE": "C082",
  "CASTEL DEL MONTE": "C083",
  "CASTEL DEL PIANO": "C085",
  "CASTEL DEL RIO": "C086",
  "CASTEL DI CASIO": "B969",
  "CASTEL DI IERI": "C090",
  "CASTEL DI IUDICA": "C091",
  "CASTEL DI LAMA": "C093",
  "CASTEL DI LUCIO": "C094",
  "CASTEL DI SANGRO": "C096",
  "CASTEL DI SASSO": "C097",
  "CASTEL DI TORA": "C098",
  "CASTEL FOCOGNANO": "C102",
  "CASTEL FRENTANO": "C114",
  "CASTEL GABBIANO": "C115",
  "CASTEL GANDOLFO": "C116",
  "CASTEL GIORGIO": "C117",
  "CASTEL GOFFREDO": "C118",
  "CASTEL GUELFO DI BOLOGNA": "C121",
  "CASTEL IVANO": "M354",
  "CASTEL MADAMA": "C203",
  "CASTEL MAGGIORE": "C204",
  "CASTEL MELLA": "C208",
  "CASTEL MORRONE": "C211",
  "CASTEL RITALDI": "C252",
  "CASTEL ROCCHERO": "C253",
  "CASTEL ROZZONE": "C255",
  "CASTEL SAN GIORGIO": "C259",
  "CASTEL SAN GIOVANNI": "C261",
  "CASTEL SAN LORENZO": "C262",
  "CASTEL SAN NICCOLO": "C263",
  "CASTEL SAN PIETRO ROMANO": "C266",
  "CASTEL SAN PIETRO TERME": "C265",
  "CASTEL SAN VINCENZO": "C270",
  "CASTEL SANTANGELO": "C268",
  "CASTEL SANTELIA": "C269",
  "CASTEL VISCARDO": "C289",
  "CASTEL VITTORIO": "C110",
  "CASTEL VOLTURNO": "C291",
  "CASTELBALDO": "C057",
  "CASTELBELFORTE": "C059",
  "CASTELBELLINO": "C060",
  "CASTELBELLO-CIARDES": "C062",
  "CASTELBIANCO": "C063",
  "CASTELBOTTACCIO": "C066",
  "CASTELBUONO": "C067",
  "CASTELCIVITA": "C069",
  "CASTELCOVATI": "C072",
  "CASTELCUCCO": "C073",
  "CASTELDACCIA": "C074",
  "CASTELDELCI": "C080",
  "CASTELDELFINO": "C081",
  "CASTELDIDONE": "C089",
  "CASTELFIDARDO": "C100",
  "CASTELFIORENTINO": "C101",
  "CASTELFORTE": "C104",
  "CASTELFRANCI": "C105",
  "CASTELFRANCO DI SOTTO": "C113",
  "CASTELFRANCO EMILIA": "C107",
  "CASTELFRANCO IN MISCANO": "C106",
  "CASTELFRANCO PIANDISCO": "M322",
  "CASTELFRANCO VENETO": "C111",
  "CASTELGERUNDO": "M393",
  "CASTELGOMBERTO": "C119",
  "CASTELGRANDE": "C120",
  "CASTELGUGLIELMO": "C122",
  "CASTELGUIDONE": "C123",
  "CASTELLABATE": "C125",
  "CASTELLAFIUME": "C126",
  "CASTELLALFERO": "C127",
  "CASTELLALTO": "C128",
  "CASTELLAMMARE DEL GOLFO": "C130",
  "CASTELLAMMARE DI STABIA": "C129",
  "CASTELLAMONTE": "C133",
  "CASTELLANA GROTTE": "C134",
  "CASTELLANA SICULA": "C135",
  "CASTELLANETA": "C136",
  "CASTELLANIA COPPI": "C137",
  "CASTELLANZA": "C139",
  "CASTELLAR GUIDOBONO": "C142",
  "CASTELLARANO": "C141",
  "CASTELLARO": "C143",
  "CASTELLARQUATO": "C145",
  "CASTELLAZZARA": "C147",
  "CASTELLAZZO BORMIDA": "C148",
  "CASTELLAZZO NOVARESE": "C149",
  "CASTELLEONE": "C153",
  "CASTELLEONE DI SUASA": "C152",
  "CASTELLERO": "C154",
  "CASTELLETTO CERVO": "C155",
  "CASTELLETTO DERRO": "C156",
  "CASTELLETTO DI BRANDUZZO": "C157",
  "CASTELLETTO DORBA": "C158",
  "CASTELLETTO MERLI": "C160",
  "CASTELLETTO MOLINA": "C161",
  "CASTELLETTO MONFERRATO": "C162",
  "CASTELLETTO SOPRA TICINO": "C166",
  "CASTELLETTO STURA": "C165",
  "CASTELLETTO UZZONE": "C167",
  "CASTELLI": "C169",
  "CASTELLI CALEPIO": "C079",
  "CASTELLINA IN CHIANTI": "C172",
  "CASTELLINA MARITTIMA": "C174",
  "CASTELLINALDO DALBA": "C173",
  "CASTELLINO DEL BIFERNO": "C175",
  "CASTELLINO TANARO": "C176",
  "CASTELLIRI": "C177",
  "CASTELLO CABIAGLIO": "B312",
  "CASTELLO DAGOGNA": "C184",
  "CASTELLO DARGILE": "C185",
  "CASTELLO DEL MATESE": "C178",
  "CASTELLO DELLACQUA": "C186",
  "CASTELLO DI ANNONE": "A300",
  "CASTELLO DI BRIANZA": "C187",
  "CASTELLO DI CISTERNA": "C188",
  "CASTELLO DI GODEGO": "C190",
  "CASTELLO TESINO": "C194",
  "CASTELLO-MOLINA DI FIEMME": "C189",
  "CASTELLUCCHIO": "C195",
  "CASTELLUCCIO DEI SAURI": "C198",
  "CASTELLUCCIO INFERIORE": "C199",
  "CASTELLUCCIO SUPERIORE": "C201",
  "CASTELLUCCIO VALMAGGIORE": "C202",
  "CASTELLUMBERTO": "C051",
  "CASTELMAGNO": "C205",
  "CASTELMARTE": "C206",
  "CASTELMASSA": "C207",
  "CASTELMAURO": "C197",
  "CASTELMEZZANO": "C209",
  "CASTELMOLA": "C210",
  "CASTELNOVETTO": "C213",
  "CASTELNOVO BARIANO": "C215",
  "CASTELNOVO DEL FRIULI": "C217",
  "CASTELNOVO DI SOTTO": "C218",
  "CASTELNOVO NE MONTI": "C219",
  "CASTELNUOVO": "C216",
  "CASTELNUOVO BELBO": "C226",
  "CASTELNUOVO BERARDENGA": "C227",
  "CASTELNUOVO BOCCA DADDA": "C228",
  "CASTELNUOVO BORMIDA": "C229",
  "CASTELNUOVO BOZZENTE": "C220",
  "CASTELNUOVO CALCEA": "C230",
  "CASTELNUOVO CILENTO": "C231",
  "CASTELNUOVO DEL GARDA": "C225",
  "CASTELNUOVO DELLA DAUNIA": "C222",
  "CASTELNUOVO DI CEVA": "C214",
  "CASTELNUOVO DI CONZA": "C235",
  "CASTELNUOVO DI FARFA": "C224",
  "CASTELNUOVO DI GARFAGNANA": "C236",
  "CASTELNUOVO DI PORTO": "C237",
  "CASTELNUOVO DI VAL DI CECINA": "C244",
  "CASTELNUOVO DON BOSCO": "C232",
  "CASTELNUOVO MAGRA": "C240",
  "CASTELNUOVO NIGRA": "C241",
  "CASTELNUOVO PARANO": "C223",
  "CASTELNUOVO RANGONE": "C242",
  "CASTELNUOVO SCRIVIA": "C243",
  "CASTELPAGANO": "C245",
  "CASTELPETROSO": "C246",
  "CASTELPIZZUTO": "C247",
  "CASTELPLANIO": "C248",
  "CASTELPOTO": "C250",
  "CASTELRAIMONDO": "C251",
  "CASTELROTTO": "C254",
  "CASTELSANTANGELO SUL NERA": "C267",
  "CASTELSARACENO": "C271",
  "CASTELSARDO": "C272",
  "CASTELSEPRIO": "C273",
  "CASTELSILANO": "B968",
  "CASTELSPINA": "C274",
  "CASTELTERMINI": "C275",
  "CASTELVECCANA": "C181",
  "CASTELVECCHIO CALVISIO": "C278",
  "CASTELVECCHIO DI ROCCA BARBENA": "C276",
  "CASTELVECCHIO SUBEQUO": "C279",
  "CASTELVENERE": "C280",
  "CASTELVERDE": "B129",
  "CASTELVERRINO": "C200",
  "CASTELVETERE IN VAL FORTORE": "C284",
  "CASTELVETERE SUL CALORE": "C283",
  "CASTELVETRANO": "C286",
  "CASTELVETRO DI MODENA": "C287",
  "CASTELVETRO PIACENTINO": "C288",
  "CASTELVISCONTI": "C290",
  "CASTENASO": "C292",
  "CASTENEDOLO": "C293",
  "CASTIADAS": "M288",
  "CASTIGLION FIBOCCHI": "C318",
  "CASTIGLION FIORENTINO": "C319",
  "CASTIGLIONE A CASAURIA": "C308",
  "CASTIGLIONE CHIAVARESE": "C302",
  "CASTIGLIONE COSENTINO": "C301",
  "CASTIGLIONE DADDA": "C304",
  "CASTIGLIONE DEI PEPOLI": "C296",
  "CASTIGLIONE DEL GENOVESI": "C306",
  "CASTIGLIONE DEL LAGO": "C309",
  "CASTIGLIONE DELLA PESCAIA": "C310",
  "CASTIGLIONE DELLE STIVIERE": "C312",
  "CASTIGLIONE DI GARFAGNANA": "C303",
  "CASTIGLIONE DI SICILIA": "C297",
  "CASTIGLIONE DORCIA": "C313",
  "CASTIGLIONE FALLETTO": "C314",
  "CASTIGLIONE IN TEVERINA": "C315",
  "CASTIGLIONE MESSER MARINO": "C298",
  "CASTIGLIONE MESSER RAIMONDO": "C316",
  "CASTIGLIONE OLONA": "C300",
  "CASTIGLIONE TINELLA": "C317",
  "CASTIGLIONE TORINESE": "C307",
  "CASTIGNANO": "C321",
  "CASTILENTI": "C322",
  "CASTINO": "C323",
  "CASTIONE ANDEVENNO": "C325",
  "CASTIONE DELLA PRESOLANA": "C324",
  "CASTIONS DI STRADA": "C327",
  "CASTIRAGA VIDARDO": "C329",
  "CASTO": "C330",
  "CASTORANO": "C331",
  "CASTREZZATO": "C332",
  "CASTRI DI LECCE": "C334",
  "CASTRIGNANO DE GRECI": "C335",
  "CASTRIGNANO DEL CAPO": "C336",
  "CASTRO": "M261",
  "CASTRO DEI VOLSCI": "C338",
  "CASTROCARO TERME E TERRA DEL SOLE": "C339",
  "CASTROCIELO": "C340",
  "CASTROFILIPPO": "C341",
  "CASTROLIBERO": "C108",
  "CASTRONNO": "C343",
  "CASTRONOVO DI SICILIA": "C344",
  "CASTRONUOVO DI SANTANDREA": "C345",
  "CASTROPIGNANO": "C346",
  "CASTROREALE": "C347",
  "CASTROREGIO": "C348",
  "CASTROVILLARI": "C349",
  "CATANIA": "C351",
  "CATANZARO": "C352",
  "CATENANUOVA": "C353",
  "CATIGNANO": "C354",
  "CATTOLICA": "C357",
  "CATTOLICA ERACLEA": "C356",
  "CAULONIA": "C285",
  "CAUTANO": "C359",
  "CAVA DE TIRRENI": "C361",
  "CAVA MANARA": "C360",
  "CAVAGLIA": "C363",
  "CAVAGLIETTO": "C364",
  "CAVAGLIO DAGOGNA": "C365",
  "CAVAGNOLO": "C369",
  "CAVAION VERONESE": "C370",
  "CAVALESE": "C372",
  "CAVALLERLEONE": "C375",
  "CAVALLERMAGGIORE": "C376",
  "CAVALLINO": "C377",
  "CAVALLINO-TREPORTI": "M308",
  "CAVALLIRIO": "C378",
  "CAVARENO": "C380",
  "CAVARGNA": "C381",
  "CAVARIA CON PREMEZZO": "C382",
  "CAVARZERE": "C383",
  "CAVASO DEL TOMBA": "C384",
  "CAVASSO NUOVO": "C385",
  "CAVATORE": "C387",
  "CAVAZZO CARNICO": "C389",
  "CAVE": "C390",
  "CAVEDAGO": "C392",
  "CAVEDINE": "C393",
  "CAVENAGO DADDA": "C394",
  "CAVENAGO DI BRIANZA": "C395",
  "CAVERNAGO": "C396",
  "CAVEZZO": "C398",
  "CAVIZZANA": "C400",
  "CAVOUR": "C404",
  "CAVRIAGO": "C405",
  "CAVRIANA": "C406",
  "CAVRIGLIA": "C407",
  "CAZZAGO BRABBIA": "C409",
  "CAZZAGO SAN MARTINO": "C408",
  "CAZZANO DI TRAMIGNA": "C412",
  "CAZZANO SANTANDREA": "C410",
  "CECCANO": "C413",
  "CECIMA": "C414",
  "CECINA": "C415",
  "CEDEGOLO": "C417",
  "CEDRASCO": "C418",
  "CEFALA DIANA": "C420",
  "CEFALU": "C421",
  "CEGGIA": "C422",
  "CEGLIE MESSAPICA": "C424",
  "CELANO": "C426",
  "CELENZA SUL TRIGNO": "C428",
  "CELENZA VALFORTORE": "C429",
  "CELICO": "C430",
  "CELLA DATI": "C435",
  "CELLA MONTE": "C432",
  "CELLAMARE": "C436",
  "CELLARA": "C437",
  "CELLARENGO": "C438",
  "CELLATICA": "C439",
  "CELLE DI BULGHERIA": "C444",
  "CELLE DI MACRA": "C441",
  "CELLE DI SAN VITO": "C442",
  "CELLE ENOMONDO": "C440",
  "CELLE LIGURE": "C443",
  "CELLENO": "C446",
  "CELLERE": "C447",
  "CELLINO ATTANASIO": "C449",
  "CELLINO SAN MARCO": "C448",
  "CELLIO CON BREIA": "M398",
  "CELLOLE": "M262",
  "CEMBRA LISIGNAGO": "M355",
  "CENADI": "C453",
  "CENATE SOPRA": "C456",
  "CENATE SOTTO": "C457",
  "CENCENIGHE AGORDINO": "C458",
  "CENE": "C459",
  "CENESELLI": "C461",
  "CENGIO": "C463",
  "CENTALLO": "C466",
  "CENTO": "C469",
  "CENTOLA": "C470",
  "CENTRACHE": "C472",
  "CENTRO VALLE INTELVI": "M394",
  "CENTURIPE": "C471",
  "CEPAGATTI": "C474",
  "CEPPALONI": "C476",
  "CEPPO MORELLI": "C478",
  "CEPRANO": "C479",
  "CERAMI": "C480",
  "CERANESI": "C481",
  "CERANO": "C483",
  "CERANO DINTELVI": "C482",
  "CERANOVA": "C484",
  "CERASO": "C485",
  "CERCEMAGGIORE": "C486",
  "CERCENASCO": "C487",
  "CERCEPICCOLA": "C488",
  "CERCHIARA DI CALABRIA": "C489",
  "CERCHIO": "C492",
  "CERCINO": "C493",
  "CERCIVENTO": "C494",
  "CERCOLA": "C495",
  "CERDA": "C496",
  "CEREA": "C498",
  "CEREGNANO": "C500",
  "CERENZIA": "C501",
  "CERES": "C497",
  "CERESARA": "C502",
  "CERESETO": "C503",
  "CERESOLE ALBA": "C504",
  "CERESOLE REALE": "C505",
  "CERETE": "C506",
  "CERETTO LOMELLINA": "C508",
  "CERGNAGO": "C509",
  "CERIALE": "C510",
  "CERIANA": "C511",
  "CERIANO LAGHETTO": "C512",
  "CERIGNALE": "C513",
  "CERIGNOLA": "C514",
  "CERISANO": "C515",
  "CERMENATE": "C516",
  "CERMES": "A022",
  "CERMIGNANO": "C517",
  "CERNOBBIO": "C520",
  "CERNUSCO LOMBARDONE": "C521",
  "CERNUSCO SUL NAVIGLIO": "C523",
  "CERRETO DASTI": "C528",
  "CERRETO DESI": "C524",
  "CERRETO DI SPOLETO": "C527",
  "CERRETO GRUE": "C507",
  "CERRETO GUIDI": "C529",
  "CERRETO LAZIALE": "C518",
  "CERRETO SANNITA": "C525",
  "CERRETTO LANGHE": "C530",
  "CERRINA MONFERRATO": "C531",
  "CERRIONE": "C532",
  "CERRO AL LAMBRO": "C536",
  "CERRO AL VOLTURNO": "C534",
  "CERRO MAGGIORE": "C537",
  "CERRO TANARO": "C533",
  "CERRO VERONESE": "C538",
  "CERSOSIMO": "C539",
  "CERTALDO": "C540",
  "CERTOSA DI PAVIA": "C541",
  "CERVA": "C542",
  "CERVARA DI ROMA": "C543",
  "CERVARESE SANTA CROCE": "C544",
  "CERVARO": "C545",
  "CERVASCA": "C547",
  "CERVATTO": "C548",
  "CERVENO": "C549",
  "CERVERE": "C550",
  "CERVESINA": "C551",
  "CERVETERI": "C552",
  "CERVIA": "C553",
  "CERVICATI": "C554",
  "CERVIGNANO DADDA": "C555",
  "CERVIGNANO DEL FRIULI": "C556",
  "CERVINARA": "C557",
  "CERVINO": "C558",
  "CERVO": "C559",
  "CERZETO": "C560",
  "CESA": "C561",
  "CESANA BRIANZA": "C563",
  "CESANA TORINESE": "C564",
  "CESANO BOSCONE": "C565",
  "CESANO MADERNO": "C566",
  "CESARA": "C567",
  "CESARO": "C568",
  "CESATE": "C569",
  "CESENA": "C573",
  "CESENATICO": "C574",
  "CESINALI": "C576",
  "CESIO": "C578",
  "CESIOMAGGIORE": "C577",
  "CESSALTO": "C580",
  "CESSANITI": "C581",
  "CESSAPALOMBO": "C582",
  "CESSOLE": "C583",
  "CETARA": "C584",
  "CETO": "C585",
  "CETONA": "C587",
  "CETRARO": "C588",
  "CEVA": "C589",
  "CEVO": "C591",
  "CHALLAND-SAINT-ANSELME": "C593",
  "CHALLAND-SAINT-VICTOR": "C594",
  "CHAMBAVE": "C595",
  "CHAMOIS": "B491",
  "CHAMPDEPRAZ": "C596",
  "CHAMPORCHER": "B540",
  "CHARVENSOD": "C598",
  "CHATILLON": "C294",
  "CHERASCO": "C599",
  "CHEREMULE": "C600",
  "CHIALAMBERTO": "C604",
  "CHIAMPO": "C605",
  "CHIANCHE": "C606",
  "CHIANCIANO TERME": "C608",
  "CHIANNI": "C609",
  "CHIANOCCO": "C610",
  "CHIARAMONTE GULFI": "C612",
  "CHIARAMONTI": "C613",
  "CHIARANO": "C614",
  "CHIARAVALLE": "C615",
  "CHIARAVALLE CENTRALE": "C616",
  "CHIARI": "C618",
  "CHIAROMONTE": "C619",
  "CHIAUCI": "C620",
  "CHIAVARI": "C621",
  "CHIAVENNA": "C623",
  "CHIAVERANO": "C624",
  "CHIENES": "C625",
  "CHIERI": "C627",
  "CHIES DALPAGO": "C630",
  "CHIESA IN VALMALENCO": "C628",
  "CHIESANUOVA": "C629",
  "CHIESINA UZZANESE": "C631",
  "CHIETI": "C632",
  "CHIEUTI": "C633",
  "CHIEVE": "C634",
  "CHIGNOLO DISOLA": "C635",
  "CHIGNOLO PO": "C637",
  "CHIOGGIA": "C638",
  "CHIOMONTE": "C639",
  "CHIONS": "C640",
  "CHIOPRIS-VISCONE": "C641",
  "CHITIGNANO": "C648",
  "CHIUDUNO": "C649",
  "CHIUPPANO": "C650",
  "CHIURO": "C651",
  "CHIUSA": "C652",
  "CHIUSA DI PESIO": "C653",
  "CHIUSA DI SAN MICHELE": "C655",
  "CHIUSA SCLAFANI": "C654",
  "CHIUSAFORTE": "C656",
  "CHIUSANICO": "C657",
  "CHIUSANO DASTI": "C658",
  "CHIUSANO DI SAN DOMENICO": "C659",
  "CHIUSAVECCHIA": "C660",
  "CHIUSDINO": "C661",
  "CHIUSI": "C662",
  "CHIUSI DELLA VERNA": "C663",
  "CHIVASSO": "C665",
  "CIAMPINO": "M272",
  "CIANCIANA": "C668",
  "CIBIANA DI CADORE": "C672",
  "CICAGNA": "C673",
  "CICALA": "C674",
  "CICCIANO": "C675",
  "CICERALE": "C676",
  "CICILIANO": "C677",
  "CICOGNOLO": "C678",
  "CICONIO": "C679",
  "CIGLIANO": "C680",
  "CIGLIE": "C681",
  "CIGOGNOLA": "C684",
  "CIGOLE": "C685",
  "CILAVEGNA": "C686",
  "CIMADOLMO": "C689",
  "CIMBERGO": "C691",
  "CIMINA": "C695",
  "CIMINNA": "C696",
  "CIMITILE": "C697",
  "CIMOLAIS": "C699",
  "CIMONE": "C700",
  "CINAGLIO": "C701",
  "CINETO ROMANO": "C702",
  "CINGIA DE BOTTI": "C703",
  "CINGOLI": "C704",
  "CINIGIANO": "C705",
  "CINISELLO BALSAMO": "C707",
  "CINISI": "C708",
  "CINO": "C709",
  "CINQUEFRONDI": "C710",
  "CINTANO": "C711",
  "CINTE TESINO": "C712",
  "CINTO CAOMAGGIORE": "C714",
  "CINTO EUGANEO": "C713",
  "CINZANO": "C715",
  "CIORLANO": "C716",
  "CIPRESSA": "C718",
  "CIRCELLO": "C719",
  "CIRIE": "C722",
  "CIRIGLIANO": "C723",
  "CIRIMIDO": "C724",
  "CIRO": "C725",
  "CIRO MARINA": "C726",
  "CIS": "C727",
  "CISANO BERGAMASCO": "C728",
  "CISANO SUL NEVA": "C729",
  "CISERANO": "C730",
  "CISLAGO": "C732",
  "CISLIANO": "C733",
  "CISON DI VALMARINO": "C735",
  "CISSONE": "C738",
  "CISTERNA DASTI": "C739",
  "CISTERNA DI LATINA": "C740",
  "CISTERNINO": "C741",
  "CITERNA": "C742",
  "CITTA DELLA PIEVE": "C744",
  "CITTA DI CASTELLO": "C745",
  "CITTA SANTANGELO": "C750",
  "CITTADELLA": "C743",
  "CITTADUCALE": "C746",
  "CITTANOVA": "C747",
  "CITTAREALE": "C749",
  "CITTIGLIO": "C751",
  "CIVATE": "C752",
  "CIVEZZA": "C755",
  "CIVEZZANO": "C756",
  "CIVIASCO": "C757",
  "CIVIDALE DEL FRIULI": "C758",
  "CIVIDATE AL PIANO": "C759",
  "CIVIDATE CAMUNO": "C760",
  "CIVITA": "C763",
  "CIVITA CASTELLANA": "C765",
  "CIVITA DANTINO": "C766",
  "CIVITACAMPOMARANO": "C764",
  "CIVITALUPARELLA": "C768",
  "CIVITANOVA DEL SANNIO": "C769",
  "CIVITANOVA MARCHE": "C770",
  "CIVITAQUANA": "C771",
  "CIVITAVECCHIA": "C773",
  "CIVITELLA ALFEDENA": "C778",
  "CIVITELLA CASANOVA": "C779",
  "CIVITELLA DAGLIANO": "C780",
  "CIVITELLA DEL TRONTO": "C781",
  "CIVITELLA DI ROMAGNA": "C777",
  "CIVITELLA IN VAL DI CHIANA": "C774",
  "CIVITELLA MESSER RAIMONDO": "C776",
  "CIVITELLA PAGANICO": "C782",
  "CIVITELLA ROVETO": "C783",
  "CIVITELLA SAN PAOLO": "C784",
  "CIVO": "C785",
  "CLAINO CON OSTENO": "C787",
  "CLAUT": "C790",
  "CLAUZETTO": "C791",
  "CLAVESANA": "C792",
  "CLAVIERE": "C793",
  "CLES": "C794",
  "CLETO": "C795",
  "CLIVIO": "C796",
  "CLUSONE": "C800",
  "COASSOLO TORINESE": "C801",
  "COAZZE": "C803",
  "COAZZOLO": "C804",
  "COCCAGLIO": "C806",
  "COCCONATO": "C807",
  "COCQUIO-TREVISAGO": "C810",
  "COCULLO": "C811",
  "CODEVIGO": "C812",
  "CODEVILLA": "C813",
  "CODIGORO": "C814",
  "CODOGNE": "C815",
  "CODOGNO": "C816",
  "CODROIPO": "C817",
  "CODRONGIANOS": "C818",
  "COGGIOLA": "C819",
  "COGLIATE": "C820",
  "COGNE": "C821",
  "COGOLETO": "C823",
  "COGOLLO DEL CENGIO": "C824",
  "COGORNO": "C826",
  "COLAZZA": "C829",
  "COLCERESA": "M426",
  "COLERE": "C835",
  "COLFELICE": "C836",
  "COLI": "C838",
  "COLICO": "C839",
  "COLLALTO SABINO": "C841",
  "COLLARMELE": "C844",
  "COLLAZZONE": "C845",
  "COLLE BRIANZA": "C851",
  "COLLE DANCHISE": "C854",
  "COLLE DI TORA": "C857",
  "COLLE DI VAL DELSA": "C847",
  "COLLE SAN MAGNO": "C870",
  "COLLE SANNITA": "C846",
  "COLLE SANTA LUCIA": "C872",
  "COLLE UMBERTO": "C848",
  "COLLEBEATO": "C850",
  "COLLECCHIO": "C852",
  "COLLECORVINO": "C853",
  "COLLEDARA": "C311",
  "COLLEDIMACINE": "C855",
  "COLLEDIMEZZO": "C856",
  "COLLEFERRO": "C858",
  "COLLEGIOVE": "C859",
  "COLLEGNO": "C860",
  "COLLELONGO": "C862",
  "COLLEPARDO": "C864",
  "COLLEPASSO": "C865",
  "COLLEPIETRO": "C866",
  "COLLERETTO CASTELNUOVO": "C867",
  "COLLERETTO GIACOSA": "C868",
  "COLLESALVETTI": "C869",
  "COLLESANO": "C871",
  "COLLETORTO": "C875",
  "COLLEVECCHIO": "C876",
  "COLLI A VOLTURNO": "C878",
  "COLLI AL METAURO": "M380",
  "COLLI DEL TRONTO": "C877",
  "COLLI SUL VELINO": "C880",
  "COLLI VERDI": "M419",
  "COLLIANO": "C879",
  "COLLINAS": "C882",
  "COLLIO": "C883",
  "COLLOBIANO": "C884",
  "COLLOREDO DI MONTE ALBANO": "C885",
  "COLMURANO": "C886",
  "COLOBRARO": "C888",
  "COLOGNA VENETA": "C890",
  "COLOGNE": "C893",
  "COLOGNO AL SERIO": "C894",
  "COLOGNO MONZESE": "C895",
  "COLOGNOLA AI COLLI": "C897",
  "COLONNA": "C900",
  "COLONNELLA": "C901",
  "COLONNO": "C902",
  "COLORINA": "C903",
  "COLORNO": "C904",
  "COLOSIMI": "C905",
  "COLTURANO": "C908",
  "COLVERDE": "M336",
  "COLZATE": "C910",
  "COMABBIO": "C911",
  "COMACCHIO": "C912",
  "COMANO": "C914",
  "COMANO TERME": "M314",
  "COMAZZO": "C917",
  "COMEGLIANS": "C918",
  "COMELICO SUPERIORE": "C920",
  "COMERIO": "C922",
  "COMEZZANO-CIZZAGO": "C925",
  "COMIGNAGO": "C926",
  "COMISO": "C927",
  "COMITINI": "C928",
  "COMIZIANO": "C929",
  "COMMESSAGGIO": "C930",
  "COMMEZZADURA": "C931",
  "COMO": "C933",
  "COMPIANO": "C934",
  "COMUN NUOVO": "C937",
  "COMUNANZA": "C935",
  "CONA": "C938",
  "CONCA CASALE": "C941",
  "CONCA DEI MARINI": "C940",
  "CONCA DELLA CAMPANIA": "C939",
  "CONCAMARISE": "C943",
  "CONCERVIANO": "C946",
  "CONCESIO": "C948",
  "CONCORDIA SAGITTARIA": "C950",
  "CONCORDIA SULLA SECCHIA": "C951",
  "CONCOREZZO": "C952",
  "CONDOFURI": "C954",
  "CONDOVE": "C955",
  "CONDRO": "C956",
  "CONEGLIANO": "C957",
  "CONFIENZA": "C958",
  "CONFIGNI": "C959",
  "CONFLENTI": "C960",
  "CONIOLO": "C962",
  "CONSELICE": "C963",
  "CONSELVE": "C964",
  "CONTA": "M356",
  "CONTESSA ENTELLINA": "C968",
  "CONTIGLIANO": "C969",
  "CONTRADA": "C971",
  "CONTROGUERRA": "C972",
  "CONTRONE": "C973",
  "CONTURSI TERME": "C974",
  "CONVERSANO": "C975",
  "CONZA DELLA CAMPANIA": "C976",
  "CONZANO": "C977",
  "COPERTINO": "C978",
  "COPIANO": "C979",
  "COPPARO": "C980",
  "CORANA": "C982",
  "CORATO": "C983",
  "CORBARA": "C984",
  "CORBETTA": "C986",
  "CORBOLA": "C987",
  "CORCHIANO": "C988",
  "CORCIANO": "C990",
  "CORDENONS": "C991",
  "CORDIGNANO": "C992",
  "CORDOVADO": "C993",
  "COREGLIA ANTELMINELLI": "C996",
  "COREGLIA LIGURE": "C995",
  "CORENO AUSONIO": "C998",
  "CORFINIO": "C999",
  "CORI": "D003",
  "CORIANO": "D004",
  "CORIGLIANO DOTRANTO": "D006",
  "CORIGLIANO-ROSSANO": "M403",
  "CORINALDO": "D007",
  "CORIO": "D008",
  "CORLEONE": "D009",
  "CORLETO MONFORTE": "D011",
  "CORLETO PERTICARA": "D010",
  "CORMANO": "D013",
  "CORMONS": "D014",
  "CORNA IMAGNA": "D015",
  "CORNALBA": "D016",
  "CORNALE E BASTIDA": "M338",
  "CORNAREDO": "D018",
  "CORNATE DADDA": "D019",
  "CORNEDO ALLISARCO": "B799",
  "CORNEDO VICENTINO": "D020",
  "CORNEGLIANO LAUDENSE": "D021",
  "CORNELIANO DALBA": "D022",
  "CORNIGLIO": "D026",
  "CORNO DI ROSAZZO": "D027",
  "CORNO GIOVINE": "D028",
  "CORNOVECCHIO": "D029",
  "CORNUDA": "D030",
  "CORREGGIO": "D037",
  "CORREZZANA": "D038",
  "CORREZZOLA": "D040",
  "CORRIDO": "D041",
  "CORRIDONIA": "D042",
  "CORROPOLI": "D043",
  "CORSANO": "D044",
  "CORSICO": "D045",
  "CORSIONE": "D046",
  "CORTACCIA SULLA STRADA DEL VINO": "D048",
  "CORTALE": "D049",
  "CORTANDONE": "D050",
  "CORTANZE": "D051",
  "CORTAZZONE": "D052",
  "CORTE BRUGNATELLA": "D054",
  "CORTE DE CORTESI CON CIGNONE": "D056",
  "CORTE DE FRATI": "D057",
  "CORTE FRANCA": "D058",
  "CORTE PALASIO": "D068",
  "CORTEMAGGIORE": "D061",
  "CORTEMILIA": "D062",
  "CORTENO GOLGI": "D064",
  "CORTENOVA": "D065",
  "CORTENUOVA": "D066",
  "CORTEOLONA E GENZONE": "M372",
  "CORTIGLIONE": "D072",
  "CORTINA DAMPEZZO": "A266",
  "CORTINA SULLA STRADA DEL VINO": "D075",
  "CORTINO": "D076",
  "CORTONA": "D077",
  "CORVARA": "D078",
  "CORVARA IN BADIA": "D079",
  "CORVINO SAN QUIRICO": "D081",
  "CORZANO": "D082",
  "COSEANO": "D085",
  "COSENZA": "D086",
  "COSIO DARROSCIA": "D087",
  "COSIO VALTELLINO": "D088",
  "COSOLETO": "D089",
  "COSSANO BELBO": "D093",
  "COSSANO CANAVESE": "D092",
  "COSSATO": "D094",
  "COSSERIA": "D095",
  "COSSIGNANO": "D096",
  "COSSOGNO": "D099",
  "COSSOINE": "D100",
  "COSSOMBRATO": "D101",
  "COSTA DE NOBILI": "D109",
  "COSTA DI MEZZATE": "D110",
  "COSTA DI ROVIGO": "D105",
  "COSTA MASNAGA": "D112",
  "COSTA SERINA": "D111",
  "COSTA VALLE IMAGNA": "D103",
  "COSTA VESCOVATO": "D102",
  "COSTA VOLPINO": "D117",
  "COSTABISSARA": "D107",
  "COSTACCIARO": "D108",
  "COSTANZANA": "D113",
  "COSTARAINERA": "D114",
  "COSTERMANO SUL GARDA": "D118",
  "COSTIGLIOLE DASTI": "D119",
  "COSTIGLIOLE SALUZZO": "D120",
  "COTIGNOLA": "D121",
  "COTRONEI": "D123",
  "COTTANELLO": "D124",
  "COURMAYEUR": "D012",
  "COVO": "D126",
  "COZZO": "D127",
  "CRACO": "D128",
  "CRANDOLA VALSASSINA": "D131",
  "CRAVAGLIANA": "D132",
  "CRAVANZANA": "D133",
  "CRAVEGGIA": "D134",
  "CREAZZO": "D136",
  "CRECCHIO": "D137",
  "CREDARO": "D139",
  "CREDERA RUBBIANO": "D141",
  "CREMA": "D142",
  "CREMELLA": "D143",
  "CREMENAGA": "D144",
  "CREMENO": "D145",
  "CREMIA": "D147",
  "CREMOLINO": "D149",
  "CREMONA": "D150",
  "CREMOSANO": "D151",
  "CRESCENTINO": "D154",
  "CRESPADORO": "D156",
  "CRESPIATICA": "D159",
  "CRESPINA LORENZANA": "M328",
  "CRESPINO": "D161",
  "CRESSA": "D162",
  "CREVACUORE": "D165",
  "CREVALCORE": "D166",
  "CREVOLADOSSOLA": "D168",
  "CRISPANO": "D170",
  "CRISPIANO": "D171",
  "CRISSOLO": "D172",
  "CROCEFIESCHI": "D175",
  "CROCETTA DEL MONTELLO": "C670",
  "CRODO": "D177",
  "CROGNALETO": "D179",
  "CROPALATI": "D180",
  "CROPANI": "D181",
  "CROSIA": "D184",
  "CROSIO DELLA VALLE": "D185",
  "CROTONE": "D122",
  "CROTTA DADDA": "D186",
  "CROVA": "D187",
  "CROVIANA": "D188",
  "CRUCOLI": "D189",
  "CUASSO AL MONTE": "D192",
  "CUCCARO VETERE": "D195",
  "CUCCIAGO": "D196",
  "CUCEGLIO": "D197",
  "CUGGIONO": "D198",
  "CUGLIATE-FABIASCO": "D199",
  "CUGLIERI": "D200",
  "CUGNOLI": "D201",
  "CUMIANA": "D202",
  "CUMIGNANO SUL NAVIGLIO": "D203",
  "CUNARDO": "D204",
  "CUNEO": "D205",
  "CUNICO": "D207",
  "CUORGNE": "D208",
  "CUPELLO": "D209",
  "CUPRA MARITTIMA": "D210",
  "CUPRAMONTANA": "D211",
  "CURA CARPIGNANO": "B824",
  "CURCURIS": "D214",
  "CUREGGIO": "D216",
  "CURIGLIA CON MONTEVIASCO": "D217",
  "CURINGA": "D218",
  "CURINO": "D219",
  "CURNO": "D221",
  "CURON VENOSTA": "D222",
  "CURSI": "D223",
  "CURTAROLO": "D226",
  "CURTATONE": "D227",
  "CURTI": "D228",
  "CUSAGO": "D229",
  "CUSANO MILANINO": "D231",
  "CUSANO MUTRI": "D230",
  "CUSINO": "D232",
  "CUSIO": "D233",
  "CUSTONACI": "D234",
  "CUTRO": "D236",
  "CUTROFIANO": "D237",
  "CUVEGLIO": "D238",
  "CUVIO": "D239",
  "DAIRAGO": "D244",
  "DALMINE": "D245",
  "DAMBEL": "D246",
  "DANTA DI CADORE": "D247",
  "DARFO BOARIO TERME": "D251",
  "DASA": "D253",
  "DAVAGNA": "D255",
  "DAVERIO": "D256",
  "DAVOLI": "D257",
  "DAZIO": "D258",
  "DECIMOMANNU": "D259",
  "DECIMOPUTZU": "D260",
  "DECOLLATURA": "D261",
  "DEGO": "D264",
  "DEIVA MARINA": "D265",
  "DELEBIO": "D266",
  "DELIA": "D267",
  "DELIANUOVA": "D268",
  "DELICETO": "D269",
  "DELLO": "D270",
  "DEMONTE": "D271",
  "DENICE": "D272",
  "DENNO": "D273",
  "DERNICE": "D277",
  "DEROVERE": "D278",
  "DERUTA": "D279",
  "DERVIO": "D280",
  "DESANA": "D281",
  "DESENZANO DEL GARDA": "D284",
  "DESIO": "D286",
  "DESULO": "D287",
  "DIAMANTE": "D289",
  "DIANO ARENTINO": "D293",
  "DIANO CASTELLO": "D296",
  "DIANO DALBA": "D291",
  "DIANO MARINA": "D297",
  "DIANO SAN PIETRO": "D298",
  "DICOMANO": "D299",
  "DIGNANO": "D300",
  "DIMARO FOLGARIDA": "M366",
  "DINAMI": "D303",
  "DIPIGNANO": "D304",
  "DISO": "D305",
  "DIVIGNANO": "D309",
  "DIZZASCO": "D310",
  "DOBBIACO": "D311",
  "DOBERDO DEL LAGO": "D312",
  "DOGLIANI": "D314",
  "DOGLIOLA": "D315",
  "DOGNA": "D316",
  "DOLCE": "D317",
  "DOLCEACQUA": "D318",
  "DOLCEDO": "D319",
  "DOLEGNA DEL COLLIO": "D321",
  "DOLIANOVA": "D323",
  "DOLO": "D325",
  "DOLZAGO": "D327",
  "DOMANICO": "D328",
  "DOMASO": "D329",
  "DOMEGGE DI CADORE": "D330",
  "DOMICELLA": "D331",
  "DOMODOSSOLA": "D332",
  "DOMUS DE MARIA": "D333",
  "DOMUSNOVAS": "D334",
  "DONATO": "D339",
  "DONGO": "D341",
  "DONNAS": "D338",
  "DONORI": "D344",
  "DORGALI": "D345",
  "DORIO": "D346",
  "DORMELLETTO": "D347",
  "DORNO": "D348",
  "DORZANO": "D350",
  "DOSOLO": "D351",
  "DOSSENA": "D352",
  "DOSSO DEL LIRO": "D355",
  "DOUES": "D356",
  "DOVADOLA": "D357",
  "DOVERA": "D358",
  "DOZZA": "D360",
  "DRAGONI": "D361",
  "DRAPIA": "D364",
  "DRENA": "D365",
  "DRENCHIA": "D366",
  "DRESANO": "D367",
  "DRO": "D371",
  "DRONERO": "D372",
  "DRUENTO": "D373",
  "DRUOGNO": "D374",
  "DUALCHI": "D376",
  "DUBINO": "D377",
  "DUE CARRARE": "M300",
  "DUEVILLE": "D379",
  "DUGENTA": "D380",
  "DUINO AURISINA": "D383",
  "DUMENZA": "D384",
  "DUNO": "D385",
  "DURAZZANO": "D386",
  "DURONIA": "C772",
  "DUSINO SAN MICHELE": "D388",
  "EBOLI": "D390",
  "EDOLO": "D391",
  "EGNA": "D392",
  "ELICE": "D394",
  "ELINI": "D395",
  "ELLO": "D398",
  "ELMAS": "D399",
  "ELVA": "D401",
  "EMARESE": "D402",
  "EMPOLI": "D403",
  "ENDINE GAIANO": "D406",
  "ENEGO": "D407",
  "ENEMONZO": "D408",
  "ENNA": "C342",
  "ENTRACQUE": "D410",
  "ENTRATICO": "D411",
  "ENVIE": "D412",
  "EPISCOPIA": "D414",
  "ERACLEA": "D415",
  "ERBA": "D416",
  "ERBE": "D419",
  "ERBEZZO": "D420",
  "ERBUSCO": "D421",
  "ERCHIE": "D422",
  "ERCOLANO": "H243",
  "ERICE": "D423",
  "ERLI": "D424",
  "ERTO E CASSO": "D426",
  "ERULA": "M292",
  "ERVE": "D428",
  "ESANATOGLIA": "D429",
  "ESCALAPLANO": "D430",
  "ESCOLCA": "D431",
  "ESINE": "D434",
  "ESINO LARIO": "D436",
  "ESPERIA": "D440",
  "ESPORLATU": "D441",
  "ESTE": "D442",
  "ESTERZILI": "D443",
  "ETROUBLES": "D444",
  "EUPILIO": "D445",
  "EXILLES": "D433",
  "FABBRICA CURONE": "D447",
  "FABBRICHE DI VERGEMOLI": "M319",
  "FABBRICO": "D450",
  "FABRIANO": "D451",
  "FABRICA DI ROMA": "D452",
  "FABRIZIA": "D453",
  "FABRO": "D454",
  "FAEDIS": "D455",
  "FAEDO VALTELLINO": "D456",
  "FAENZA": "D458",
  "FAETO": "D459",
  "FAGAGNA": "D461",
  "FAGGETO LARIO": "D462",
  "FAGGIANO": "D463",
  "FAGNANO ALTO": "D465",
  "FAGNANO CASTELLO": "D464",
  "FAGNANO OLONA": "D467",
  "FAI DELLA PAGANELLA": "D468",
  "FAICCHIO": "D469",
  "FALCADE": "D470",
  "FALCIANO DEL MASSICO": "D471",
  "FALCONARA ALBANESE": "D473",
  "FALCONARA MARITTIMA": "D472",
  "FALCONE": "D474",
  "FALERIA": "D475",
  "FALERNA": "D476",
  "FALERONE": "D477",
  "FALLO": "D480",
  "FALOPPIO": "D482",
  "FALVATERRA": "D483",
  "FALZES": "D484",
  "FANANO": "D486",
  "FANNA": "D487",
  "FANO": "D488",
  "FANO ADRIANO": "D489",
  "FARA FILIORUM PETRI": "D494",
  "FARA GERA DADDA": "D490",
  "FARA IN SABINA": "D493",
  "FARA NOVARESE": "D492",
  "FARA OLIVANA CON SOLA": "D491",
  "FARA SAN MARTINO": "D495",
  "FARA VICENTINO": "D496",
  "FARDELLA": "D497",
  "FARIGLIANO": "D499",
  "FARINDOLA": "D501",
  "FARINI": "D502",
  "FARNESE": "D503",
  "FARRA DI SOLIGO": "D505",
  "FARRA DISONZO": "D504",
  "FASANO": "D508",
  "FASCIA": "D509",
  "FAUGLIA": "D510",
  "FAULE": "D511",
  "FAVALE DI MALVARO": "D512",
  "FAVARA": "D514",
  "FAVIGNANA": "D518",
  "FAVRIA": "D520",
  "FEISOGLIO": "D523",
  "FELETTO": "D524",
  "FELINO": "D526",
  "FELITTO": "D527",
  "FELIZZANO": "D528",
  "FELTRE": "D530",
  "FENEGRO": "D531",
  "FENESTRELLE": "D532",
  "FENIS": "D537",
  "FERENTILLO": "D538",
  "FERENTINO": "D539",
  "FERLA": "D540",
  "FERMIGNANO": "D541",
  "FERMO": "D542",
  "FERNO": "D543",
  "FEROLETO ANTICO": "D544",
  "FEROLETO DELLA CHIESA": "D545",
  "FERRANDINA": "D547",
  "FERRARA": "D548",
  "FERRARA DI MONTE BALDO": "D549",
  "FERRAZZANO": "D550",
  "FERRERA DI VARESE": "D551",
  "FERRERA ERBOGNONE": "D552",
  "FERRERE": "D554",
  "FERRIERE": "D555",
  "FERRUZZANO": "D557",
  "FIAMIGNANO": "D560",
  "FIANO": "D562",
  "FIANO ROMANO": "D561",
  "FIASTRA": "D564",
  "FIAVE": "D565",
  "FICARAZZI": "D567",
  "FICAROLO": "D568",
  "FICARRA": "D569",
  "FICULLE": "D570",
  "FIDENZA": "B034",
  "FIE ALLO SCILIAR": "D571",
  "FIEROZZO": "D573",
  "FIESCO": "D574",
  "FIESOLE": "D575",
  "FIESSE": "D576",
  "FIESSO DARTICO": "D578",
  "FIESSO UMBERTIANO": "D577",
  "FIGINO SERENZA": "D579",
  "FIGLINE E INCISA VALDARNO": "M321",
  "FIGLINE VEGLIATURO": "D582",
  "FILACCIANO": "D586",
  "FILADELFIA": "D587",
  "FILAGO": "D588",
  "FILANDARI": "D589",
  "FILATTIERA": "D590",
  "FILETTINO": "D591",
  "FILETTO": "D592",
  "FILIANO": "D593",
  "FILIGHERA": "D594",
  "FILIGNANO": "D595",
  "FILOGASO": "D596",
  "FILOTTRANO": "D597",
  "FINALE EMILIA": "D599",
  "FINALE LIGURE": "D600",
  "FINO DEL MONTE": "D604",
  "FINO MORNASCO": "D605",
  "FIORANO AL SERIO": "D606",
  "FIORANO CANAVESE": "D608",
  "FIORANO MODENESE": "D607",
  "FIORENZUOLA DARDA": "D611",
  "FIRENZE": "D612",
  "FIRENZUOLA": "D613",
  "FIRMO": "D614",
  "FISCAGLIA": "M323",
  "FISCIANO": "D615",
  "FIUGGI": "A310",
  "FIUMALBO": "D617",
  "FIUMARA": "D619",
  "FIUME VENETO": "D621",
  "FIUMEDINISI": "D622",
  "FIUMEFREDDO BRUZIO": "D624",
  "FIUMEFREDDO DI SICILIA": "D623",
  "FIUMICELLO VILLA VICENTINA": "M400",
  "FIUMICINO": "M297",
  "FIUMINATA": "D628",
  "FIVIZZANO": "D629",
  "FLAIBANO": "D630",
  "FLERO": "D634",
  "FLORESTA": "D635",
  "FLORIDIA": "D636",
  "FLORINAS": "D637",
  "FLUMERI": "D638",
  "FLUMINIMAGGIORE": "D639",
  "FLUSSIO": "D640",
  "FOBELLO": "D641",
  "FOGGIA": "D643",
  "FOGLIANISE": "D644",
  "FOGLIANO REDIPUGLIA": "D645",
  "FOGLIZZO": "D646",
  "FOIANO DELLA CHIANA": "D649",
  "FOIANO DI VAL FORTORE": "D650",
  "FOLGARIA": "D651",
  "FOLIGNANO": "D652",
  "FOLIGNO": "D653",
  "FOLLINA": "D654",
  "FOLLO": "D655",
  "FOLLONICA": "D656",
  "FOMBIO": "D660",
  "FONDACHELLI-FANTINA": "D661",
  "FONDI": "D662",
  "FONNI": "D665",
  "FONTAINEMORE": "D666",
  "FONTANA LIRI": "D667",
  "FONTANAFREDDA": "D670",
  "FONTANAROSA": "D671",
  "FONTANELICE": "D668",
  "FONTANELLA": "D672",
  "FONTANELLATO": "D673",
  "FONTANELLE": "D674",
  "FONTANETO DAGOGNA": "D675",
  "FONTANETTO PO": "D676",
  "FONTANIGORDA": "D677",
  "FONTANILE": "D678",
  "FONTANIVA": "D679",
  "FONTE": "D680",
  "FONTE NUOVA": "M309",
  "FONTECCHIO": "D681",
  "FONTECHIARI": "D682",
  "FONTEGRECA": "D683",
  "FONTENO": "D684",
  "FONTEVIVO": "D685",
  "FONZASO": "D686",
  "FOPPOLO": "D688",
  "FORANO": "D689",
  "FORCE": "D691",
  "FORCHIA": "D693",
  "FORCOLA": "D694",
  "FORDONGIANUS": "D695",
  "FORENZA": "D696",
  "FORESTO SPARSO": "D697",
  "FORGARIA NEL FRIULI": "D700",
  "FORINO": "D701",
  "FORIO": "D702",
  "FORLI": "D704",
  "FORLI DEL SANNIO": "D703",
  "FORLIMPOPOLI": "D705",
  "FORMAZZA": "D706",
  "FORMELLO": "D707",
  "FORMIA": "D708",
  "FORMICOLA": "D709",
  "FORMIGARA": "D710",
  "FORMIGINE": "D711",
  "FORMIGLIANA": "D712",
  "FORNACE": "D714",
  "FORNELLI": "D715",
  "FORNI AVOLTRI": "D718",
  "FORNI DI SOPRA": "D719",
  "FORNI DI SOTTO": "D720",
  "FORNO CANAVESE": "D725",
  "FORNOVO DI TARO": "D728",
  "FORNOVO SAN GIOVANNI": "D727",
  "FORTE DEI MARMI": "D730",
  "FORTEZZA": "D731",
  "FORTUNAGO": "D732",
  "FORZA DAGRO": "D733",
  "FOSCIANDORA": "D734",
  "FOSDINOVO": "D735",
  "FOSSA": "D736",
  "FOSSACESIA": "D738",
  "FOSSALTA DI PIAVE": "D740",
  "FOSSALTA DI PORTOGRUARO": "D741",
  "FOSSALTO": "D737",
  "FOSSANO": "D742",
  "FOSSATO DI VICO": "D745",
  "FOSSATO SERRALTA": "D744",
  "FOSSO": "D748",
  "FOSSOMBRONE": "D749",
  "FOZA": "D750",
  "FRABOSA SOPRANA": "D751",
  "FRABOSA SOTTANA": "D752",
  "FRACONALTO": "D559",
  "FRAGAGNANO": "D754",
  "FRAGNETO LABATE": "D755",
  "FRAGNETO MONFORTE": "D756",
  "FRAINE": "D757",
  "FRAMURA": "D758",
  "FRANCAVILLA AL MARE": "D763",
  "FRANCAVILLA ANGITOLA": "D762",
  "FRANCAVILLA BISIO": "D759",
  "FRANCAVILLA DETE": "D760",
  "FRANCAVILLA DI SICILIA": "D765",
  "FRANCAVILLA FONTANA": "D761",
  "FRANCAVILLA IN SINNI": "D766",
  "FRANCAVILLA MARITTIMA": "D764",
  "FRANCICA": "D767",
  "FRANCOFONTE": "D768",
  "FRANCOLISE": "D769",
  "FRASCARO": "D770",
  "FRASCAROLO": "D771",
  "FRASCATI": "D773",
  "FRASCINETO": "D774",
  "FRASSILONGO": "D775",
  "FRASSINELLE POLESINE": "D776",
  "FRASSINELLO MONFERRATO": "D777",
  "FRASSINETO PO": "D780",
  "FRASSINETTO": "D781",
  "FRASSINO": "D782",
  "FRASSINORO": "D783",
  "FRASSO SABINO": "D785",
  "FRASSO TELESINO": "D784",
  "FRATTA POLESINE": "D788",
  "FRATTA TODINA": "D787",
  "FRATTAMAGGIORE": "D789",
  "FRATTAMINORE": "D790",
  "FRATTE ROSA": "D791",
  "FRAZZANO": "D793",
  "FREGONA": "D794",
  "FRESAGRANDINARIA": "D796",
  "FRESONARA": "D797",
  "FRIGENTO": "D798",
  "FRIGNANO": "D799",
  "FRINCO": "D802",
  "FRISA": "D803",
  "FRISANCO": "D804",
  "FRONT": "D805",
  "FRONTINO": "D807",
  "FRONTONE": "D808",
  "FROSINONE": "D810",
  "FROSOLONE": "D811",
  "FROSSASCO": "D812",
  "FRUGAROLO": "D813",
  "FUBINE MONFERRATO": "D814",
  "FUCECCHIO": "D815",
  "FUIPIANO VALLE IMAGNA": "D817",
  "FUMANE": "D818",
  "FUMONE": "D819",
  "FUNES": "D821",
  "FURCI": "D823",
  "FURCI SICULO": "D824",
  "FURNARI": "D825",
  "FURORE": "D826",
  "FURTEI": "D827",
  "FUSCALDO": "D828",
  "FUSIGNANO": "D829",
  "FUSINE": "D830",
  "FUTANI": "D832",
  "GABBIONETA-BINANUOVA": "D834",
  "GABIANO": "D835",
  "GABICCE MARE": "D836",
  "GABY": "D839",
  "GADESCO-PIEVE DELMONA": "D841",
  "GADONI": "D842",
  "GAETA": "D843",
  "GAGGI": "D844",
  "GAGGIANO": "D845",
  "GAGGIO MONTANO": "D847",
  "GAGLIANICO": "D848",
  "GAGLIANO ATERNO": "D850",
  "GAGLIANO CASTELFERRATO": "D849",
  "GAGLIANO DEL CAPO": "D851",
  "GAGLIATO": "D852",
  "GAGLIOLE": "D853",
  "GAIARINE": "D854",
  "GAIBA": "D855",
  "GAIOLA": "D856",
  "GAIOLE IN CHIANTI": "D858",
  "GAIRO": "D859",
  "GAIS": "D860",
  "GALATI MAMERTINO": "D861",
  "GALATINA": "D862",
  "GALATONE": "D863",
  "GALATRO": "D864",
  "GALBIATE": "D865",
  "GALEATA": "D867",
  "GALGAGNANO": "D868",
  "GALLARATE": "D869",
  "GALLESE": "D870",
  "GALLIATE": "D872",
  "GALLIATE LOMBARDO": "D871",
  "GALLIAVOLA": "D873",
  "GALLICANO": "D874",
  "GALLICANO NEL LAZIO": "D875",
  "GALLICCHIO": "D876",
  "GALLIERA": "D878",
  "GALLIERA VENETA": "D879",
  "GALLINARO": "D881",
  "GALLIO": "D882",
  "GALLIPOLI": "D883",
  "GALLO MATESE": "D884",
  "GALLODORO": "D885",
  "GALLUCCIO": "D886",
  "GALTELLI": "D888",
  "GALZIGNANO TERME": "D889",
  "GAMALERO": "D890",
  "GAMBARA": "D891",
  "GAMBARANA": "D892",
  "GAMBASCA": "D894",
  "GAMBASSI TERME": "D895",
  "GAMBATESA": "D896",
  "GAMBELLARA": "D897",
  "GAMBERALE": "D898",
  "GAMBETTOLA": "D899",
  "GAMBOLO": "D901",
  "GAMBUGLIANO": "D902",
  "GANDELLINO": "D903",
  "GANDINO": "D905",
  "GANDOSSO": "D906",
  "GANGI": "D907",
  "GARAGUSO": "D909",
  "GARBAGNA": "D910",
  "GARBAGNA NOVARESE": "D911",
  "GARBAGNATE MILANESE": "D912",
  "GARBAGNATE MONASTERO": "D913",
  "GARDA": "D915",
  "GARDONE RIVIERA": "D917",
  "GARDONE VAL TROMPIA": "D918",
  "GARESSIO": "D920",
  "GARGALLO": "D921",
  "GARGAZZONE": "D923",
  "GARGNANO": "D924",
  "GARLASCO": "D925",
  "GARLATE": "D926",
  "GARLENDA": "D927",
  "GARNIGA TERME": "D928",
  "GARZENO": "D930",
  "GARZIGLIANA": "D931",
  "GASPERINA": "D932",
  "GASSINO TORINESE": "D933",
  "GATTATICO": "D934",
  "GATTEO": "D935",
  "GATTICO-VERUNO": "M416",
  "GATTINARA": "D938",
  "GAVARDO": "D940",
  "GAVELLO": "D942",
  "GAVERINA TERME": "D943",
  "GAVI": "D944",
  "GAVIGNANO": "D945",
  "GAVIRATE": "D946",
  "GAVOI": "D947",
  "GAVORRANO": "D948",
  "GAZOLDO DEGLI IPPOLITI": "D949",
  "GAZZADA SCHIANNO": "D951",
  "GAZZANIGA": "D952",
  "GAZZO": "D956",
  "GAZZO VERONESE": "D957",
  "GAZZOLA": "D958",
  "GAZZUOLO": "D959",
  "GELA": "D960",
  "GEMMANO": "D961",
  "GEMONA DEL FRIULI": "D962",
  "GEMONIO": "D963",
  "GENAZZANO": "D964",
  "GENGA": "D965",
  "GENIVOLTA": "D966",
  "GENOLA": "D967",
  "GENONI": "D968",
  "GENOVA": "D969",
  "GENURI": "D970",
  "GENZANO DI LUCANIA": "D971",
  "GENZANO DI ROMA": "D972",
  "GERA LARIO": "D974",
  "GERACE": "D975",
  "GERACI SICULO": "D977",
  "GERANO": "D978",
  "GERENZAGO": "D980",
  "GERENZANO": "D981",
  "GERGEI": "D982",
  "GERMAGNANO": "D983",
  "GERMAGNO": "D984",
  "GERMIGNAGA": "D987",
  "GEROCARNE": "D988",
  "GEROLA ALTA": "D990",
  "GERRE DE CAPRIOLI": "D993",
  "GESICO": "D994",
  "GESSATE": "D995",
  "GESSOPALENA": "D996",
  "GESTURI": "D997",
  "GESUALDO": "D998",
  "GHEDI": "D999",
  "GHEMME": "E001",
  "GHIFFA": "E003",
  "GHILARZA": "E004",
  "GHISALBA": "E006",
  "GHISLARENGO": "E007",
  "GIACCIANO CON BARUCHELLA": "E008",
  "GIAGLIONE": "E009",
  "GIANICO": "E010",
  "GIANO DELLUMBRIA": "E012",
  "GIANO VETUSTO": "E011",
  "GIARDINELLO": "E013",
  "GIARDINI-NAXOS": "E014",
  "GIAROLE": "E015",
  "GIARRATANA": "E016",
  "GIARRE": "E017",
  "GIAVE": "E019",
  "GIAVENO": "E020",
  "GIAVERA DEL MONTELLO": "E021",
  "GIBA": "E022",
  "GIBELLINA": "E023",
  "GIFFLENGA": "E024",
  "GIFFONE": "E025",
  "GIFFONI SEI CASALI": "E026",
  "GIFFONI VALLE PIANA": "E027",
  "GIGNESE": "E028",
  "GIGNOD": "E029",
  "GILDONE": "E030",
  "GIMIGLIANO": "E031",
  "GINESTRA": "E033",
  "GINESTRA DEGLI SCHIAVONI": "E034",
  "GINOSA": "E036",
  "GIOI": "E037",
  "GIOIA DEI MARSI": "E040",
  "GIOIA DEL COLLE": "E038",
  "GIOIA SANNITICA": "E039",
  "GIOIA TAURO": "E041",
  "GIOIOSA IONICA": "E044",
  "GIOIOSA MAREA": "E043",
  "GIOVE": "E045",
  "GIOVINAZZO": "E047",
  "GIOVO": "E048",
  "GIRASOLE": "E049",
  "GIRIFALCO": "E050",
  "GISSI": "E052",
  "GIUGGIANELLO": "E053",
  "GIUGLIANO IN CAMPANIA": "E054",
  "GIULIANA": "E055",
  "GIULIANO DI ROMA": "E057",
  "GIULIANO TEATINO": "E056",
  "GIULIANOVA": "E058",
  "GIUNGANO": "E060",
  "GIURDIGNANO": "E061",
  "GIUSSAGO": "E062",
  "GIUSSANO": "E063",
  "GIUSTENICE": "E064",
  "GIUSTINO": "E065",
  "GIUSVALLA": "E066",
  "GIVOLETTO": "E067",
  "GIZZERIA": "E068",
  "GLORENZA": "E069",
  "GODEGA DI SANTURBANO": "E071",
  "GODIASCO SALICE TERME": "E072",
  "GODRANO": "E074",
  "GOITO": "E078",
  "GOLASECCA": "E079",
  "GOLFERENZO": "E081",
  "GOLFO ARANCI": "M274",
  "GOMBITO": "E082",
  "GONARS": "E083",
  "GONI": "E084",
  "GONNESA": "E086",
  "GONNOSCODINA": "E087",
  "GONNOSFANADIGA": "E085",
  "GONNOSNO": "D585",
  "GONNOSTRAMATZA": "E088",
  "GONZAGA": "E089",
  "GORDONA": "E090",
  "GORGA": "E091",
  "GORGO AL MONTICANO": "E092",
  "GORGOGLIONE": "E093",
  "GORGONZOLA": "E094",
  "GORIANO SICOLI": "E096",
  "GORIZIA": "E098",
  "GORLA MAGGIORE": "E101",
  "GORLA MINORE": "E102",
  "GORLAGO": "E100",
  "GORLE": "E103",
  "GORNATE OLONA": "E104",
  "GORNO": "E106",
  "GORO": "E107",
  "GORRETO": "E109",
  "GORZEGNO": "E111",
  "GOSALDO": "E113",
  "GOSSOLENGO": "E114",
  "GOTTASECCA": "E115",
  "GOTTOLENGO": "E116",
  "GOVONE": "E118",
  "GOZZANO": "E120",
  "GRADARA": "E122",
  "GRADISCA DISONZO": "E124",
  "GRADO": "E125",
  "GRADOLI": "E126",
  "GRAFFIGNANA": "E127",
  "GRAFFIGNANO": "E128",
  "GRAGLIA": "E130",
  "GRAGNANO": "E131",
  "GRAGNANO TREBBIENSE": "E132",
  "GRAMMICHELE": "E133",
  "GRANA": "E134",
  "GRANAROLO DELLEMILIA": "E136",
  "GRANDATE": "E139",
  "GRANDOLA ED UNITI": "E141",
  "GRANITI": "E142",
  "GRANOZZO CON MONTICELLO": "E143",
  "GRANTOLA": "E144",
  "GRANTORTO": "E145",
  "GRANZE": "E146",
  "GRASSANO": "E147",
  "GRASSOBBIO": "E148",
  "GRATTERI": "E149",
  "GRAVEDONA ED UNITI": "M315",
  "GRAVELLONA LOMELLINA": "E152",
  "GRAVELLONA TOCE": "E153",
  "GRAVERE": "E154",
  "GRAVINA DI CATANIA": "E156",
  "GRAVINA IN PUGLIA": "E155",
  "GRAZZANISE": "E158",
  "GRAZZANO BADOGLIO": "E159",
  "GRECCIO": "E160",
  "GRECI": "E161",
  "GREGGIO": "E163",
  "GREMIASCO": "E164",
  "GRESSAN": "E165",
  "GRESSONEY-LA-TRINITE": "E167",
  "GRESSONEY-SAINT-JEAN": "E168",
  "GREVE IN CHIANTI": "E169",
  "GREZZAGO": "E170",
  "GREZZANA": "E171",
  "GRIANTE": "E172",
  "GRICIGNANO DI AVERSA": "E173",
  "GRIGNASCO": "E177",
  "GRIGNO": "E178",
  "GRIMACCO": "E179",
  "GRIMALDI": "E180",
  "GRINZANE CAVOUR": "E182",
  "GRISIGNANO DI ZOCCO": "E184",
  "GRISOLIA": "E185",
  "GRIZZANA MORANDI": "E187",
  "GROGNARDO": "E188",
  "GROMO": "E189",
  "GRONDONA": "E191",
  "GRONE": "E192",
  "GRONTARDO": "E193",
  "GROPELLO CAIROLI": "E195",
  "GROPPARELLO": "E196",
  "GROSCAVALLO": "E199",
  "GROSIO": "E200",
  "GROSOTTO": "E201",
  "GROSSETO": "E202",
  "GROSSO": "E203",
  "GROTTAFERRATA": "E204",
  "GROTTAGLIE": "E205",
  "GROTTAMINARDA": "E206",
  "GROTTAMMARE": "E207",
  "GROTTAZZOLINA": "E208",
  "GROTTE": "E209",
  "GROTTE DI CASTRO": "E210",
  "GROTTERIA": "E212",
  "GROTTOLE": "E213",
  "GROTTOLELLA": "E214",
  "GRUARO": "E215",
  "GRUGLIASCO": "E216",
  "GRUMELLO CREMONESE ED UNITI": "E217",
  "GRUMELLO DEL MONTE": "E219",
  "GRUMENTO NOVA": "E221",
  "GRUMO APPULA": "E223",
  "GRUMO NEVANO": "E224",
  "GRUMOLO DELLE ABBADESSE": "E226",
  "GUAGNANO": "E227",
  "GUALDO": "E228",
  "GUALDO CATTANEO": "E229",
  "GUALDO TADINO": "E230",
  "GUALTIERI": "E232",
  "GUALTIERI SICAMINO": "E233",
  "GUAMAGGIORE": "E234",
  "GUANZATE": "E235",
  "GUARCINO": "E236",
  "GUARDA VENETA": "E240",
  "GUARDABOSONE": "E237",
  "GUARDAMIGLIO": "E238",
  "GUARDAVALLE": "E239",
  "GUARDEA": "E241",
  "GUARDIA LOMBARDI": "E245",
  "GUARDIA PERTICARA": "E246",
  "GUARDIA PIEMONTESE": "E242",
  "GUARDIA SANFRAMONDI": "E249",
  "GUARDIAGRELE": "E243",
  "GUARDIALFIERA": "E244",
  "GUARDIAREGIA": "E248",
  "GUARDISTALLO": "E250",
  "GUARENE": "E251",
  "GUASILA": "E252",
  "GUASTALLA": "E253",
  "GUAZZORA": "E255",
  "GUBBIO": "E256",
  "GUDO VISCONTI": "E258",
  "GUGLIONESI": "E259",
  "GUIDIZZOLO": "E261",
  "GUIDONIA MONTECELIO": "E263",
  "GUIGLIA": "E264",
  "GUILMI": "E266",
  "GURRO": "E269",
  "GUSPINI": "E270",
  "GUSSAGO": "E271",
  "GUSSOLA": "E272",
  "HONE": "E273",
  "IDRO": "E280",
  "IGLESIAS": "E281",
  "IGLIANO": "E282",
  "ILBONO": "E283",
  "ILLASI": "E284",
  "ILLORAI": "E285",
  "IMBERSAGO": "E287",
  "IMER": "E288",
  "IMOLA": "E289",
  "IMPERIA": "E290",
  "IMPRUNETA": "E291",
  "INARZO": "E292",
  "INCISA SCAPACCINO": "E295",
  "INCUDINE": "E297",
  "INDUNO OLONA": "E299",
  "INGRIA": "E301",
  "INTRAGNA": "E304",
  "INTROBIO": "E305",
  "INTROD": "E306",
  "INTRODACQUA": "E307",
  "INVERIGO": "E309",
  "INVERNO E MONTELEONE": "E310",
  "INVERSO PINASCA": "E311",
  "INVERUNO": "E313",
  "INVORIO": "E314",
  "INZAGO": "E317",
  "IONADI": "E321",
  "IRGOLI": "E323",
  "IRMA": "E325",
  "IRSINA": "E326",
  "ISASCA": "E327",
  "ISCA SULLO IONIO": "E328",
  "ISCHIA": "E329",
  "ISCHIA DI CASTRO": "E330",
  "ISCHITELLA": "E332",
  "ISEO": "E333",
  "ISERA": "E334",
  "ISERNIA": "E335",
  "ISILI": "E336",
  "ISNELLO": "E337",
  "ISOLA DASTI": "E338",
  "ISOLA DEL CANTONE": "E341",
  "ISOLA DEL GIGLIO": "E348",
  "ISOLA DEL GRAN SASSO DITALIA": "E343",
  "ISOLA DEL LIRI": "E340",
  "ISOLA DEL PIANO": "E351",
  "ISOLA DELLA SCALA": "E349",
  "ISOLA DELLE FEMMINE": "E350",
  "ISOLA DI CAPO RIZZUTO": "E339",
  "ISOLA DI FONDRA": "E353",
  "ISOLA DOVARESE": "E356",
  "ISOLA RIZZA": "E358",
  "ISOLA SANTANTONIO": "E360",
  "ISOLA VICENTINA": "E354",
  "ISOLABELLA": "E345",
  "ISOLABONA": "E346",
  "ISOLE TREMITI": "E363",
  "ISORELLA": "E364",
  "ISPANI": "E365",
  "ISPICA": "E366",
  "ISPRA": "E367",
  "ISSIGLIO": "E368",
  "ISSIME": "E369",
  "ISSO": "E370",
  "ISSOGNE": "E371",
  "ISTRANA": "E373",
  "ITALA": "E374",
  "ITRI": "E375",
  "ITTIREDDU": "E376",
  "ITTIRI": "E377",
  "IVREA": "E379",
  "IZANO": "E380",
  "JACURSO": "E274",
  "JELSI": "E381",
  "JENNE": "E382",
  "JERAGO CON ORAGO": "E386",
  "JERZU": "E387",
  "JESI": "E388",
  "JESOLO": "C388",
  "JOLANDA DI SAVOIA": "E320",
  "JOPPOLO": "E389",
  "JOPPOLO GIANCAXIO": "E390",
  "JOVENCAN": "E391",
  "LA CASSA": "E394",
  "LA LOGGIA": "E423",
  "LA MADDALENA": "E425",
  "LA MAGDELEINE": "A308",
  "LA MORRA": "E430",
  "LA SALLE": "E458",
  "LA SPEZIA": "E463",
  "LA THUILE": "E470",
  "LA VALLE": "E491",
  "LA VALLE AGORDINA": "E490",
  "LA VALLETTA BRIANZA": "M348",
  "LABICO": "E392",
  "LABRO": "E393",
  "LACCHIARELLA": "E395",
  "LACCO AMENO": "E396",
  "LACEDONIA": "E397",
  "LACES": "E398",
  "LACONI": "E400",
  "LADISPOLI": "M212",
  "LAERRU": "E401",
  "LAGANADI": "E402",
  "LAGHI": "E403",
  "LAGLIO": "E405",
  "LAGNASCO": "E406",
  "LAGO": "E407",
  "LAGONEGRO": "E409",
  "LAGOSANTO": "E410",
  "LAGUNDO": "E412",
  "LAIGUEGLIA": "E414",
  "LAINATE": "E415",
  "LAINO": "E416",
  "LAINO BORGO": "E417",
  "LAINO CASTELLO": "E419",
  "LAION": "E420",
  "LAIVES": "E421",
  "LAJATICO": "E413",
  "LALLIO": "E422",
  "LAMA DEI PELIGNI": "E424",
  "LAMA MOCOGNO": "E426",
  "LAMBRUGO": "E428",
  "LAMEZIA TERME": "M208",
  "LAMON": "E429",
  "LAMPEDUSA E LINOSA": "E431",
  "LAMPORECCHIO": "E432",
  "LAMPORO": "E433",
  "LANA": "E434",
  "LANCIANO": "E435",
  "LANDIONA": "E436",
  "LANDRIANO": "E437",
  "LANGHIRANO": "E438",
  "LANGOSCO": "E439",
  "LANUSEI": "E441",
  "LANUVIO": "C767",
  "LANZADA": "E443",
  "LANZO TORINESE": "E445",
  "LAPEDONA": "E447",
  "LAPIO": "E448",
  "LAPPANO": "E450",
  "LAQUILA": "A345",
  "LARCIANO": "E451",
  "LARDIRAGO": "E454",
  "LARIANO": "M207",
  "LARINO": "E456",
  "LAS PLASSAS": "E464",
  "LASA": "E457",
  "LASCARI": "E459",
  "LASNIGO": "E462",
  "LASTEBASSE": "E465",
  "LASTRA A SIGNA": "E466",
  "LATERA": "E467",
  "LATERINA PERGINE VALDARNO": "M392",
  "LATERZA": "E469",
  "LATIANO": "E471",
  "LATINA": "E472",
  "LATISANA": "E473",
  "LATRONICO": "E474",
  "LATTARICO": "E475",
  "LAUCO": "E476",
  "LAUREANA CILENTO": "E480",
  "LAUREANA DI BORRELLO": "E479",
  "LAUREGNO": "E481",
  "LAURENZANA": "E482",
  "LAURIA": "E483",
  "LAURIANO": "E484",
  "LAURINO": "E485",
  "LAURITO": "E486",
  "LAURO": "E487",
  "LAVAGNA": "E488",
  "LAVAGNO": "E489",
  "LAVARONE": "E492",
  "LAVELLO": "E493",
  "LAVENA PONTE TRESA": "E494",
  "LAVENO-MOMBELLO": "E496",
  "LAVENONE": "E497",
  "LAVIANO": "E498",
  "LAVIS": "E500",
  "LAZISE": "E502",
  "LAZZATE": "E504",
  "LECCE": "E506",
  "LECCE NEI MARSI": "E505",
  "LECCO": "E507",
  "LEDRO": "M313",
  "LEFFE": "E509",
  "LEGGIUNO": "E510",
  "LEGNAGO": "E512",
  "LEGNANO": "E514",
  "LEGNARO": "E515",
  "LEI": "E517",
  "LEINI": "E518",
  "LEIVI": "E519",
  "LEMIE": "E520",
  "LENDINARA": "E522",
  "LENI": "E523",
  "LENNA": "E524",
  "LENO": "E526",
  "LENOLA": "E527",
  "LENTA": "E528",
  "LENTATE SUL SEVESO": "E530",
  "LENTELLA": "E531",
  "LENTINI": "E532",
  "LEONESSA": "E535",
  "LEONFORTE": "E536",
  "LEPORANO": "E537",
  "LEQUILE": "E538",
  "LEQUIO BERRIA": "E540",
  "LEQUIO TANARO": "E539",
  "LERCARA FRIDDI": "E541",
  "LERICI": "E542",
  "LERMA": "E543",
  "LESA": "E544",
  "LESEGNO": "E546",
  "LESIGNANO DE BAGNI": "E547",
  "LESINA": "E549",
  "LESMO": "E550",
  "LESSOLO": "E551",
  "LESSONA": "M371",
  "LESTIZZA": "E553",
  "LETINO": "E554",
  "LETOJANNI": "E555",
  "LETTERE": "E557",
  "LETTOMANOPPELLO": "E558",
  "LETTOPALENA": "E559",
  "LEVANTO": "E560",
  "LEVATE": "E562",
  "LEVERANO": "E563",
  "LEVICE": "E564",
  "LEVICO TERME": "E565",
  "LEVONE": "E566",
  "LEZZENO": "E569",
  "LIBERI": "E570",
  "LIBRIZZI": "E571",
  "LICATA": "E573",
  "LICCIANA NARDI": "E574",
  "LICENZA": "E576",
  "LICODIA EUBEA": "E578",
  "LIERNA": "E581",
  "LIGNANA": "E583",
  "LIGNANO SABBIADORO": "E584",
  "LILLIANES": "E587",
  "LIMANA": "E588",
  "LIMATOLA": "E589",
  "LIMBADI": "E590",
  "LIMBIATE": "E591",
  "LIMENA": "E592",
  "LIMIDO COMASCO": "E593",
  "LIMINA": "E594",
  "LIMONE PIEMONTE": "E597",
  "LIMONE SUL GARDA": "E596",
  "LIMOSANO": "E599",
  "LINAROLO": "E600",
  "LINGUAGLOSSA": "E602",
  "LIONI": "E605",
  "LIPARI": "E606",
  "LIPOMO": "E607",
  "LIRIO": "E608",
  "LISCATE": "E610",
  "LISCIA": "E611",
  "LISCIANO NICCONE": "E613",
  "LISIO": "E615",
  "LISSONE": "E617",
  "LIVERI": "E620",
  "LIVIGNO": "E621",
  "LIVINALLONGO DEL COL DI LANA": "E622",
  "LIVO": "E624",
  "LIVORNO": "E625",
  "LIVORNO FERRARIS": "E626",
  "LIVRAGA": "E627",
  "LIZZANELLO": "E629",
  "LIZZANO": "E630",
  "LIZZANO IN BELVEDERE": "A771",
  "LOANO": "E632",
  "LOAZZOLO": "E633",
  "LOCANA": "E635",
  "LOCATE DI TRIULZI": "E639",
  "LOCATE VARESINO": "E638",
  "LOCATELLO": "E640",
  "LOCERI": "E644",
  "LOCOROTONDO": "E645",
  "LOCRI": "D976",
  "LOCULI": "E646",
  "LODE": "E647",
  "LODI": "E648",
  "LODI VECCHIO": "E651",
  "LODINE": "E649",
  "LODRINO": "E652",
  "LOGRATO": "E654",
  "LOIANO": "E655",
  "LOIRI PORTO SAN PAOLO": "M275",
  "LOMAGNA": "E656",
  "LOMAZZO": "E659",
  "LOMBARDORE": "E660",
  "LOMBRIASCO": "E661",
  "LOMELLO": "E662",
  "LONA-LASES": "E664",
  "LONATE CEPPINO": "E665",
  "LONATE POZZOLO": "E666",
  "LONATO DEL GARDA": "M312",
  "LONDA": "E668",
  "LONGANO": "E669",
  "LONGARE": "E671",
  "LONGARONE": "M342",
  "LONGHENA": "E673",
  "LONGI": "E674",
  "LONGIANO": "E675",
  "LONGOBARDI": "E677",
  "LONGOBUCCO": "E678",
  "LONGONE AL SEGRINO": "E679",
  "LONGONE SABINO": "E681",
  "LONIGO": "E682",
  "LORANZE": "E683",
  "LOREGGIA": "E684",
  "LOREGLIA": "E685",
  "LORENZAGO DI CADORE": "E687",
  "LOREO": "E689",
  "LORETO": "E690",
  "LORETO APRUTINO": "E691",
  "LORIA": "E692",
  "LORO CIUFFENNA": "E693",
  "LORO PICENO": "E694",
  "LORSICA": "E695",
  "LOSINE": "E698",
  "LOTZORAI": "E700",
  "LOVERE": "E704",
  "LOVERO": "E705",
  "LOZIO": "E706",
  "LOZZA": "E707",
  "LOZZO ATESTINO": "E709",
  "LOZZO DI CADORE": "E708",
  "LOZZOLO": "E711",
  "LU E CUCCARO MONFERRATO": "M420",
  "LUBRIANO": "E713",
  "LUCCA": "E715",
  "LUCCA SICULA": "E714",
  "LUCERA": "E716",
  "LUCIGNANO": "E718",
  "LUCINASCO": "E719",
  "LUCITO": "E722",
  "LUCO DEI MARSI": "E723",
  "LUCOLI": "E724",
  "LUGAGNANO VAL DARDA": "E726",
  "LUGNANO IN TEVERINA": "E729",
  "LUGO": "E730",
  "LUGO DI VICENZA": "E731",
  "LUINO": "E734",
  "LUISAGO": "E735",
  "LULA": "E736",
  "LUMARZO": "E737",
  "LUMEZZANE": "E738",
  "LUNAMATRONA": "E742",
  "LUNANO": "E743",
  "LUNGAVILLA": "B387",
  "LUNGRO": "E745",
  "LUNI": "G143",
  "LUOGOSANO": "E746",
  "LUOGOSANTO": "E747",
  "LUPARA": "E748",
  "LURAGO DERBA": "E749",
  "LURAGO MARINONE": "E750",
  "LURANO": "E751",
  "LURAS": "E752",
  "LURATE CACCIVIO": "E753",
  "LUSCIANO": "E754",
  "LUSERNA": "E757",
  "LUSERNA SAN GIOVANNI": "E758",
  "LUSERNETTA": "E759",
  "LUSEVERA": "E760",
  "LUSIA": "E761",
  "LUSIANA CONCO": "M427",
  "LUSIGLIE": "E763",
  "LUSON": "E764",
  "LUSTRA": "E767",
  "LUVINATE": "E769",
  "LUZZANA": "E770",
  "LUZZARA": "E772",
  "LUZZI": "E773",
  "MACCAGNO CON PINO E VEDDASCA": "M339",
  "MACCASTORNA": "E777",
  "MACCHIA DISERNIA": "E778",
  "MACCHIA VALFORTORE": "E780",
  "MACCHIAGODENA": "E779",
  "MACELLO": "E782",
  "MACERATA": "E783",
  "MACERATA CAMPANIA": "E784",
  "MACERATA FELTRIA": "E785",
  "MACHERIO": "E786",
  "MACLODIO": "E787",
  "MACOMER": "E788",
  "MACRA": "E789",
  "MACUGNAGA": "E790",
  "MADDALONI": "E791",
  "MADESIMO": "E342",
  "MADIGNANO": "E793",
  "MADONE": "E794",
  "MADONNA DEL SASSO": "E795",
  "MADRUZZO": "M357",
  "MAENZA": "E798",
  "MAFALDA": "E799",
  "MAGASA": "E800",
  "MAGENTA": "E801",
  "MAGGIORA": "E803",
  "MAGHERNO": "E804",
  "MAGIONE": "E805",
  "MAGISANO": "E806",
  "MAGLIANO ALFIERI": "E809",
  "MAGLIANO ALPI": "E808",
  "MAGLIANO DE MARSI": "E811",
  "MAGLIANO DI TENNA": "E807",
  "MAGLIANO IN TOSCANA": "E810",
  "MAGLIANO ROMANO": "E813",
  "MAGLIANO SABINA": "E812",
  "MAGLIANO VETERE": "E814",
  "MAGLIE": "E815",
  "MAGLIOLO": "E816",
  "MAGLIONE": "E817",
  "MAGNACAVALLO": "E818",
  "MAGNAGO": "E819",
  "MAGNANO": "E821",
  "MAGNANO IN RIVIERA": "E820",
  "MAGOMADAS": "E825",
  "MAGRE SULLA STRADA DEL VINO": "E829",
  "MAGREGLIO": "E830",
  "MAIDA": "E834",
  "MAIERA": "E835",
  "MAIERATO": "E836",
  "MAIOLATI SPONTINI": "E837",
  "MAIOLO": "E838",
  "MAIORI": "E839",
  "MAIRAGO": "E840",
  "MAIRANO": "E841",
  "MAISSANA": "E842",
  "MAJANO": "E833",
  "MALAGNINO": "E843",
  "MALALBERGO": "E844",
  "MALBORGHETTO VALBRUNA": "E847",
  "MALCESINE": "E848",
  "MALE": "E850",
  "MALEGNO": "E851",
  "MALEO": "E852",
  "MALESCO": "E853",
  "MALETTO": "E854",
  "MALFA": "E855",
  "MALGESSO": "E856",
  "MALGRATE": "E858",
  "MALITO": "E859",
  "MALLARE": "E860",
  "MALLES VENOSTA": "E862",
  "MALNATE": "E863",
  "MALO": "E864",
  "MALONNO": "E865",
  "MALTIGNANO": "E868",
  "MALVAGNA": "E869",
  "MALVICINO": "E870",
  "MALVITO": "E872",
  "MAMMOLA": "E873",
  "MAMOIADA": "E874",
  "MANCIANO": "E875",
  "MANDANICI": "E876",
  "MANDAS": "E877",
  "MANDATORICCIO": "E878",
  "MANDELA": "B632",
  "MANDELLO DEL LARIO": "E879",
  "MANDELLO VITTA": "E880",
  "MANDURIA": "E882",
  "MANERBA DEL GARDA": "E883",
  "MANERBIO": "E884",
  "MANFREDONIA": "E885",
  "MANGO": "E887",
  "MANGONE": "E888",
  "MANIACE": "M283",
  "MANIAGO": "E889",
  "MANOCALZATI": "E891",
  "MANOPPELLO": "E892",
  "MANSUE": "E893",
  "MANTA": "E894",
  "MANTELLO": "E896",
  "MANTOVA": "E897",
  "MANZANO": "E899",
  "MANZIANA": "E900",
  "MAPELLO": "E901",
  "MAPPANO": "M316",
  "MARA": "E902",
  "MARACALAGONIS": "E903",
  "MARANELLO": "E904",
  "MARANO DI NAPOLI": "E906",
  "MARANO DI VALPOLICELLA": "E911",
  "MARANO EQUO": "E908",
  "MARANO LAGUNARE": "E910",
  "MARANO MARCHESATO": "E914",
  "MARANO PRINCIPATO": "E915",
  "MARANO SUL PANARO": "E905",
  "MARANO TICINO": "E907",
  "MARANO VICENTINO": "E912",
  "MARANZANA": "E917",
  "MARATEA": "E919",
  "MARCALLO CON CASONE": "E921",
  "MARCARIA": "E922",
  "MARCEDUSA": "E923",
  "MARCELLINA": "E924",
  "MARCELLINARA": "E925",
  "MARCETELLI": "E927",
  "MARCHENO": "E928",
  "MARCHIROLO": "E929",
  "MARCIANA": "E930",
  "MARCIANA MARINA": "E931",
  "MARCIANISE": "E932",
  "MARCIANO DELLA CHIANA": "E933",
  "MARCIGNAGO": "E934",
  "MARCON": "E936",
  "MAREBBE": "E938",
  "MARENE": "E939",
  "MARENO DI PIAVE": "E940",
  "MARENTINO": "E941",
  "MARETTO": "E944",
  "MARGARITA": "E945",
  "MARGHERITA DI SAVOIA": "E946",
  "MARGNO": "E947",
  "MARIANA MANTOVANA": "E949",
  "MARIANO COMENSE": "E951",
  "MARIANO DEL FRIULI": "E952",
  "MARIANOPOLI": "E953",
  "MARIGLIANELLA": "E954",
  "MARIGLIANO": "E955",
  "MARINA DI GIOIOSA IONICA": "E956",
  "MARINEO": "E957",
  "MARINO": "E958",
  "MARLENGO": "E959",
  "MARLIANA": "E960",
  "MARMENTINO": "E961",
  "MARMIROLO": "E962",
  "MARMORA": "E963",
  "MARNATE": "E965",
  "MARONE": "E967",
  "MAROPATI": "E968",
  "MAROSTICA": "E970",
  "MARRADI": "E971",
  "MARRUBIU": "E972",
  "MARSAGLIA": "E973",
  "MARSALA": "E974",
  "MARSCIANO": "E975",
  "MARSICO NUOVO": "E976",
  "MARSICOVETERE": "E977",
  "MARTA": "E978",
  "MARTANO": "E979",
  "MARTELLAGO": "E980",
  "MARTELLO": "E981",
  "MARTIGNACCO": "E982",
  "MARTIGNANA DI PO": "E983",
  "MARTIGNANO": "E984",
  "MARTINA FRANCA": "E986",
  "MARTINENGO": "E987",
  "MARTINIANA PO": "E988",
  "MARTINSICURO": "E989",
  "MARTIRANO": "E990",
  "MARTIRANO LOMBARDO": "E991",
  "MARTIS": "E992",
  "MARTONE": "E993",
  "MARUDO": "E994",
  "MARUGGIO": "E995",
  "MARZABOTTO": "B689",
  "MARZANO": "E999",
  "MARZANO APPIO": "E998",
  "MARZANO DI NOLA": "E997",
  "MARZI": "F001",
  "MARZIO": "F002",
  "MASAINAS": "M270",
  "MASATE": "F003",
  "MASCALI": "F004",
  "MASCALUCIA": "F005",
  "MASCHITO": "F006",
  "MASCIAGO PRIMO": "F007",
  "MASER": "F009",
  "MASERA": "F010",
  "MASERA DI PADOVA": "F011",
  "MASERADA SUL PIAVE": "F012",
  "MASI": "F013",
  "MASI TORELLO": "F016",
  "MASIO": "F015",
  "MASLIANICO": "F017",
  "MASONE": "F020",
  "MASSA": "F023",
  "MASSA DALBE": "F022",
  "MASSA DI SOMMA": "M289",
  "MASSA E COZZILE": "F025",
  "MASSA FERMANA": "F021",
  "MASSA LOMBARDA": "F029",
  "MASSA LUBRENSE": "F030",
  "MASSA MARITTIMA": "F032",
  "MASSA MARTANA": "F024",
  "MASSAFRA": "F027",
  "MASSALENGO": "F028",
  "MASSANZAGO": "F033",
  "MASSAROSA": "F035",
  "MASSAZZA": "F037",
  "MASSELLO": "F041",
  "MASSERANO": "F042",
  "MASSIGNANO": "F044",
  "MASSIMENO": "F045",
  "MASSIMINO": "F046",
  "MASSINO VISCONTI": "F047",
  "MASSIOLA": "F048",
  "MASULLAS": "F050",
  "MATELICA": "F051",
  "MATERA": "F052",
  "MATHI": "F053",
  "MATINO": "F054",
  "MATRICE": "F055",
  "MATTIE": "F058",
  "MATTINATA": "F059",
  "MAZARA DEL VALLO": "F061",
  "MAZZANO": "F063",
  "MAZZANO ROMANO": "F064",
  "MAZZARINO": "F065",
  "MAZZARRA SANTANDREA": "F066",
  "MAZZARRONE": "M271",
  "MAZZE": "F067",
  "MAZZIN": "F068",
  "MAZZO DI VALTELLINA": "F070",
  "MEANA DI SUSA": "F074",
  "MEANA SARDO": "F073",
  "MEDA": "F078",
  "MEDE": "F080",
  "MEDEA": "F081",
  "MEDESANO": "F082",
  "MEDICINA": "F083",
  "MEDIGLIA": "F084",
  "MEDOLAGO": "F085",
  "MEDOLE": "F086",
  "MEDOLLA": "F087",
  "MEDUNA DI LIVENZA": "F088",
  "MEDUNO": "F089",
  "MEGLIADINO SAN VITALE": "F092",
  "MEINA": "F093",
  "MELARA": "F095",
  "MELAZZO": "F096",
  "MELDOLA": "F097",
  "MELE": "F098",
  "MELEGNANO": "F100",
  "MELENDUGNO": "F101",
  "MELETI": "F102",
  "MELFI": "F104",
  "MELICUCCA": "F105",
  "MELICUCCO": "F106",
  "MELILLI": "F107",
  "MELISSA": "F108",
  "MELISSANO": "F109",
  "MELITO DI NAPOLI": "F111",
  "MELITO DI PORTO SALVO": "F112",
  "MELITO IRPINO": "F110",
  "MELIZZANO": "F113",
  "MELLE": "F114",
  "MELLO": "F115",
  "MELPIGNANO": "F117",
  "MELTINA": "F118",
  "MELZO": "F119",
  "MENAGGIO": "F120",
  "MENCONICO": "F122",
  "MENDATICA": "F123",
  "MENDICINO": "F125",
  "MENFI": "F126",
  "MENTANA": "F127",
  "MEOLO": "F130",
  "MERANA": "F131",
  "MERANO": "F132",
  "MERATE": "F133",
  "MERCALLO": "F134",
  "MERCATELLO SUL METAURO": "F135",
  "MERCATINO CONCA": "F136",
  "MERCATO SAN SEVERINO": "F138",
  "MERCATO SARACENO": "F139",
  "MERCENASCO": "F140",
  "MERCOGLIANO": "F141",
  "MERETO DI TOMBA": "F144",
  "MERGO": "F145",
  "MERGOZZO": "F146",
  "MERI": "F147",
  "MERLARA": "F148",
  "MERLINO": "F149",
  "MERONE": "F151",
  "MESAGNE": "F152",
  "MESE": "F153",
  "MESENZANA": "F154",
  "MESERO": "F155",
  "MESOLA": "F156",
  "MESORACA": "F157",
  "MESSINA": "F158",
  "MESTRINO": "F161",
  "META": "F162",
  "MEZZAGO": "F165",
  "MEZZANA": "F168",
  "MEZZANA BIGLI": "F170",
  "MEZZANA MORTIGLIENGO": "F167",
  "MEZZANA RABATTONE": "F171",
  "MEZZANE DI SOTTO": "F172",
  "MEZZANEGO": "F173",
  "MEZZANINO": "F175",
  "MEZZANO": "F176",
  "MEZZENILE": "F182",
  "MEZZOCORONA": "F183",
  "MEZZOJUSO": "F184",
  "MEZZOLDO": "F186",
  "MEZZOLOMBARDO": "F187",
  "MEZZOMERICO": "F188",
  "MIAGLIANO": "F189",
  "MIANE": "F190",
  "MIASINO": "F191",
  "MIAZZINA": "F192",
  "MICIGLIANO": "F193",
  "MIGGIANO": "F194",
  "MIGLIANICO": "F196",
  "MIGLIERINA": "F200",
  "MIGLIONICO": "F201",
  "MIGNANEGO": "F202",
  "MIGNANO MONTE LUNGO": "F203",
  "MILANO": "F205",
  "MILAZZO": "F206",
  "MILENA": "E618",
  "MILETO": "F207",
  "MILIS": "F208",
  "MILITELLO IN VAL DI CATANIA": "F209",
  "MILITELLO ROSMARINO": "F210",
  "MILLESIMO": "F213",
  "MILO": "F214",
  "MILZANO": "F216",
  "MINEO": "F217",
  "MINERBE": "F218",
  "MINERBIO": "F219",
  "MINERVINO DI LECCE": "F221",
  "MINERVINO MURGE": "F220",
  "MINORI": "F223",
  "MINTURNO": "F224",
  "MINUCCIANO": "F225",
  "MIOGLIA": "F226",
  "MIRA": "F229",
  "MIRABELLA ECLANO": "F230",
  "MIRABELLA IMBACCARI": "F231",
  "MIRABELLO MONFERRATO": "F232",
  "MIRABELLO SANNITICO": "F233",
  "MIRADOLO TERME": "F238",
  "MIRANDA": "F239",
  "MIRANDOLA": "F240",
  "MIRANO": "F241",
  "MIRTO": "F242",
  "MISANO ADRIATICO": "F244",
  "MISANO DI GERA DADDA": "F243",
  "MISILMERI": "F246",
  "MISINTO": "F247",
  "MISSAGLIA": "F248",
  "MISSANELLO": "F249",
  "MISTERBIANCO": "F250",
  "MISTRETTA": "F251",
  "MOASCA": "F254",
  "MOCONESI": "F256",
  "MODENA": "F257",
  "MODICA": "F258",
  "MODIGLIANA": "F259",
  "MODOLO": "F261",
  "MODUGNO": "F262",
  "MOENA": "F263",
  "MOGGIO": "F265",
  "MOGGIO UDINESE": "F266",
  "MOGLIA": "F267",
  "MOGLIANO": "F268",
  "MOGLIANO VENETO": "F269",
  "MOGORELLA": "F270",
  "MOGORO": "F272",
  "MOIANO": "F274",
  "MOIMACCO": "F275",
  "MOIO ALCANTARA": "F277",
  "MOIO DE CALVI": "F276",
  "MOIO DELLA CIVITELLA": "F278",
  "MOIOLA": "F279",
  "MOLA DI BARI": "F280",
  "MOLARE": "F281",
  "MOLAZZANA": "F283",
  "MOLFETTA": "F284",
  "MOLINA ATERNO": "M255",
  "MOLINARA": "F287",
  "MOLINELLA": "F288",
  "MOLINI DI TRIORA": "F290",
  "MOLINO DEI TORTI": "F293",
  "MOLISE": "F294",
  "MOLITERNO": "F295",
  "MOLLIA": "F297",
  "MOLOCHIO": "F301",
  "MOLTENO": "F304",
  "MOLTRASIO": "F305",
  "MOLVENO": "F307",
  "MOMBALDONE": "F308",
  "MOMBARCARO": "F309",
  "MOMBAROCCIO": "F310",
  "MOMBARUZZO": "F311",
  "MOMBASIGLIO": "F312",
  "MOMBELLO DI TORINO": "F315",
  "MOMBELLO MONFERRATO": "F313",
  "MOMBERCELLI": "F316",
  "MOMO": "F317",
  "MOMPANTERO": "F318",
  "MOMPEO": "F319",
  "MOMPERONE": "F320",
  "MONACILIONI": "F322",
  "MONALE": "F323",
  "MONASTERACE": "F324",
  "MONASTERO BORMIDA": "F325",
  "MONASTERO DI LANZO": "F327",
  "MONASTERO DI VASCO": "F326",
  "MONASTEROLO CASOTTO": "F329",
  "MONASTEROLO DEL CASTELLO": "F328",
  "MONASTEROLO DI SAVIGLIANO": "F330",
  "MONASTIER DI TREVISO": "F332",
  "MONASTIR": "F333",
  "MONCALIERI": "F335",
  "MONCALVO": "F336",
  "MONCENISIO": "D553",
  "MONCESTINO": "F337",
  "MONCHIERO": "F338",
  "MONCHIO DELLE CORTI": "F340",
  "MONCRIVELLO": "F342",
  "MONCUCCO TORINESE": "F343",
  "MONDAINO": "F346",
  "MONDAVIO": "F347",
  "MONDOLFO": "F348",
  "MONDOVI": "F351",
  "MONDRAGONE": "F352",
  "MONEGLIA": "F354",
  "MONESIGLIO": "F355",
  "MONFALCONE": "F356",
  "MONFORTE DALBA": "F358",
  "MONFORTE SAN GIORGIO": "F359",
  "MONFUMO": "F360",
  "MONGARDINO": "F361",
  "MONGHIDORO": "F363",
  "MONGIANA": "F364",
  "MONGIARDINO LIGURE": "F365",
  "MONGIUFFI MELIA": "F368",
  "MONGRANDO": "F369",
  "MONGRASSANO": "F370",
  "MONGUELFO-TESIDO": "F371",
  "MONGUZZO": "F372",
  "MONIGA DEL GARDA": "F373",
  "MONLEALE": "F374",
  "MONNO": "F375",
  "MONOPOLI": "F376",
  "MONREALE": "F377",
  "MONRUPINO": "F378",
  "MONSAMPIETRO MORICO": "F379",
  "MONSAMPOLO DEL TRONTO": "F380",
  "MONSANO": "F381",
  "MONSELICE": "F382",
  "MONSERRATO": "F383",
  "MONSUMMANO TERME": "F384",
  "MONTA": "F385",
  "MONTABONE": "F386",
  "MONTACUTO": "F387",
  "MONTAFIA": "F390",
  "MONTAGANO": "F391",
  "MONTAGNA": "F392",
  "MONTAGNA IN VALTELLINA": "F393",
  "MONTAGNANA": "F394",
  "MONTAGNAREALE": "F395",
  "MONTAGUTO": "F397",
  "MONTAIONE": "F398",
  "MONTALBANO ELICONA": "F400",
  "MONTALBANO JONICO": "F399",
  "MONTALCINO": "M378",
  "MONTALDEO": "F403",
  "MONTALDO BORMIDA": "F404",
  "MONTALDO DI MONDOVI": "F405",
  "MONTALDO ROERO": "F408",
  "MONTALDO SCARAMPI": "F409",
  "MONTALDO TORINESE": "F407",
  "MONTALE": "F410",
  "MONTALENGHE": "F411",
  "MONTALLEGRO": "F414",
  "MONTALTO CARPASIO": "M387",
  "MONTALTO DELLE MARCHE": "F415",
  "MONTALTO DI CASTRO": "F419",
  "MONTALTO DORA": "F420",
  "MONTALTO PAVESE": "F417",
  "MONTALTO UFFUGO": "F416",
  "MONTANARO": "F422",
  "MONTANASO LOMBARDO": "F423",
  "MONTANERA": "F424",
  "MONTANO ANTILIA": "F426",
  "MONTANO LUCINO": "F427",
  "MONTAPPONE": "F428",
  "MONTAQUILA": "F429",
  "MONTASOLA": "F430",
  "MONTAURO": "F432",
  "MONTAZZOLI": "F433",
  "MONTE ARGENTARIO": "F437",
  "MONTE CASTELLO DI VIBIO": "F456",
  "MONTE CAVALLO": "F460",
  "MONTE CERIGNONE": "F467",
  "MONTE COMPATRI": "F477",
  "MONTE CREMASCO": "F434",
  "MONTE DI MALO": "F486",
  "MONTE DI PROCIDA": "F488",
  "MONTE GIBERTO": "F517",
  "MONTE GRIMANO TERME": "F524",
  "MONTE ISOLA": "F532",
  "MONTE MARENZO": "F561",
  "MONTE PORZIO": "F589",
  "MONTE PORZIO CATONE": "F590",
  "MONTE RINALDO": "F599",
  "MONTE ROBERTO": "F600",
  "MONTE ROMANO": "F603",
  "MONTE SAN BIAGIO": "F616",
  "MONTE SAN GIACOMO": "F618",
  "MONTE SAN GIOVANNI CAMPANO": "F620",
  "MONTE SAN GIOVANNI IN SABINA": "F619",
  "MONTE SAN GIUSTO": "F621",
  "MONTE SAN MARTINO": "F622",
  "MONTE SAN PIETRANGELI": "F626",
  "MONTE SAN PIETRO": "F627",
  "MONTE SAN SAVINO": "F628",
  "MONTE SAN VITO": "F634",
  "MONTE SANTA MARIA TIBERINA": "F629",
  "MONTE SANTANGELO": "F631",
  "MONTE URANO": "F653",
  "MONTE VIDON COMBATTE": "F664",
  "MONTE VIDON CORRADO": "F665",
  "MONTEBELLO DELLA BATTAGLIA": "F440",
  "MONTEBELLO DI BERTONA": "F441",
  "MONTEBELLO JONICO": "D746",
  "MONTEBELLO SUL SANGRO": "B268",
  "MONTEBELLO VICENTINO": "F442",
  "MONTEBELLUNA": "F443",
  "MONTEBRUNO": "F445",
  "MONTEBUONO": "F446",
  "MONTECALVO IN FOGLIA": "F450",
  "MONTECALVO IRPINO": "F448",
  "MONTECALVO VERSIGGIA": "F449",
  "MONTECARLO": "F452",
  "MONTECAROTTO": "F453",
  "MONTECASSIANO": "F454",
  "MONTECASTELLO": "F455",
  "MONTECASTRILLI": "F457",
  "MONTECATINI VAL DI CECINA": "F458",
  "MONTECATINI-TERME": "A561",
  "MONTECCHIA DI CROSARA": "F461",
  "MONTECCHIO": "F462",
  "MONTECCHIO EMILIA": "F463",
  "MONTECCHIO MAGGIORE": "F464",
  "MONTECCHIO PRECALCINO": "F465",
  "MONTECHIARO DACQUI": "F469",
  "MONTECHIARO DASTI": "F468",
  "MONTECHIARUGOLO": "F473",
  "MONTECICCARDO": "F474",
  "MONTECILFONE": "F475",
  "MONTECOPIOLO": "F478",
  "MONTECORICE": "F479",
  "MONTECORVINO PUGLIANO": "F480",
  "MONTECORVINO ROVELLA": "F481",
  "MONTECOSARO": "F482",
  "MONTECRESTESE": "F483",
  "MONTECRETO": "F484",
  "MONTEDINOVE": "F487",
  "MONTEDORO": "F489",
  "MONTEFALCIONE": "F491",
  "MONTEFALCO": "F492",
  "MONTEFALCONE APPENNINO": "F493",
  "MONTEFALCONE DI VAL FORTORE": "F494",
  "MONTEFALCONE NEL SANNIO": "F495",
  "MONTEFANO": "F496",
  "MONTEFELCINO": "F497",
  "MONTEFERRANTE": "F498",
  "MONTEFIASCONE": "F499",
  "MONTEFINO": "F500",
  "MONTEFIORE CONCA": "F502",
  "MONTEFIORE DELLASO": "F501",
  "MONTEFIORINO": "F503",
  "MONTEFLAVIO": "F504",
  "MONTEFORTE CILENTO": "F507",
  "MONTEFORTE DALPONE": "F508",
  "MONTEFORTE IRPINO": "F506",
  "MONTEFORTINO": "F509",
  "MONTEFRANCO": "F510",
  "MONTEFREDANE": "F511",
  "MONTEFUSCO": "F512",
  "MONTEGABBIONE": "F513",
  "MONTEGALDA": "F514",
  "MONTEGALDELLA": "F515",
  "MONTEGALLO": "F516",
  "MONTEGIOCO": "F518",
  "MONTEGIORDANO": "F519",
  "MONTEGIORGIO": "F520",
  "MONTEGRANARO": "F522",
  "MONTEGRIDOLFO": "F523",
  "MONTEGRINO VALTRAVAGLIA": "F526",
  "MONTEGROSSO DASTI": "F527",
  "MONTEGROSSO PIAN LATTE": "F528",
  "MONTEGROTTO TERME": "F529",
  "MONTEIASI": "F531",
  "MONTELABBATE": "F533",
  "MONTELANICO": "F534",
  "MONTELAPIANO": "F535",
  "MONTELEONE DI FERMO": "F536",
  "MONTELEONE DI PUGLIA": "F538",
  "MONTELEONE DI SPOLETO": "F540",
  "MONTELEONE DORVIETO": "F543",
  "MONTELEONE ROCCA DORIA": "F542",
  "MONTELEONE SABINO": "F541",
  "MONTELEPRE": "F544",
  "MONTELIBRETTI": "F545",
  "MONTELLA": "F546",
  "MONTELLO": "F547",
  "MONTELONGO": "F548",
  "MONTELPARO": "F549",
  "MONTELUPO ALBESE": "F550",
  "MONTELUPO FIORENTINO": "F551",
  "MONTELUPONE": "F552",
  "MONTEMAGGIORE BELSITO": "F553",
  "MONTEMAGNO": "F556",
  "MONTEMALE DI CUNEO": "F558",
  "MONTEMARANO": "F559",
  "MONTEMARCIANO": "F560",
  "MONTEMARZINO": "F562",
  "MONTEMESOLA": "F563",
  "MONTEMEZZO": "F564",
  "MONTEMIGNAIO": "F565",
  "MONTEMILETTO": "F566",
  "MONTEMILONE": "F568",
  "MONTEMITRO": "F569",
  "MONTEMONACO": "F570",
  "MONTEMURLO": "F572",
  "MONTEMURRO": "F573",
  "MONTENARS": "F574",
  "MONTENERO DI BISACCIA": "F576",
  "MONTENERO SABINO": "F579",
  "MONTENERO VAL COCCHIARA": "F580",
  "MONTENERODOMO": "F578",
  "MONTEODORISIO": "F582",
  "MONTEPAONE": "F586",
  "MONTEPARANO": "F587",
  "MONTEPRANDONE": "F591",
  "MONTEPULCIANO": "F592",
  "MONTERCHI": "F594",
  "MONTEREALE": "F595",
  "MONTEREALE VALCELLINA": "F596",
  "MONTERENZIO": "F597",
  "MONTERIGGIONI": "F598",
  "MONTERODUNI": "F601",
  "MONTERONI DARBIA": "F605",
  "MONTERONI DI LECCE": "F604",
  "MONTEROSI": "F606",
  "MONTEROSSO AL MARE": "F609",
  "MONTEROSSO ALMO": "F610",
  "MONTEROSSO CALABRO": "F607",
  "MONTEROSSO GRANA": "F608",
  "MONTEROTONDO": "F611",
  "MONTEROTONDO MARITTIMO": "F612",
  "MONTERUBBIANO": "F614",
  "MONTESANO SALENTINO": "F623",
  "MONTESANO SULLA MARCELLANA": "F625",
  "MONTESARCHIO": "F636",
  "MONTESCAGLIOSO": "F637",
  "MONTESCANO": "F638",
  "MONTESCHENO": "F639",
  "MONTESCUDAIO": "F640",
  "MONTESCUDO-MONTE COLOMBO": "M368",
  "MONTESE": "F642",
  "MONTESEGALE": "F644",
  "MONTESILVANO": "F646",
  "MONTESPERTOLI": "F648",
  "MONTEU DA PO": "F651",
  "MONTEU ROERO": "F654",
  "MONTEVAGO": "F655",
  "MONTEVARCHI": "F656",
  "MONTEVECCHIA": "F657",
  "MONTEVERDE": "F660",
  "MONTEVERDI MARITTIMO": "F661",
  "MONTEVIALE": "F662",
  "MONTEZEMOLO": "F666",
  "MONTI": "F667",
  "MONTIANO": "F668",
  "MONTICELLI BRUSATI": "F672",
  "MONTICELLI DONGINA": "F671",
  "MONTICELLI PAVESE": "F670",
  "MONTICELLO BRIANZA": "F674",
  "MONTICELLO CONTE OTTO": "F675",
  "MONTICELLO DALBA": "F669",
  "MONTICHIARI": "F471",
  "MONTICIANO": "F676",
  "MONTIERI": "F677",
  "MONTIGLIO MONFERRATO": "M302",
  "MONTIGNOSO": "F679",
  "MONTIRONE": "F680",
  "MONTJOVET": "F367",
  "MONTODINE": "F681",
  "MONTOGGIO": "F682",
  "MONTONE": "F685",
  "MONTOPOLI DI SABINA": "F687",
  "MONTOPOLI IN VAL DARNO": "F686",
  "MONTORFANO": "F688",
  "MONTORIO AL VOMANO": "F690",
  "MONTORIO NEI FRENTANI": "F689",
  "MONTORIO ROMANO": "F692",
  "MONTORO": "M330",
  "MONTORSO VICENTINO": "F696",
  "MONTOTTONE": "F697",
  "MONTRESTA": "F698",
  "MONTU BECCARIA": "F701",
  "MONVALLE": "F703",
  "MONZA": "F704",
  "MONZAMBANO": "F705",
  "MONZUNO": "F706",
  "MORANO CALABRO": "F708",
  "MORANO SUL PO": "F707",
  "MORANSENGO": "F709",
  "MORARO": "F710",
  "MORAZZONE": "F711",
  "MORBEGNO": "F712",
  "MORBELLO": "F713",
  "MORCIANO DI LEUCA": "F716",
  "MORCIANO DI ROMAGNA": "F715",
  "MORCONE": "F717",
  "MORDANO": "F718",
  "MORENGO": "F720",
  "MORES": "F721",
  "MORESCO": "F722",
  "MORETTA": "F723",
  "MORFASSO": "F724",
  "MORGANO": "F725",
  "MORGEX": "F726",
  "MORGONGIORI": "F727",
  "MORI": "F728",
  "MORIAGO DELLA BATTAGLIA": "F729",
  "MORICONE": "F730",
  "MORIGERATI": "F731",
  "MORIMONDO": "D033",
  "MORINO": "F732",
  "MORIONDO TORINESE": "F733",
  "MORLUPO": "F734",
  "MORMANNO": "F735",
  "MORNAGO": "F736",
  "MORNESE": "F737",
  "MORNICO AL SERIO": "F738",
  "MORNICO LOSANA": "F739",
  "MOROLO": "F740",
  "MOROZZO": "F743",
  "MORRA DE SANCTIS": "F744",
  "MORRO DALBA": "F745",
  "MORRO DORO": "F747",
  "MORRO REATINO": "F746",
  "MORRONE DEL SANNIO": "F748",
  "MORROVALLE": "F749",
  "MORSANO AL TAGLIAMENTO": "F750",
  "MORSASCO": "F751",
  "MORTARA": "F754",
  "MORTEGLIANO": "F756",
  "MORTERONE": "F758",
  "MORUZZO": "F760",
  "MOSCAZZANO": "F761",
  "MOSCHIANO": "F762",
  "MOSCIANO SANTANGELO": "F764",
  "MOSCUFO": "F765",
  "MOSO IN PASSIRIA": "F766",
  "MOSSA": "F767",
  "MOTTA BALUFFI": "F771",
  "MOTTA CAMASTRA": "F772",
  "MOTTA DAFFERMO": "F773",
  "MOTTA DE CONTI": "F774",
  "MOTTA DI LIVENZA": "F770",
  "MOTTA MONTECORVINO": "F777",
  "MOTTA SAN GIOVANNI": "F779",
  "MOTTA SANTA LUCIA": "F780",
  "MOTTA SANTANASTASIA": "F781",
  "MOTTA VISCONTI": "F783",
  "MOTTAFOLLONE": "F775",
  "MOTTALCIATA": "F776",
  "MOTTEGGIANA": "B012",
  "MOTTOLA": "F784",
  "MOZZAGROGNA": "F785",
  "MOZZANICA": "F786",
  "MOZZATE": "F788",
  "MOZZECANE": "F789",
  "MOZZO": "F791",
  "MUCCIA": "F793",
  "MUGGIA": "F795",
  "MUGGIO": "F797",
  "MUGNANO DEL CARDINALE": "F798",
  "MUGNANO DI NAPOLI": "F799",
  "MULAZZANO": "F801",
  "MULAZZO": "F802",
  "MURA": "F806",
  "MURAVERA": "F808",
  "MURAZZANO": "F809",
  "MURELLO": "F811",
  "MURIALDO": "F813",
  "MURISENGO": "F814",
  "MURLO": "F815",
  "MURO LECCESE": "F816",
  "MURO LUCANO": "F817",
  "MUROS": "F818",
  "MUSCOLINE": "F820",
  "MUSEI": "F822",
  "MUSILE DI PIAVE": "F826",
  "MUSSO": "F828",
  "MUSSOLENTE": "F829",
  "MUSSOMELI": "F830",
  "MUZZANA DEL TURGNANO": "F832",
  "MUZZANO": "F833",
  "NAGO-TORBOLE": "F835",
  "NALLES": "F836",
  "NANTO": "F838",
  "NAPOLI": "F839",
  "NARBOLIA": "F840",
  "NARCAO": "F841",
  "NARDO": "F842",
  "NARDODIPACE": "F843",
  "NARNI": "F844",
  "NARO": "F845",
  "NARZOLE": "F846",
  "NASINO": "F847",
  "NASO": "F848",
  "NATURNO": "F849",
  "NAVE": "F851",
  "NAVELLI": "F852",
  "NAZ-SCIAVES": "F856",
  "NAZZANO": "F857",
  "NE": "F858",
  "NEBBIUNO": "F859",
  "NEGRAR DI VALPOLICELLA": "F861",
  "NEIRONE": "F862",
  "NEIVE": "F863",
  "NEMBRO": "F864",
  "NEMI": "F865",
  "NEMOLI": "F866",
  "NEONELI": "F867",
  "NEPI": "F868",
  "NERETO": "F870",
  "NEROLA": "F871",
  "NERVESA DELLA BATTAGLIA": "F872",
  "NERVIANO": "F874",
  "NESPOLO": "F876",
  "NESSO": "F877",
  "NETRO": "F878",
  "NETTUNO": "F880",
  "NEVIANO": "F881",
  "NEVIANO DEGLI ARDUINI": "F882",
  "NEVIGLIE": "F883",
  "NIARDO": "F884",
  "NIBBIOLA": "F886",
  "NIBIONNO": "F887",
  "NICHELINO": "F889",
  "NICOLOSI": "F890",
  "NICORVO": "F891",
  "NICOSIA": "F892",
  "NICOTERA": "F893",
  "NIELLA BELBO": "F894",
  "NIELLA TANARO": "F895",
  "NIMIS": "F898",
  "NISCEMI": "F899",
  "NISSORIA": "F900",
  "NIZZA DI SICILIA": "F901",
  "NIZZA MONFERRATO": "F902",
  "NOALE": "F904",
  "NOASCA": "F906",
  "NOCARA": "F907",
  "NOCCIANO": "F908",
  "NOCERA INFERIORE": "F912",
  "NOCERA SUPERIORE": "F913",
  "NOCERA TERINESE": "F910",
  "NOCERA UMBRA": "F911",
  "NOCETO": "F914",
  "NOCI": "F915",
  "NOCIGLIA": "F916",
  "NOEPOLI": "F917",
  "NOGARA": "F918",
  "NOGAREDO": "F920",
  "NOGAROLE ROCCA": "F921",
  "NOGAROLE VICENTINO": "F922",
  "NOICATTARO": "F923",
  "NOLA": "F924",
  "NOLE": "F925",
  "NOLI": "F926",
  "NOMAGLIO": "F927",
  "NOMI": "F929",
  "NONANTOLA": "F930",
  "NONE": "F931",
  "NONIO": "F932",
  "NORAGUGUME": "F933",
  "NORBELLO": "F934",
  "NORCIA": "F935",
  "NORMA": "F937",
  "NOSATE": "F939",
  "NOTARESCO": "F942",
  "NOTO": "F943",
  "NOVA LEVANTE": "F949",
  "NOVA MILANESE": "F944",
  "NOVA PONENTE": "F950",
  "NOVA SIRI": "A942",
  "NOVAFELTRIA": "F137",
  "NOVALEDO": "F947",
  "NOVALESA": "F948",
  "NOVARA": "F952",
  "NOVARA DI SICILIA": "F951",
  "NOVATE MEZZOLA": "F956",
  "NOVATE MILANESE": "F955",
  "NOVE": "F957",
  "NOVEDRATE": "F958",
  "NOVELLA": "M430",
  "NOVELLARA": "F960",
  "NOVELLO": "F961",
  "NOVENTA DI PIAVE": "F963",
  "NOVENTA PADOVANA": "F962",
  "NOVENTA VICENTINA": "F964",
  "NOVI DI MODENA": "F966",
  "NOVI LIGURE": "F965",
  "NOVI VELIA": "F967",
  "NOVIGLIO": "F968",
  "NOVOLI": "F970",
  "NUCETTO": "F972",
  "NUGHEDU SAN NICOLO": "F975",
  "NUGHEDU SANTA VITTORIA": "F974",
  "NULE": "F976",
  "NULVI": "F977",
  "NUMANA": "F978",
  "NUORO": "F979",
  "NURACHI": "F980",
  "NURAGUS": "F981",
  "NURALLAO": "F982",
  "NURAMINIS": "F983",
  "NURECI": "F985",
  "NURRI": "F986",
  "NUS": "F987",
  "NUSCO": "F988",
  "NUVOLENTO": "F989",
  "NUVOLERA": "F990",
  "NUXIS": "F991",
  "OCCHIEPPO INFERIORE": "F992",
  "OCCHIEPPO SUPERIORE": "F993",
  "OCCHIOBELLO": "F994",
  "OCCIMIANO": "F995",
  "OCRE": "F996",
  "ODALENGO GRANDE": "F997",
  "ODALENGO PICCOLO": "F998",
  "ODERZO": "F999",
  "ODOLO": "G001",
  "OFENA": "G002",
  "OFFAGNA": "G003",
  "OFFANENGO": "G004",
  "OFFIDA": "G005",
  "OFFLAGA": "G006",
  "OGGEBBIO": "G007",
  "OGGIONA CON SANTO STEFANO": "G008",
  "OGGIONO": "G009",
  "OGLIANICO": "G010",
  "OGLIASTRO CILENTO": "G011",
  "OLBIA": "G015",
  "OLCENENGO": "G016",
  "OLDENICO": "G018",
  "OLEGGIO": "G019",
  "OLEGGIO CASTELLO": "G020",
  "OLEVANO DI LOMELLINA": "G021",
  "OLEVANO ROMANO": "G022",
  "OLEVANO SUL TUSCIANO": "G023",
  "OLGIATE COMASCO": "G025",
  "OLGIATE MOLGORA": "G026",
  "OLGIATE OLONA": "G028",
  "OLGINATE": "G030",
  "OLIENA": "G031",
  "OLIVA GESSI": "G032",
  "OLIVADI": "G034",
  "OLIVERI": "G036",
  "OLIVETO CITRA": "G039",
  "OLIVETO LARIO": "G040",
  "OLIVETO LUCANO": "G037",
  "OLIVETTA SAN MICHELE": "G041",
  "OLIVOLA": "G042",
  "OLLASTRA": "G043",
  "OLLOLAI": "G044",
  "OLLOMONT": "G045",
  "OLMEDO": "G046",
  "OLMENETA": "G047",
  "OLMO AL BREMBO": "G049",
  "OLMO GENTILE": "G048",
  "OLTRE IL COLLE": "G050",
  "OLTRESSENDA ALTA": "G054",
  "OLTRONA DI SAN MAMETTE": "G056",
  "OLZAI": "G058",
  "OME": "G061",
  "OMEGNA": "G062",
  "OMIGNANO": "G063",
  "ONANI": "G064",
  "ONANO": "G065",
  "ONCINO": "G066",
  "ONETA": "G068",
  "ONIFAI": "G070",
  "ONIFERI": "G071",
  "ONO SAN PIETRO": "G074",
  "ONORE": "G075",
  "ONZO": "G076",
  "OPERA": "G078",
  "OPI": "G079",
  "OPPEANO": "G080",
  "OPPIDO LUCANO": "G081",
  "OPPIDO MAMERTINA": "G082",
  "ORA": "G083",
  "ORANI": "G084",
  "ORATINO": "G086",
  "ORBASSANO": "G087",
  "ORBETELLO": "G088",
  "ORCIANO PISANO": "G090",
  "ORCO FEGLINO": "D522",
  "ORDONA": "M266",
  "ORERO": "G093",
  "ORGIANO": "G095",
  "ORGOSOLO": "G097",
  "ORIA": "G098",
  "ORICOLA": "G102",
  "ORIGGIO": "G103",
  "ORINO": "G105",
  "ORIO AL SERIO": "G108",
  "ORIO CANAVESE": "G109",
  "ORIO LITTA": "G107",
  "ORIOLO": "G110",
  "ORIOLO ROMANO": "G111",
  "ORISTANO": "G113",
  "ORMEA": "G114",
  "ORMELLE": "G115",
  "ORNAGO": "G116",
  "ORNAVASSO": "G117",
  "ORNICA": "G118",
  "OROSEI": "G119",
  "OROTELLI": "G120",
  "ORRIA": "G121",
  "ORROLI": "G122",
  "ORSAGO": "G123",
  "ORSARA BORMIDA": "G124",
  "ORSARA DI PUGLIA": "G125",
  "ORSENIGO": "G126",
  "ORSOGNA": "G128",
  "ORSOMARSO": "G129",
  "ORTA DI ATELLA": "G130",
  "ORTA NOVA": "G131",
  "ORTA SAN GIULIO": "G134",
  "ORTACESUS": "G133",
  "ORTE": "G135",
  "ORTELLE": "G136",
  "ORTEZZANO": "G137",
  "ORTIGNANO RAGGIOLO": "G139",
  "ORTISEI": "G140",
  "ORTONA": "G141",
  "ORTONA DEI MARSI": "G142",
  "ORTOVERO": "G144",
  "ORTUCCHIO": "G145",
  "ORTUERI": "G146",
  "ORUNE": "G147",
  "ORVIETO": "G148",
  "ORVINIO": "B595",
  "ORZINUOVI": "G149",
  "ORZIVECCHI": "G150",
  "OSASCO": "G151",
  "OSASIO": "G152",
  "OSCHIRI": "G153",
  "OSIDDA": "G154",
  "OSIGLIA": "G155",
  "OSILO": "G156",
  "OSIMO": "G157",
  "OSINI": "G158",
  "OSIO SOPRA": "G159",
  "OSIO SOTTO": "G160",
  "OSNAGO": "G161",
  "OSOPPO": "G163",
  "OSPEDALETTI": "G164",
  "OSPEDALETTO": "G168",
  "OSPEDALETTO DALPINOLO": "G165",
  "OSPEDALETTO EUGANEO": "G167",
  "OSPEDALETTO LODIGIANO": "G166",
  "OSPITALE DI CADORE": "G169",
  "OSPITALETTO": "G170",
  "OSSAGO LODIGIANO": "G171",
  "OSSANA": "G173",
  "OSSI": "G178",
  "OSSIMO": "G179",
  "OSSONA": "G181",
  "OSTANA": "G183",
  "OSTELLATO": "G184",
  "OSTIANO": "G185",
  "OSTIGLIA": "G186",
  "OSTRA": "F401",
  "OSTRA VETERE": "F581",
  "OSTUNI": "G187",
  "OTRANTO": "G188",
  "OTRICOLI": "G189",
  "OTTANA": "G191",
  "OTTATI": "G192",
  "OTTAVIANO": "G190",
  "OTTIGLIO": "G193",
  "OTTOBIANO": "G194",
  "OTTONE": "G195",
  "OULX": "G196",
  "OVADA": "G197",
  "OVARO": "G198",
  "OVIGLIO": "G199",
  "OVINDOLI": "G200",
  "OVODDA": "G201",
  "OYACE": "G012",
  "OZEGNA": "G202",
  "OZIERI": "G203",
  "OZZANO DELLEMILIA": "G205",
  "OZZANO MONFERRATO": "G204",
  "OZZERO": "G206",
  "PABILLONIS": "G207",
  "PACE DEL MELA": "G209",
  "PACECO": "G208",
  "PACENTRO": "G210",
  "PACHINO": "G211",
  "PACIANO": "G212",
  "PADENGHE SUL GARDA": "G213",
  "PADERNA": "G215",
  "PADERNO DADDA": "G218",
  "PADERNO DUGNANO": "G220",
  "PADERNO FRANCIACORTA": "G217",
  "PADERNO PONCHIELLI": "G222",
  "PADOVA": "G224",
  "PADRIA": "G225",
  "PADRU": "M301",
  "PADULA": "G226",
  "PADULI": "G227",
  "PAESANA": "G228",
  "PAESE": "G229",
  "PAGANI": "G230",
  "PAGANICO SABINO": "G232",
  "PAGAZZANO": "G233",
  "PAGLIARA": "G234",
  "PAGLIETA": "G237",
  "PAGNACCO": "G238",
  "PAGNO": "G240",
  "PAGNONA": "G241",
  "PAGO DEL VALLO DI LAURO": "G242",
  "PAGO VEIANO": "G243",
  "PAISCO LOVENO": "G247",
  "PAITONE": "G248",
  "PALADINA": "G249",
  "PALAGANO": "G250",
  "PALAGIANELLO": "G251",
  "PALAGIANO": "G252",
  "PALAGONIA": "G253",
  "PALAIA": "G254",
  "PALANZANO": "G255",
  "PALATA": "G257",
  "PALAU": "G258",
  "PALAZZAGO": "G259",
  "PALAZZO ADRIANO": "G263",
  "PALAZZO CANAVESE": "G262",
  "PALAZZO PIGNANO": "G260",
  "PALAZZO SAN GERVASIO": "G261",
  "PALAZZOLO ACREIDE": "G267",
  "PALAZZOLO DELLO STELLA": "G268",
  "PALAZZOLO SULLOGLIO": "G264",
  "PALAZZOLO VERCELLESE": "G266",
  "PALAZZUOLO SUL SENIO": "G270",
  "PALENA": "G271",
  "PALERMITI": "G272",
  "PALERMO": "G273",
  "PALESTRINA": "G274",
  "PALESTRO": "G275",
  "PALIANO": "G276",
  "PALIZZI": "G277",
  "PALLAGORIO": "G278",
  "PALLANZENO": "G280",
  "PALLARE": "G281",
  "PALMA CAMPANIA": "G283",
  "PALMA DI MONTECHIARO": "G282",
  "PALMANOVA": "G284",
  "PALMARIGGI": "G285",
  "PALMAS ARBOREA": "G286",
  "PALMI": "G288",
  "PALMIANO": "G289",
  "PALMOLI": "G290",
  "PALO DEL COLLE": "G291",
  "PALOMBARA SABINA": "G293",
  "PALOMBARO": "G294",
  "PALOMONTE": "G292",
  "PALOSCO": "G295",
  "PALU": "G297",
  "PALU DEL FERSINA": "G296",
  "PALUDI": "G298",
  "PALUZZA": "G300",
  "PAMPARATO": "G302",
  "PANCALIERI": "G303",
  "PANCARANA": "G304",
  "PANCHIA": "G305",
  "PANDINO": "G306",
  "PANETTIERI": "G307",
  "PANICALE": "G308",
  "PANNARANO": "G311",
  "PANNI": "G312",
  "PANTELLERIA": "G315",
  "PANTIGLIATE": "G316",
  "PAOLA": "G317",
  "PAOLISI": "G318",
  "PAPASIDERO": "G320",
  "PAPOZZE": "G323",
  "PARABIAGO": "G324",
  "PARABITA": "G325",
  "PARATICO": "G327",
  "PARCINES": "G328",
  "PARELLA": "G330",
  "PARENTI": "G331",
  "PARETE": "G333",
  "PARETO": "G334",
  "PARGHELIA": "G335",
  "PARLASCO": "G336",
  "PARMA": "G337",
  "PARODI LIGURE": "G338",
  "PAROLDO": "G339",
  "PAROLISE": "G340",
  "PARONA": "G342",
  "PARRANO": "G344",
  "PARRE": "G346",
  "PARTANNA": "G347",
  "PARTINICO": "G348",
  "PARUZZARO": "G349",
  "PARZANICA": "G350",
  "PASIAN DI PRATO": "G352",
  "PASIANO DI PORDENONE": "G353",
  "PASPARDO": "G354",
  "PASSERANO MARMORITO": "G358",
  "PASSIGNANO SUL TRASIMENO": "G359",
  "PASSIRANO": "G361",
  "PASTENA": "G362",
  "PASTORANO": "G364",
  "PASTRENGO": "G365",
  "PASTURANA": "G367",
  "PASTURO": "G368",
  "PATERNO": "G371",
  "PATERNO CALABRO": "G372",
  "PATERNOPOLI": "G370",
  "PATRICA": "G374",
  "PATTADA": "G376",
  "PATTI": "G377",
  "PATU": "G378",
  "PAU": "G379",
  "PAULARO": "G381",
  "PAULI ARBAREI": "G382",
  "PAULILATINO": "G384",
  "PAULLO": "G385",
  "PAUPISI": "G386",
  "PAVAROLO": "G387",
  "PAVIA": "G388",
  "PAVIA DI UDINE": "G389",
  "PAVONE CANAVESE": "G392",
  "PAVONE DEL MELLA": "G391",
  "PAVULLO NEL FRIGNANO": "G393",
  "PAZZANO": "G394",
  "PECCIOLI": "G395",
  "PECETTO DI VALENZA": "G397",
  "PECETTO TORINESE": "G398",
  "PEDARA": "G402",
  "PEDASO": "G403",
  "PEDAVENA": "G404",
  "PEDEMONTE": "G406",
  "PEDEROBBA": "G408",
  "PEDESINA": "G410",
  "PEDIVIGLIANO": "G411",
  "PEDRENGO": "G412",
  "PEGLIO": "G416",
  "PEGOGNAGA": "G417",
  "PEIA": "G418",
  "PEIO": "G419",
  "PELAGO": "G420",
  "PELLA": "G421",
  "PELLEGRINO PARMENSE": "G424",
  "PELLEZZANO": "G426",
  "PELLIZZANO": "G428",
  "PELUGO": "G429",
  "PENANGO": "G430",
  "PENNA IN TEVERINA": "G432",
  "PENNA SAN GIOVANNI": "G436",
  "PENNA SANTANDREA": "G437",
  "PENNABILLI": "G433",
  "PENNADOMO": "G434",
  "PENNAPIEDIMONTE": "G435",
  "PENNE": "G438",
  "PENTONE": "G439",
  "PERANO": "G441",
  "PERAROLO DI CADORE": "G442",
  "PERCA": "G443",
  "PERCILE": "G444",
  "PERDASDEFOGU": "G445",
  "PERDAXIUS": "G446",
  "PERDIFUMO": "G447",
  "PERETO": "G449",
  "PERFUGAS": "G450",
  "PERGINE VALSUGANA": "G452",
  "PERGOLA": "G453",
  "PERINALDO": "G454",
  "PERITO": "G455",
  "PERLEDO": "G456",
  "PERLETTO": "G457",
  "PERLO": "G458",
  "PERLOZ": "G459",
  "PERNUMIA": "G461",
  "PERO": "C013",
  "PEROSA ARGENTINA": "G463",
  "PEROSA CANAVESE": "G462",
  "PERRERO": "G465",
  "PERSICO DOSIMO": "G469",
  "PERTENGO": "G471",
  "PERTICA ALTA": "G474",
  "PERTICA BASSA": "G475",
  "PERTOSA": "G476",
  "PERTUSIO": "G477",
  "PERUGIA": "G478",
  "PESARO": "G479",
  "PESCAGLIA": "G480",
  "PESCANTINA": "G481",
  "PESCARA": "G482",
  "PESCAROLO ED UNITI": "G483",
  "PESCASSEROLI": "G484",
  "PESCATE": "G485",
  "PESCHE": "G486",
  "PESCHICI": "G487",
  "PESCHIERA BORROMEO": "G488",
  "PESCHIERA DEL GARDA": "G489",
  "PESCIA": "G491",
  "PESCINA": "G492",
  "PESCO SANNITA": "G494",
  "PESCOCOSTANZO": "G493",
  "PESCOLANCIANO": "G495",
  "PESCOPAGANO": "G496",
  "PESCOPENNATARO": "G497",
  "PESCOROCCHIANO": "G498",
  "PESCOSANSONESCO": "G499",
  "PESCOSOLIDO": "G500",
  "PESSANO CON BORNAGO": "G502",
  "PESSINA CREMONESE": "G504",
  "PESSINETTO": "G505",
  "PETACCIATO": "G506",
  "PETILIA POLICASTRO": "G508",
  "PETINA": "G509",
  "PETRALIA SOPRANA": "G510",
  "PETRALIA SOTTANA": "G511",
  "PETRELLA SALTO": "G513",
  "PETRELLA TIFERNINA": "G512",
  "PETRIANO": "G514",
  "PETRIOLO": "G515",
  "PETRITOLI": "G516",
  "PETRIZZI": "G517",
  "PETRONA": "G518",
  "PETROSINO": "M281",
  "PETRURO IRPINO": "G519",
  "PETTENASCO": "G520",
  "PETTINENGO": "G521",
  "PETTINEO": "G522",
  "PETTORANELLO DEL MOLISE": "G523",
  "PETTORANO SUL GIZIO": "G524",
  "PETTORAZZA GRIMANI": "G525",
  "PEVERAGNO": "G526",
  "PEZZANA": "G528",
  "PEZZAZE": "G529",
  "PEZZOLO VALLE UZZONE": "G532",
  "PIACENZA": "G535",
  "PIACENZA DADIGE": "G534",
  "PIADENA DRIZZONA": "M418",
  "PIAGGINE": "G538",
  "PIAN CAMUNO": "G546",
  "PIANA CRIXIA": "G542",
  "PIANA DEGLI ALBANESI": "G543",
  "PIANA DI MONTE VERNA": "G541",
  "PIANCASTAGNAIO": "G547",
  "PIANCOGNO": "G549",
  "PIANDIMELETO": "G551",
  "PIANE CRATI": "G553",
  "PIANELLA": "G555",
  "PIANELLO DEL LARIO": "G556",
  "PIANELLO VAL TIDONE": "G557",
  "PIANENGO": "G558",
  "PIANEZZA": "G559",
  "PIANEZZE": "G560",
  "PIANFEI": "G561",
  "PIANICO": "G564",
  "PIANIGA": "G565",
  "PIANO DI SORRENTO": "G568",
  "PIANOPOLI": "D546",
  "PIANORO": "G570",
  "PIANSANO": "G571",
  "PIANTEDO": "G572",
  "PIARIO": "G574",
  "PIASCO": "G575",
  "PIATEDA": "G576",
  "PIATTO": "G577",
  "PIAZZA AL SERCHIO": "G582",
  "PIAZZA ARMERINA": "G580",
  "PIAZZA BREMBANA": "G579",
  "PIAZZATORRE": "G583",
  "PIAZZOLA SUL BRENTA": "G587",
  "PIAZZOLO": "G588",
  "PICCIANO": "G589",
  "PICERNO": "G590",
  "PICINISCO": "G591",
  "PICO": "G592",
  "PIEA": "G593",
  "PIEDICAVALLO": "G594",
  "PIEDIMONTE ETNEO": "G597",
  "PIEDIMONTE MATESE": "G596",
  "PIEDIMONTE SAN GERMANO": "G598",
  "PIEDIMULERA": "G600",
  "PIEGARO": "G601",
  "PIENZA": "G602",
  "PIERANICA": "G603",
  "PIETRA DE GIORGI": "G612",
  "PIETRA LIGURE": "G605",
  "PIETRA MARAZZI": "G619",
  "PIETRABBONDANTE": "G606",
  "PIETRABRUNA": "G607",
  "PIETRACAMELA": "G608",
  "PIETRACATELLA": "G609",
  "PIETRACUPA": "G610",
  "PIETRADEFUSI": "G611",
  "PIETRAFERRAZZANA": "G613",
  "PIETRAFITTA": "G615",
  "PIETRAGALLA": "G616",
  "PIETRALUNGA": "G618",
  "PIETRAMELARA": "G620",
  "PIETRAMONTECORVINO": "G604",
  "PIETRANICO": "G621",
  "PIETRAPAOLA": "G622",
  "PIETRAPERTOSA": "G623",
  "PIETRAPERZIA": "G624",
  "PIETRAPORZIO": "G625",
  "PIETRAROJA": "G626",
  "PIETRARUBBIA": "G627",
  "PIETRASANTA": "G628",
  "PIETRASTORNINA": "G629",
  "PIETRAVAIRANO": "G630",
  "PIETRELCINA": "G631",
  "PIEVE A NIEVOLE": "G636",
  "PIEVE ALBIGNOLA": "G635",
  "PIEVE DEL CAIRO": "G639",
  "PIEVE DEL GRAPPA": "M422",
  "PIEVE DI BONO-PREZZO": "M365",
  "PIEVE DI CADORE": "G642",
  "PIEVE DI CENTO": "G643",
  "PIEVE DI SOLIGO": "G645",
  "PIEVE DI TECO": "G632",
  "PIEVE DOLMI": "G647",
  "PIEVE EMANUELE": "G634",
  "PIEVE FISSIRAGA": "G096",
  "PIEVE FOSCIANA": "G648",
  "PIEVE LIGURE": "G646",
  "PIEVE PORTO MORONE": "G650",
  "PIEVE SAN GIACOMO": "G651",
  "PIEVE SANTO STEFANO": "G653",
  "PIEVE TESINO": "G656",
  "PIEVE TORINA": "G657",
  "PIEVE VERGONTE": "G658",
  "PIEVEPELAGO": "G649",
  "PIGLIO": "G659",
  "PIGNA": "G660",
  "PIGNATARO INTERAMNA": "G662",
  "PIGNATARO MAGGIORE": "G661",
  "PIGNOLA": "G663",
  "PIGNONE": "G664",
  "PIGRA": "G665",
  "PILA": "G666",
  "PIMENTEL": "G669",
  "PIMONTE": "G670",
  "PINAROLO PO": "G671",
  "PINASCA": "G672",
  "PINCARA": "G673",
  "PINEROLO": "G674",
  "PINETO": "F831",
  "PINO DASTI": "G676",
  "PINO TORINESE": "G678",
  "PINZANO AL TAGLIAMENTO": "G680",
  "PINZOLO": "G681",
  "PIOBBICO": "G682",
  "PIOBESI DALBA": "G683",
  "PIOBESI TORINESE": "G684",
  "PIODE": "G685",
  "PIOLTELLO": "G686",
  "PIOMBINO": "G687",
  "PIOMBINO DESE": "G688",
  "PIORACO": "G690",
  "PIOSSASCO": "G691",
  "PIOVA MASSAIA": "G692",
  "PIOVE DI SACCO": "G693",
  "PIOVENE ROCCHETTE": "G694",
  "PIOZZANO": "G696",
  "PIOZZO": "G697",
  "PIRAINO": "G699",
  "PISA": "G702",
  "PISANO": "G703",
  "PISCINA": "G705",
  "PISCINAS": "M291",
  "PISCIOTTA": "G707",
  "PISOGNE": "G710",
  "PISONIANO": "G704",
  "PISTICCI": "G712",
  "PISTOIA": "G713",
  "PITIGLIANO": "G716",
  "PIUBEGA": "G717",
  "PIURO": "G718",
  "PIVERONE": "G719",
  "PIZZALE": "G720",
  "PIZZIGHETTONE": "G721",
  "PIZZO": "G722",
  "PIZZOFERRATO": "G724",
  "PIZZOLI": "G726",
  "PIZZONE": "G727",
  "PIZZONI": "G728",
  "PLACANICA": "G729",
  "PLATACI": "G733",
  "PLATANIA": "G734",
  "PLATI": "G735",
  "PLAUS": "G299",
  "PLESIO": "G737",
  "PLOAGHE": "G740",
  "PLODIO": "G741",
  "POCAPAGLIA": "G742",
  "POCENIA": "G743",
  "PODENZANA": "G746",
  "PODENZANO": "G747",
  "POFI": "G749",
  "POGGIARDO": "G751",
  "POGGIBONSI": "G752",
  "POGGIO A CAIANO": "G754",
  "POGGIO BUSTONE": "G756",
  "POGGIO CATINO": "G757",
  "POGGIO IMPERIALE": "G761",
  "POGGIO MIRTETO": "G763",
  "POGGIO MOIANO": "G764",
  "POGGIO NATIVO": "G765",
  "POGGIO PICENZE": "G766",
  "POGGIO RENATICO": "G768",
  "POGGIO RUSCO": "G753",
  "POGGIO SAN LORENZO": "G770",
  "POGGIO SAN MARCELLO": "G771",
  "POGGIO SAN VICINO": "D566",
  "POGGIO SANNITA": "B317",
  "POGGIO TORRIANA": "M324",
  "POGGIODOMO": "G758",
  "POGGIOFIORITO": "G760",
  "POGGIOMARINO": "G762",
  "POGGIOREALE": "G767",
  "POGGIORSINI": "G769",
  "POGGIRIDENTI": "G431",
  "POGLIANO MILANESE": "G772",
  "POGNANA LARIO": "G773",
  "POGNANO": "G774",
  "POGNO": "G775",
  "POIRINO": "G777",
  "POJANA MAGGIORE": "G776",
  "POLAVENO": "G779",
  "POLCENIGO": "G780",
  "POLESELLA": "G782",
  "POLESINE ZIBELLO": "M367",
  "POLI": "G784",
  "POLIA": "G785",
  "POLICORO": "G786",
  "POLIGNANO A MARE": "G787",
  "POLINAGO": "G789",
  "POLINO": "G790",
  "POLISTENA": "G791",
  "POLIZZI GENEROSA": "G792",
  "POLLA": "G793",
  "POLLEIN": "G794",
  "POLLENA TROCCHIA": "G795",
  "POLLENZA": "F567",
  "POLLICA": "G796",
  "POLLINA": "G797",
  "POLLONE": "G798",
  "POLLUTRI": "G799",
  "POLONGHERA": "G800",
  "POLPENAZZE DEL GARDA": "G801",
  "POLVERARA": "G802",
  "POLVERIGI": "G803",
  "POMARANCE": "G804",
  "POMARETTO": "G805",
  "POMARICO": "G806",
  "POMARO MONFERRATO": "G807",
  "POMAROLO": "G808",
  "POMBIA": "G809",
  "POMEZIA": "G811",
  "POMIGLIANO DARCO": "G812",
  "POMPEI": "G813",
  "POMPEIANA": "G814",
  "POMPIANO": "G815",
  "POMPONESCO": "G816",
  "POMPU": "G817",
  "PONCARALE": "G818",
  "PONDERANO": "G820",
  "PONNA": "G821",
  "PONSACCO": "G822",
  "PONSO": "G823",
  "PONT-CANAVESE": "G826",
  "PONT-SAINT-MARTIN": "G854",
  "PONTASSIEVE": "G825",
  "PONTBOSET": "G545",
  "PONTE": "G827",
  "PONTE BUGGIANESE": "G833",
  "PONTE DELLOLIO": "G842",
  "PONTE DI LEGNO": "G844",
  "PONTE DI PIAVE": "G846",
  "PONTE GARDENA": "G830",
  "PONTE IN VALTELLINA": "G829",
  "PONTE LAMBRO": "G847",
  "PONTE NELLE ALPI": "B662",
  "PONTE NIZZA": "G851",
  "PONTE NOSSA": "F941",
  "PONTE SAN NICOLO": "G855",
  "PONTE SAN PIETRO": "G856",
  "PONTEBBA": "G831",
  "PONTECAGNANO FAIANO": "G834",
  "PONTECCHIO POLESINE": "G836",
  "PONTECHIANALE": "G837",
  "PONTECORVO": "G838",
  "PONTECURONE": "G839",
  "PONTEDASSIO": "G840",
  "PONTEDERA": "G843",
  "PONTELANDOLFO": "G848",
  "PONTELATONE": "G849",
  "PONTELONGO": "G850",
  "PONTENURE": "G852",
  "PONTERANICA": "G853",
  "PONTESTURA": "G858",
  "PONTEVICO": "G859",
  "PONTEY": "G860",
  "PONTI": "G861",
  "PONTI SUL MINCIO": "G862",
  "PONTIDA": "G864",
  "PONTINIA": "G865",
  "PONTINVREA": "G866",
  "PONTIROLO NUOVO": "G867",
  "PONTOGLIO": "G869",
  "PONTREMOLI": "G870",
  "PONZA": "G871",
  "PONZANO DI FERMO": "G873",
  "PONZANO MONFERRATO": "G872",
  "PONZANO ROMANO": "G874",
  "PONZANO VENETO": "G875",
  "PONZONE": "G877",
  "POPOLI": "G878",
  "POPPI": "G879",
  "PORANO": "G881",
  "PORCARI": "G882",
  "PORCIA": "G886",
  "PORDENONE": "G888",
  "PORLEZZA": "G889",
  "PORNASSIO": "G890",
  "PORPETTO": "G891",
  "PORTACOMARO": "G894",
  "PORTALBERA": "G895",
  "PORTE": "G900",
  "PORTE DI RENDENA": "M358",
  "PORTICI": "G902",
  "PORTICO DI CASERTA": "G903",
  "PORTICO E SAN BENEDETTO": "G904",
  "PORTIGLIOLA": "G905",
  "PORTO AZZURRO": "E680",
  "PORTO CERESIO": "G906",
  "PORTO CESAREO": "M263",
  "PORTO EMPEDOCLE": "F299",
  "PORTO MANTOVANO": "G917",
  "PORTO RECANATI": "G919",
  "PORTO SAN GIORGIO": "G920",
  "PORTO SANTELPIDIO": "G921",
  "PORTO TOLLE": "G923",
  "PORTO TORRES": "G924",
  "PORTO VALTRAVAGLIA": "G907",
  "PORTO VIRO": "G926",
  "PORTOBUFFOLE": "G909",
  "PORTOCANNONE": "G910",
  "PORTOFERRAIO": "G912",
  "PORTOFINO": "G913",
  "PORTOGRUARO": "G914",
  "PORTOMAGGIORE": "G916",
  "PORTOPALO DI CAPO PASSERO": "M257",
  "PORTOSCUSO": "G922",
  "PORTOVENERE": "G925",
  "PORTULA": "G927",
  "POSADA": "G929",
  "POSINA": "G931",
  "POSITANO": "G932",
  "POSSAGNO": "G933",
  "POSTA": "G934",
  "POSTA FIBRENO": "G935",
  "POSTAL": "G936",
  "POSTALESIO": "G937",
  "POSTIGLIONE": "G939",
  "POSTUA": "G940",
  "POTENZA": "G942",
  "POTENZA PICENA": "F632",
  "POVE DEL GRAPPA": "G943",
  "POVEGLIANO": "G944",
  "POVEGLIANO VERONESE": "G945",
  "POVIGLIO": "G947",
  "POVOLETTO": "G949",
  "POZZAGLIA SABINA": "G951",
  "POZZAGLIO ED UNITI": "B914",
  "POZZALLO": "G953",
  "POZZILLI": "G954",
  "POZZO DADDA": "G955",
  "POZZOL GROPPO": "G960",
  "POZZOLENGO": "G959",
  "POZZOLEONE": "G957",
  "POZZOLO FORMIGARO": "G961",
  "POZZOMAGGIORE": "G962",
  "POZZONOVO": "G963",
  "POZZUOLI": "G964",
  "POZZUOLO DEL FRIULI": "G966",
  "POZZUOLO MARTESANA": "G965",
  "PRADALUNGA": "G968",
  "PRADAMANO": "G969",
  "PRADLEVES": "G970",
  "PRAGELATO": "G973",
  "PRAIA A MARE": "G975",
  "PRAIANO": "G976",
  "PRALBOINO": "G977",
  "PRALI": "G978",
  "PRALORMO": "G979",
  "PRALUNGO": "G980",
  "PRAMAGGIORE": "G981",
  "PRAMOLLO": "G982",
  "PRAROLO": "G985",
  "PRAROSTINO": "G986",
  "PRASCO": "G987",
  "PRASCORSANO": "G988",
  "PRATA CAMPORTACCIO": "G993",
  "PRATA DANSIDONIA": "G992",
  "PRATA DI PORDENONE": "G994",
  "PRATA DI PRINCIPATO ULTRA": "G990",
  "PRATA SANNITA": "G991",
  "PRATELLA": "G995",
  "PRATIGLIONE": "G997",
  "PRATO": "G999",
  "PRATO ALLO STELVIO": "H004",
  "PRATO CARNICO": "H002",
  "PRATO SESIA": "H001",
  "PRATOLA PELIGNA": "H007",
  "PRATOLA SERRA": "H006",
  "PRATOVECCHIO STIA": "M329",
  "PRAVISDOMINI": "H010",
  "PRAY": "G974",
  "PRAZZO": "H011",
  "PRE-SAINT-DIDIER": "H042",
  "PRECENICCO": "H014",
  "PRECI": "H015",
  "PREDAIA": "M344",
  "PREDAPPIO": "H017",
  "PREDAZZO": "H018",
  "PREDOI": "H019",
  "PREDORE": "H020",
  "PREDOSA": "H021",
  "PREGANZIOL": "H022",
  "PREGNANA MILANESE": "H026",
  "PRELA": "H027",
  "PREMANA": "H028",
  "PREMARIACCO": "H029",
  "PREMENO": "H030",
  "PREMIA": "H033",
  "PREMILCUORE": "H034",
  "PREMOLO": "H036",
  "PREMOSELLO-CHIOVENDA": "H037",
  "PREONE": "H038",
  "PREPOTTO": "H040",
  "PRESEGLIE": "H043",
  "PRESENZANO": "H045",
  "PRESEZZO": "H046",
  "PRESICCE-ACQUARICA": "M428",
  "PRESSANA": "H048",
  "PRETORO": "H052",
  "PREVALLE": "H055",
  "PREZZA": "H056",
  "PRIERO": "H059",
  "PRIGNANO CILENTO": "H062",
  "PRIGNANO SULLA SECCHIA": "H061",
  "PRIMALUNA": "H063",
  "PRIMIERO SAN MARTINO DI CASTROZZA": "M359",
  "PRIOCCA": "H068",
  "PRIOLA": "H069",
  "PRIOLO GARGALLO": "M279",
  "PRIVERNO": "G698",
  "PRIZZI": "H070",
  "PROCENO": "H071",
  "PROCIDA": "H072",
  "PROPATA": "H073",
  "PROSERPIO": "H074",
  "PROSSEDI": "H076",
  "PROVAGLIO DISEO": "H078",
  "PROVAGLIO VAL SABBIA": "H077",
  "PROVES": "H081",
  "PROVVIDENTI": "H083",
  "PRUNETTO": "H085",
  "PUEGNAGO DEL GARDA": "H086",
  "PUGLIANELLO": "H087",
  "PULA": "H088",
  "PULFERO": "H089",
  "PULSANO": "H090",
  "PUMENENGO": "H091",
  "PUSIANO": "H094",
  "PUTIFIGARI": "H095",
  "PUTIGNANO": "H096",
  "QUADRELLE": "H097",
  "QUADRI": "H098",
  "QUAGLIUZZO": "H100",
  "QUALIANO": "H101",
  "QUARANTI": "H102",
  "QUAREGNA CERRETO": "M414",
  "QUARGNENTO": "H104",
  "QUARNA SOPRA": "H106",
  "QUARNA SOTTO": "H107",
  "QUARONA": "H108",
  "QUARRATA": "H109",
  "QUART": "H110",
  "QUARTO": "H114",
  "QUARTO DALTINO": "H117",
  "QUARTU SANTELENA": "H118",
  "QUARTUCCIU": "H119",
  "QUASSOLO": "H120",
  "QUATTORDIO": "H121",
  "QUATTRO CASTELLA": "H122",
  "QUERO VAS": "M332",
  "QUILIANO": "H126",
  "QUINCINETTO": "H127",
  "QUINDICI": "H128",
  "QUINGENTOLE": "H129",
  "QUINTANO": "H130",
  "QUINTO DI TREVISO": "H131",
  "QUINTO VERCELLESE": "H132",
  "QUINTO VICENTINO": "H134",
  "QUINZANO DOGLIO": "H140",
  "QUISTELLO": "H143",
  "RABBI": "H146",
  "RACALE": "H147",
  "RACALMUTO": "H148",
  "RACCONIGI": "H150",
  "RACCUJA": "H151",
  "RACINES": "H152",
  "RADDA IN CHIANTI": "H153",
  "RADDUSA": "H154",
  "RADICOFANI": "H156",
  "RADICONDOLI": "H157",
  "RAFFADALI": "H159",
  "RAGALNA": "M287",
  "RAGOGNA": "H161",
  "RAGUSA": "H163",
  "RAIANO": "H166",
  "RAMACCA": "H168",
  "RANCIO VALCUVIA": "H173",
  "RANCO": "H174",
  "RANDAZZO": "H175",
  "RANICA": "H176",
  "RANZANICO": "H177",
  "RANZO": "H180",
  "RAPAGNANO": "H182",
  "RAPALLO": "H183",
  "RAPINO": "H184",
  "RAPOLANO TERME": "H185",
  "RAPOLLA": "H186",
  "RAPONE": "H187",
  "RASSA": "H188",
  "RASUN-ANTERSELVA": "H189",
  "RASURA": "H192",
  "RAVANUSA": "H194",
  "RAVARINO": "H195",
  "RAVASCLETTO": "H196",
  "RAVELLO": "H198",
  "RAVENNA": "H199",
  "RAVEO": "H200",
  "RAVISCANINA": "H202",
  "RE": "H203",
  "REA": "H204",
  "REALMONTE": "H205",
  "REANA DEL ROJALE": "H206",
  "REANO": "H207",
  "RECALE": "H210",
  "RECANATI": "H211",
  "RECCO": "H212",
  "RECETTO": "H213",
  "RECOARO TERME": "H214",
  "REDAVALLE": "H216",
  "REDONDESCO": "H218",
  "REFRANCORE": "H219",
  "REFRONTOLO": "H220",
  "REGALBUTO": "H221",
  "REGGELLO": "H222",
  "REGGIO CALABRIA": "H224",
  "REGGIO DI CALABRIA": "H224",
  "REGGIO EMILIA": "H223",
  "REGGIO NELLEMILIA": "H223",
  "REGGIOLO": "H225",
  "REINO": "H227",
  "REITANO": "H228",
  "REMANZACCO": "H229",
  "REMEDELLO": "H230",
  "RENATE": "H233",
  "RENDE": "H235",
  "RENON": "H236",
  "RESANA": "H238",
  "RESCALDINA": "H240",
  "RESIA": "H242",
  "RESIUTTA": "H244",
  "RESUTTANO": "H245",
  "RETORBIDO": "H246",
  "REVELLO": "H247",
  "REVIGLIASCO DASTI": "H250",
  "REVINE LAGO": "H253",
  "REZZAGO": "H255",
  "REZZATO": "H256",
  "REZZO": "H257",
  "REZZOAGLIO": "H258",
  "RHEMES-NOTRE-DAME": "H262",
  "RHEMES-SAINT-GEORGES": "H263",
  "RHO": "H264",
  "RIACE": "H265",
  "RIALTO": "H266",
  "RIANO": "H267",
  "RIARDO": "H268",
  "RIBERA": "H269",
  "RIBORDONE": "H270",
  "RICADI": "H271",
  "RICALDONE": "H272",
  "RICCIA": "H273",
  "RICCIONE": "H274",
  "RICCO DEL GOLFO DI SPEZIA": "H275",
  "RICENGO": "H276",
  "RICIGLIANO": "H277",
  "RIESE PIO X": "H280",
  "RIESI": "H281",
  "RIETI": "H282",
  "RIFIANO": "H284",
  "RIFREDDO": "H285",
  "RIGNANO FLAMINIO": "H288",
  "RIGNANO GARGANICO": "H287",
  "RIGNANO SULLARNO": "H286",
  "RIGOLATO": "H289",
  "RIMELLA": "H293",
  "RIMINI": "H294",
  "RIO": "M391",
  "RIO DI PUSTERIA": "H299",
  "RIO SALICETO": "H298",
  "RIOFREDDO": "H300",
  "RIOLA SARDO": "H301",
  "RIOLO TERME": "H302",
  "RIOLUNATO": "H303",
  "RIOMAGGIORE": "H304",
  "RIONERO IN VULTURE": "H307",
  "RIONERO SANNITICO": "H308",
  "RIPA TEATINA": "H320",
  "RIPABOTTONI": "H311",
  "RIPACANDIDA": "H312",
  "RIPALIMOSANI": "H313",
  "RIPALTA ARPINA": "H314",
  "RIPALTA CREMASCA": "H315",
  "RIPALTA GUERINA": "H316",
  "RIPARBELLA": "H319",
  "RIPATRANSONE": "H321",
  "RIPE SAN GINESIO": "H323",
  "RIPI": "H324",
  "RIPOSTO": "H325",
  "RITTANA": "H326",
  "RIVA DEL GARDA": "H330",
  "RIVA DEL PO": "M410",
  "RIVA DI SOLTO": "H331",
  "RIVA LIGURE": "H328",
  "RIVA PRESSO CHIERI": "H337",
  "RIVALBA": "H333",
  "RIVALTA BORMIDA": "H334",
  "RIVALTA DI TORINO": "H335",
  "RIVAMONTE AGORDINO": "H327",
  "RIVANAZZANO TERME": "H336",
  "RIVARA": "H338",
  "RIVAROLO CANAVESE": "H340",
  "RIVAROLO DEL RE ED UNITI": "H341",
  "RIVAROLO MANTOVANO": "H342",
  "RIVARONE": "H343",
  "RIVAROSSA": "H344",
  "RIVE": "H346",
  "RIVE DARCANO": "H347",
  "RIVELLO": "H348",
  "RIVERGARO": "H350",
  "RIVIGNANO TEOR": "M317",
  "RIVISONDOLI": "H353",
  "RIVODUTRI": "H354",
  "RIVOLI": "H355",
  "RIVOLI VERONESE": "H356",
  "RIVOLTA DADDA": "H357",
  "RIZZICONI": "H359",
  "ROANA": "H361",
  "ROASCHIA": "H362",
  "ROASCIO": "H363",
  "ROASIO": "H365",
  "ROATTO": "H366",
  "ROBASSOMERO": "H367",
  "ROBBIATE": "G223",
  "ROBBIO": "H369",
  "ROBECCHETTO CON INDUNO": "H371",
  "ROBECCO DOGLIO": "H372",
  "ROBECCO PAVESE": "H375",
  "ROBECCO SUL NAVIGLIO": "H373",
  "ROBELLA": "H376",
  "ROBILANTE": "H377",
  "ROBURENT": "H378",
  "ROCCA CANAVESE": "H386",
  "ROCCA CANTERANO": "H387",
  "ROCCA CIGLIE": "H391",
  "ROCCA DARAZZO": "H392",
  "ROCCA DARCE": "H393",
  "ROCCA DE BALDI": "H395",
  "ROCCA DE GIORGI": "H396",
  "ROCCA DEVANDRO": "H398",
  "ROCCA DI BOTTE": "H399",
  "ROCCA DI CAMBIO": "H400",
  "ROCCA DI CAVE": "H401",
  "ROCCA DI MEZZO": "H402",
  "ROCCA DI NETO": "H403",
  "ROCCA DI PAPA": "H404",
  "ROCCA GRIMALDA": "H414",
  "ROCCA IMPERIALE": "H416",
  "ROCCA MASSIMA": "H421",
  "ROCCA PIA": "H429",
  "ROCCA PIETORE": "H379",
  "ROCCA PRIORA": "H432",
  "ROCCA SAN CASCIANO": "H437",
  "ROCCA SAN FELICE": "H438",
  "ROCCA SAN GIOVANNI": "H439",
  "ROCCA SANTA MARIA": "H440",
  "ROCCA SANTO STEFANO": "H441",
  "ROCCA SINIBALDA": "H446",
  "ROCCA SUSELLA": "H450",
  "ROCCABASCERANA": "H382",
  "ROCCABERNARDA": "H383",
  "ROCCABIANCA": "H384",
  "ROCCABRUNA": "H385",
  "ROCCACASALE": "H389",
  "ROCCADASPIDE": "H394",
  "ROCCAFIORITA": "H405",
  "ROCCAFLUVIONE": "H390",
  "ROCCAFORTE DEL GRECO": "H408",
  "ROCCAFORTE LIGURE": "H406",
  "ROCCAFORTE MONDOVI": "H407",
  "ROCCAFORZATA": "H409",
  "ROCCAFRANCA": "H410",
  "ROCCAGIOVINE": "H411",
  "ROCCAGLORIOSA": "H412",
  "ROCCAGORGA": "H413",
  "ROCCALBEGNA": "H417",
  "ROCCALUMERA": "H418",
  "ROCCAMANDOLFI": "H420",
  "ROCCAMENA": "H422",
  "ROCCAMONFINA": "H423",
  "ROCCAMONTEPIANO": "H424",
  "ROCCAMORICE": "H425",
  "ROCCANOVA": "H426",
  "ROCCANTICA": "H427",
  "ROCCAPALUMBA": "H428",
  "ROCCAPIEMONTE": "H431",
  "ROCCARAINOLA": "H433",
  "ROCCARASO": "H434",
  "ROCCAROMANA": "H436",
  "ROCCASCALEGNA": "H442",
  "ROCCASECCA": "H443",
  "ROCCASECCA DEI VOLSCI": "H444",
  "ROCCASICURA": "H445",
  "ROCCASPARVERA": "H447",
  "ROCCASPINALVETI": "H448",
  "ROCCASTRADA": "H449",
  "ROCCAVALDINA": "H380",
  "ROCCAVERANO": "H451",
  "ROCCAVIGNALE": "H452",
  "ROCCAVIONE": "H453",
  "ROCCAVIVARA": "H454",
  "ROCCELLA IONICA": "H456",
  "ROCCELLA VALDEMONE": "H455",
  "ROCCHETTA A VOLTURNO": "H458",
  "ROCCHETTA BELBO": "H462",
  "ROCCHETTA DI VARA": "H461",
  "ROCCHETTA E CROCE": "H459",
  "ROCCHETTA LIGURE": "H465",
  "ROCCHETTA NERVINA": "H460",
  "ROCCHETTA PALAFEA": "H466",
  "ROCCHETTA SANTANTONIO": "H467",
  "ROCCHETTA TANARO": "H468",
  "RODANO": "H470",
  "RODDI": "H472",
  "RODDINO": "H473",
  "RODELLO": "H474",
  "RODENGO": "H475",
  "RODENGO SAIANO": "H477",
  "RODERO": "H478",
  "RODI GARGANICO": "H480",
  "RODI MILICI": "H479",
  "RODIGO": "H481",
  "ROE VOLCIANO": "H484",
  "ROFRANO": "H485",
  "ROGENO": "H486",
  "ROGGIANO GRAVINA": "H488",
  "ROGHUDI": "H489",
  "ROGLIANO": "H490",
  "ROGNANO": "H491",
  "ROGNO": "H492",
  "ROGOLO": "H493",
  "ROIATE": "H494",
  "ROIO DEL SANGRO": "H495",
  "ROISAN": "H497",
  "ROLETTO": "H498",
  "ROLO": "H500",
  "ROMA": "H501",
  "ROMAGNANO AL MONTE": "H503",
  "ROMAGNANO SESIA": "H502",
  "ROMAGNESE": "H505",
  "ROMANA": "H507",
  "ROMANENGO": "H508",
  "ROMANO CANAVESE": "H511",
  "ROMANO DEZZELINO": "H512",
  "ROMANO DI LOMBARDIA": "H509",
  "ROMANS DISONZO": "H514",
  "ROMBIOLO": "H516",
  "ROMENO": "H517",
  "ROMENTINO": "H518",
  "ROMETTA": "H519",
  "RONAGO": "H521",
  "RONCA": "H522",
  "RONCADE": "H523",
  "RONCADELLE": "H525",
  "RONCARO": "H527",
  "RONCEGNO TERME": "H528",
  "RONCELLO": "H529",
  "RONCHI DEI LEGIONARI": "H531",
  "RONCHI VALSUGANA": "H532",
  "RONCHIS": "H533",
  "RONCIGLIONE": "H534",
  "RONCO ALLADIGE": "H540",
  "RONCO BIELLESE": "H538",
  "RONCO BRIANTINO": "H537",
  "RONCO CANAVESE": "H539",
  "RONCO SCRIVIA": "H536",
  "RONCOBELLO": "H535",
  "RONCOFERRARO": "H541",
  "RONCOFREDDO": "H542",
  "RONCOLA": "H544",
  "RONDANINA": "H546",
  "RONDISSONE": "H547",
  "RONSECCO": "H549",
  "RONZO-CHIENIS": "M303",
  "RONZONE": "H552",
  "ROPPOLO": "H553",
  "RORA": "H554",
  "ROSA": "H556",
  "ROSARNO": "H558",
  "ROSASCO": "H559",
  "ROSATE": "H560",
  "ROSAZZA": "H561",
  "ROSCIANO": "H562",
  "ROSCIGNO": "H564",
  "ROSE": "H565",
  "ROSELLO": "H566",
  "ROSETO CAPO SPULICO": "H572",
  "ROSETO DEGLI ABRUZZI": "F585",
  "ROSETO VALFORTORE": "H568",
  "ROSIGNANO MARITTIMO": "H570",
  "ROSIGNANO MONFERRATO": "H569",
  "ROSOLINA": "H573",
  "ROSOLINI": "H574",
  "ROSORA": "H575",
  "ROSSA": "H577",
  "ROSSANA": "H578",
  "ROSSANO VENETO": "H580",
  "ROSSIGLIONE": "H581",
  "ROSTA": "H583",
  "ROTA DIMAGNA": "H584",
  "ROTA GRECA": "H585",
  "ROTELLA": "H588",
  "ROTELLO": "H589",
  "ROTONDA": "H590",
  "ROTONDELLA": "H591",
  "ROTONDI": "H592",
  "ROTTOFRENO": "H593",
  "ROTZO": "H594",
  "ROURE": "H555",
  "ROVASENDA": "H364",
  "ROVATO": "H598",
  "ROVEGNO": "H599",
  "ROVELLASCA": "H601",
  "ROVELLO PORRO": "H602",
  "ROVERBELLA": "H604",
  "ROVERCHIARA": "H606",
  "ROVERE DELLA LUNA": "H607",
  "ROVERE VERONESE": "H608",
  "ROVEREDO DI GUA": "H610",
  "ROVEREDO IN PIANO": "H609",
  "ROVERETO": "H612",
  "ROVESCALA": "H614",
  "ROVETTA": "H615",
  "ROVIANO": "H618",
  "ROVIGO": "H620",
  "ROVITO": "H621",
  "ROVOLON": "H622",
  "ROZZANO": "H623",
  "RUBANO": "H625",
  "RUBIANA": "H627",
  "RUBIERA": "H628",
  "RUDA": "H629",
  "RUDIANO": "H630",
  "RUEGLIO": "H631",
  "RUFFANO": "H632",
  "RUFFIA": "H633",
  "RUFFRE-MENDOLA": "H634",
  "RUFINA": "H635",
  "RUINAS": "F271",
  "RUMO": "H639",
  "RUOTI": "H641",
  "RUSSI": "H642",
  "RUTIGLIANO": "H643",
  "RUTINO": "H644",
  "RUVIANO": "H165",
  "RUVO DEL MONTE": "H646",
  "RUVO DI PUGLIA": "H645",
  "SABAUDIA": "H647",
  "SABBIO CHIESE": "H650",
  "SABBIONETA": "H652",
  "SACCO": "H654",
  "SACCOLONGO": "H655",
  "SACILE": "H657",
  "SACROFANO": "H658",
  "SADALI": "H659",
  "SAGAMA": "H661",
  "SAGLIANO MICCA": "H662",
  "SAGRADO": "H665",
  "SAGRON MIS": "H666",
  "SAINT-CHRISTOPHE": "H669",
  "SAINT-DENIS": "H670",
  "SAINT-MARCEL": "H671",
  "SAINT-NICOLAS": "H672",
  "SAINT-OYEN": "H673",
  "SAINT-PIERRE": "H674",
  "SAINT-RHEMY-EN-BOSSES": "H675",
  "SAINT-VINCENT": "H676",
  "SALA BAGANZA": "H682",
  "SALA BIELLESE": "H681",
  "SALA BOLOGNESE": "H678",
  "SALA COMACINA": "H679",
  "SALA CONSILINA": "H683",
  "SALA MONFERRATO": "H677",
  "SALANDRA": "H687",
  "SALAPARUTA": "H688",
  "SALARA": "H689",
  "SALASCO": "H690",
  "SALASSA": "H691",
  "SALBERTRAND": "H684",
  "SALCEDO": "F810",
  "SALCITO": "H693",
  "SALE": "H694",
  "SALE DELLE LANGHE": "H695",
  "SALE MARASINO": "H699",
  "SALE SAN GIOVANNI": "H704",
  "SALEMI": "H700",
  "SALENTO": "H686",
  "SALERANO CANAVESE": "H702",
  "SALERANO SUL LAMBRO": "H701",
  "SALERNO": "H703",
  "SALGAREDA": "H706",
  "SALI VERCELLESE": "H707",
  "SALICE SALENTINO": "H708",
  "SALICETO": "H710",
  "SALISANO": "H713",
  "SALIZZOLE": "H714",
  "SALLE": "H715",
  "SALMOUR": "H716",
  "SALO": "H717",
  "SALORNO": "H719",
  "SALSOMAGGIORE TERME": "H720",
  "SALTRIO": "H723",
  "SALUDECIO": "H724",
  "SALUGGIA": "H725",
  "SALUSSOLA": "H726",
  "SALUZZO": "H727",
  "SALVE": "H729",
  "SALVIROLA": "H731",
  "SALVITELLE": "H732",
  "SALZA DI PINEROLO": "H734",
  "SALZA IRPINA": "H733",
  "SALZANO": "H735",
  "SAMARATE": "H736",
  "SAMASSI": "H738",
  "SAMATZAI": "H739",
  "SAMBUCA DI SICILIA": "H743",
  "SAMBUCA PISTOIESE": "H744",
  "SAMBUCI": "H745",
  "SAMBUCO": "H746",
  "SAMMICHELE DI BARI": "H749",
  "SAMO": "H013",
  "SAMOLACO": "H752",
  "SAMONE": "H754",
  "SAMPEYRE": "H755",
  "SAMUGHEO": "H756",
  "SAN BARTOLOMEO AL MARE": "H763",
  "SAN BARTOLOMEO IN GALDO": "H764",
  "SAN BARTOLOMEO VAL CAVARGNA": "H760",
  "SAN BASILE": "H765",
  "SAN BASILIO": "H766",
  "SAN BASSANO": "H767",
  "SAN BELLINO": "H768",
  "SAN BENEDETTO BELBO": "H770",
  "SAN BENEDETTO DEI MARSI": "H772",
  "SAN BENEDETTO DEL TRONTO": "H769",
  "SAN BENEDETTO IN PERILLIS": "H773",
  "SAN BENEDETTO PO": "H771",
  "SAN BENEDETTO ULLANO": "H774",
  "SAN BENEDETTO VAL DI SAMBRO": "G566",
  "SAN BENIGNO CANAVESE": "H775",
  "SAN BERNARDINO VERBANO": "H777",
  "SAN BIAGIO DELLA CIMA": "H780",
  "SAN BIAGIO DI CALLALTA": "H781",
  "SAN BIAGIO PLATANI": "H778",
  "SAN BIAGIO SARACINISCO": "H779",
  "SAN BIASE": "H782",
  "SAN BONIFACIO": "H783",
  "SAN BUONO": "H784",
  "SAN CALOGERO": "H785",
  "SAN CANDIDO": "H786",
  "SAN CANZIAN DISONZO": "H787",
  "SAN CARLO CANAVESE": "H789",
  "SAN CASCIANO DEI BAGNI": "H790",
  "SAN CASCIANO IN VAL DI PESA": "H791",
  "SAN CASSIANO": "M264",
  "SAN CATALDO": "H792",
  "SAN CESAREO": "M295",
  "SAN CESARIO DI LECCE": "H793",
  "SAN CESARIO SUL PANARO": "H794",
  "SAN CHIRICO NUOVO": "H795",
  "SAN CHIRICO RAPARO": "H796",
  "SAN CIPIRELLO": "H797",
  "SAN CIPRIANO DAVERSA": "H798",
  "SAN CIPRIANO PICENTINO": "H800",
  "SAN CIPRIANO PO": "H799",
  "SAN CLEMENTE": "H801",
  "SAN COLOMBANO AL LAMBRO": "H803",
  "SAN COLOMBANO BELMONTE": "H804",
  "SAN COLOMBANO CERTENOLI": "H802",
  "SAN CONO": "H805",
  "SAN COSMO ALBANESE": "H806",
  "SAN COSTANTINO ALBANESE": "H808",
  "SAN COSTANTINO CALABRO": "H807",
  "SAN COSTANZO": "H809",
  "SAN CRISTOFORO": "H810",
  "SAN DAMIANO AL COLLE": "H814",
  "SAN DAMIANO DASTI": "H811",
  "SAN DAMIANO MACRA": "H812",
  "SAN DANIELE DEL FRIULI": "H816",
  "SAN DANIELE PO": "H815",
  "SAN DEMETRIO CORONE": "H818",
  "SAN DEMETRIO NE VESTINI": "H819",
  "SAN DIDERO": "H820",
  "SAN DONA DI PIAVE": "H823",
  "SAN DONACI": "H822",
  "SAN DONATO DI LECCE": "H826",
  "SAN DONATO DI NINEA": "H825",
  "SAN DONATO MILANESE": "H827",
  "SAN DONATO VAL DI COMINO": "H824",
  "SAN DORLIGO DELLA VALLE": "D324",
  "SAN FELE": "H831",
  "SAN FELICE A CANCELLO": "H834",
  "SAN FELICE CIRCEO": "H836",
  "SAN FELICE DEL BENACO": "H838",
  "SAN FELICE DEL MOLISE": "H833",
  "SAN FELICE SUL PANARO": "H835",
  "SAN FERDINANDO": "M277",
  "SAN FERDINANDO DI PUGLIA": "H839",
  "SAN FERMO DELLA BATTAGLIA": "H840",
  "SAN FILI": "H841",
  "SAN FILIPPO DEL MELA": "H842",
  "SAN FIOR": "H843",
  "SAN FIORANO": "H844",
  "SAN FLORIANO DEL COLLIO": "H845",
  "SAN FLORO": "H846",
  "SAN FRANCESCO AL CAMPO": "H847",
  "SAN FRATELLO": "H850",
  "SAN GAVINO MONREALE": "H856",
  "SAN GEMINI": "H857",
  "SAN GENESIO ATESINO": "H858",
  "SAN GENESIO ED UNITI": "H859",
  "SAN GENNARO VESUVIANO": "H860",
  "SAN GERMANO CHISONE": "H862",
  "SAN GERMANO VERCELLESE": "H861",
  "SAN GERVASIO BRESCIANO": "H865",
  "SAN GIACOMO DEGLI SCHIAVONI": "H867",
  "SAN GIACOMO DELLE SEGNATE": "H870",
  "SAN GIACOMO FILIPPO": "H868",
  "SAN GIACOMO VERCELLESE": "B952",
  "SAN GILLIO": "H873",
  "SAN GIMIGNANO": "H875",
  "SAN GINESIO": "H876",
  "SAN GIORGIO A CREMANO": "H892",
  "SAN GIORGIO A LIRI": "H880",
  "SAN GIORGIO ALBANESE": "H881",
  "SAN GIORGIO BIGARELLO": "H883",
  "SAN GIORGIO CANAVESE": "H890",
  "SAN GIORGIO DEL SANNIO": "H894",
  "SAN GIORGIO DELLA RICHINVELDA": "H891",
  "SAN GIORGIO DELLE PERTICHE": "H893",
  "SAN GIORGIO DI LOMELLINA": "H885",
  "SAN GIORGIO DI NOGARO": "H895",
  "SAN GIORGIO DI PIANO": "H896",
  "SAN GIORGIO IN BOSCO": "H897",
  "SAN GIORGIO IONICO": "H882",
  "SAN GIORGIO LA MOLARA": "H898",
  "SAN GIORGIO LUCANO": "H888",
  "SAN GIORGIO MONFERRATO": "H878",
  "SAN GIORGIO MORGETO": "H889",
  "SAN GIORGIO PIACENTINO": "H887",
  "SAN GIORGIO SCARAMPI": "H899",
  "SAN GIORGIO SU LEGNANO": "H884",
  "SAN GIORIO DI SUSA": "H900",
  "SAN GIOVANNI A PIRO": "H907",
  "SAN GIOVANNI AL NATISONE": "H906",
  "SAN GIOVANNI BIANCO": "H910",
  "SAN GIOVANNI DEL DOSSO": "H912",
  "SAN GIOVANNI DI FASSA": "M390",
  "SAN GIOVANNI DI GERACE": "H903",
  "SAN GIOVANNI GEMINI": "H914",
  "SAN GIOVANNI ILARIONE": "H916",
  "SAN GIOVANNI IN CROCE": "H918",
  "SAN GIOVANNI IN FIORE": "H919",
  "SAN GIOVANNI IN GALDO": "H920",
  "SAN GIOVANNI IN MARIGNANO": "H921",
  "SAN GIOVANNI IN PERSICETO": "G467",
  "SAN GIOVANNI INCARICO": "H917",
  "SAN GIOVANNI LA PUNTA": "H922",
  "SAN GIOVANNI LIPIONI": "H923",
  "SAN GIOVANNI LUPATOTO": "H924",
  "SAN GIOVANNI ROTONDO": "H926",
  "SAN GIOVANNI SUERGIU": "G287",
  "SAN GIOVANNI TEATINO": "D690",
  "SAN GIOVANNI VALDARNO": "H901",
  "SAN GIULIANO DEL SANNIO": "H928",
  "SAN GIULIANO DI PUGLIA": "H929",
  "SAN GIULIANO MILANESE": "H930",
  "SAN GIULIANO TERME": "A562",
  "SAN GIUSEPPE JATO": "H933",
  "SAN GIUSEPPE VESUVIANO": "H931",
  "SAN GIUSTINO": "H935",
  "SAN GIUSTO CANAVESE": "H936",
  "SAN GODENZO": "H937",
  "SAN GREGORIO DA SASSOLA": "H942",
  "SAN GREGORIO DI CATANIA": "H940",
  "SAN GREGORIO DIPPONA": "H941",
  "SAN GREGORIO MAGNO": "H943",
  "SAN GREGORIO MATESE": "H939",
  "SAN GREGORIO NELLE ALPI": "H938",
  "SAN LAZZARO DI SAVENA": "H945",
  "SAN LEO": "H949",
  "SAN LEONARDO": "H951",
  "SAN LEONARDO IN PASSIRIA": "H952",
  "SAN LEUCIO DEL SANNIO": "H953",
  "SAN LORENZELLO": "H955",
  "SAN LORENZO": "H959",
  "SAN LORENZO AL MARE": "H957",
  "SAN LORENZO BELLIZZI": "H961",
  "SAN LORENZO DEL VALLO": "H962",
  "SAN LORENZO DI SEBATO": "H956",
  "SAN LORENZO DORSINO": "M345",
  "SAN LORENZO IN CAMPO": "H958",
  "SAN LORENZO ISONTINO": "H964",
  "SAN LORENZO MAGGIORE": "H967",
  "SAN LORENZO NUOVO": "H969",
  "SAN LUCA": "H970",
  "SAN LUCIDO": "H971",
  "SAN LUPO": "H973",
  "SAN MANGO DAQUINO": "H976",
  "SAN MANGO PIEMONTE": "H977",
  "SAN MANGO SUL CALORE": "H975",
  "SAN MARCELLINO": "H978",
  "SAN MARCELLO": "H979",
  "SAN MARCELLO PITEGLIO": "M377",
  "SAN MARCO ARGENTANO": "H981",
  "SAN MARCO DALUNZIO": "H982",
  "SAN MARCO DEI CAVOTI": "H984",
  "SAN MARCO EVANGELISTA": "F043",
  "SAN MARCO IN LAMIS": "H985",
  "SAN MARCO LA CATOLA": "H986",
  "SAN MARTINO AL TAGLIAMENTO": "H999",
  "SAN MARTINO ALFIERI": "H987",
  "SAN MARTINO BUON ALBERGO": "I003",
  "SAN MARTINO CANAVESE": "H997",
  "SAN MARTINO DAGRI": "H994",
  "SAN MARTINO DALLARGINE": "I005",
  "SAN MARTINO DEL LAGO": "I007",
  "SAN MARTINO DI FINITA": "H992",
  "SAN MARTINO DI LUPARI": "I008",
  "SAN MARTINO DI VENEZZE": "H996",
  "SAN MARTINO IN BADIA": "H988",
  "SAN MARTINO IN PASSIRIA": "H989",
  "SAN MARTINO IN PENSILIS": "H990",
  "SAN MARTINO IN RIO": "I011",
  "SAN MARTINO IN STRADA": "I012",
  "SAN MARTINO SANNITA": "I002",
  "SAN MARTINO SICCOMARIO": "I014",
  "SAN MARTINO SULLA MARRUCINA": "H991",
  "SAN MARTINO VALLE CAUDINA": "I016",
  "SAN MARZANO DI SAN GIUSEPPE": "I018",
  "SAN MARZANO OLIVETO": "I017",
  "SAN MARZANO SUL SARNO": "I019",
  "SAN MASSIMO": "I023",
  "SAN MAURIZIO CANAVESE": "I024",
  "SAN MAURIZIO DOPAGLIO": "I025",
  "SAN MAURO CASTELVERDE": "I028",
  "SAN MAURO CILENTO": "I031",
  "SAN MAURO DI SALINE": "H712",
  "SAN MAURO FORTE": "I029",
  "SAN MAURO LA BRUCA": "I032",
  "SAN MAURO MARCHESATO": "I026",
  "SAN MAURO PASCOLI": "I027",
  "SAN MAURO TORINESE": "I030",
  "SAN MICHELE AL TAGLIAMENTO": "I040",
  "SAN MICHELE ALLADIGE": "I042",
  "SAN MICHELE DI GANZARIA": "I035",
  "SAN MICHELE DI SERINO": "I034",
  "SAN MICHELE MONDOVI": "I037",
  "SAN MICHELE SALENTINO": "I045",
  "SAN MINIATO": "I046",
  "SAN NAZZARO": "I049",
  "SAN NAZZARO SESIA": "I052",
  "SAN NAZZARO VAL CAVARGNA": "I051",
  "SAN NICANDRO GARGANICO": "I054",
  "SAN NICOLA ARCELLA": "I060",
  "SAN NICOLA BARONIA": "I061",
  "SAN NICOLA DA CRISSA": "I058",
  "SAN NICOLA DELLALTO": "I057",
  "SAN NICOLA LA STRADA": "I056",
  "SAN NICOLA MANFREDI": "I062",
  "SAN NICOLO DARCIDANO": "A368",
  "SAN NICOLO DI COMELICO": "I063",
  "SAN NICOLO GERREI": "G383",
  "SAN PANCRAZIO": "I065",
  "SAN PANCRAZIO SALENTINO": "I066",
  "SAN PAOLO": "G407",
  "SAN PAOLO ALBANESE": "B906",
  "SAN PAOLO BEL SITO": "I073",
  "SAN PAOLO DARGON": "B310",
  "SAN PAOLO DI CIVITATE": "I072",
  "SAN PAOLO DI JESI": "I071",
  "SAN PAOLO SOLBRITO": "I076",
  "SAN PELLEGRINO TERME": "I079",
  "SAN PIER DISONZO": "I082",
  "SAN PIER NICETO": "I084",
  "SAN PIERO PATTI": "I086",
  "SAN PIETRO A MAIDA": "I093",
  "SAN PIETRO AL NATISONE": "I092",
  "SAN PIETRO AL TANAGRO": "I089",
  "SAN PIETRO APOSTOLO": "I095",
  "SAN PIETRO AVELLANA": "I096",
  "SAN PIETRO CLARENZA": "I098",
  "SAN PIETRO DI CADORE": "I088",
  "SAN PIETRO DI CARIDA": "I102",
  "SAN PIETRO DI FELETTO": "I103",
  "SAN PIETRO DI MORUBIO": "I105",
  "SAN PIETRO IN AMANTEA": "I108",
  "SAN PIETRO IN CARIANO": "I109",
  "SAN PIETRO IN CASALE": "I110",
  "SAN PIETRO IN CERRO": "G788",
  "SAN PIETRO IN GU": "I107",
  "SAN PIETRO IN GUARANO": "I114",
  "SAN PIETRO IN LAMA": "I115",
  "SAN PIETRO INFINE": "I113",
  "SAN PIETRO MOSEZZO": "I116",
  "SAN PIETRO MUSSOLINO": "I117",
  "SAN PIETRO VAL LEMINA": "I090",
  "SAN PIETRO VERNOTICO": "I119",
  "SAN PIETRO VIMINARIO": "I120",
  "SAN PIO DELLE CAMERE": "I121",
  "SAN POLO DEI CAVALIERI": "I125",
  "SAN POLO DENZA": "I123",
  "SAN POLO DI PIAVE": "I124",
  "SAN POLO MATESE": "I122",
  "SAN PONSO": "I126",
  "SAN POSSIDONIO": "I128",
  "SAN POTITO SANNITICO": "I130",
  "SAN POTITO ULTRA": "I129",
  "SAN PRISCO": "I131",
  "SAN PROCOPIO": "I132",
  "SAN PROSPERO": "I133",
  "SAN QUIRICO DORCIA": "I135",
  "SAN QUIRINO": "I136",
  "SAN RAFFAELE CIMENA": "I137",
  "SAN ROBERTO": "I139",
  "SAN ROCCO AL PORTO": "I140",
  "SAN ROMANO IN GARFAGNANA": "I142",
  "SAN RUFO": "I143",
  "SAN SALVATORE DI FITALIA": "I147",
  "SAN SALVATORE MONFERRATO": "I144",
  "SAN SALVATORE TELESINO": "I145",
  "SAN SALVO": "I148",
  "SAN SEBASTIANO AL VESUVIO": "I151",
  "SAN SEBASTIANO CURONE": "I150",
  "SAN SEBASTIANO DA PO": "I152",
  "SAN SECONDO DI PINEROLO": "I154",
  "SAN SECONDO PARMENSE": "I153",
  "SAN SEVERINO LUCANO": "I157",
  "SAN SEVERINO MARCHE": "I156",
  "SAN SEVERO": "I158",
  "SAN SIRO": "I162",
  "SAN SOSSIO BARONIA": "I163",
  "SAN SOSTENE": "I164",
  "SAN SOSTI": "I165",
  "SAN SPERATE": "I166",
  "SAN STINO DI LIVENZA": "I373",
  "SAN TAMMARO": "I261",
  "SAN TEODORO": "I329",
  "SAN TOMASO AGORDINO": "I347",
  "SAN VALENTINO IN ABRUZZO CITERIORE": "I376",
  "SAN VALENTINO TORIO": "I377",
  "SAN VENANZO": "I381",
  "SAN VENDEMIANO": "I382",
  "SAN VERO MILIS": "I384",
  "SAN VINCENZO": "I390",
  "SAN VINCENZO LA COSTA": "I388",
  "SAN VINCENZO VALLE ROVETO": "I389",
  "SAN VITALIANO": "I391",
  "SAN VITO": "I402",
  "SAN VITO AL TAGLIAMENTO": "I403",
  "SAN VITO AL TORRE": "I404",
  "SAN VITO CHIETINO": "I394",
  "SAN VITO DEI NORMANNI": "I396",
  "SAN VITO DI CADORE": "I392",
  "SAN VITO DI FAGAGNA": "I405",
  "SAN VITO DI LEGUZZANO": "I401",
  "SAN VITO LO CAPO": "I407",
  "SAN VITO ROMANO": "I400",
  "SAN VITO SULLO IONIO": "I393",
  "SAN VITTORE DEL LAZIO": "I408",
  "SAN VITTORE OLONA": "I409",
  "SAN ZENO DI MONTAGNA": "I414",
  "SAN ZENO NAVIGLIO": "I412",
  "SAN ZENONE AL LAMBRO": "I415",
  "SAN ZENONE AL PO": "I416",
  "SAN ZENONE DEGLI EZZELINI": "I417",
  "SANARICA": "H757",
  "SANDIGLIANO": "H821",
  "SANDRIGO": "H829",
  "SANFRE": "H851",
  "SANFRONT": "H852",
  "SANGANO": "H855",
  "SANGIANO": "H872",
  "SANGINETO": "H877",
  "SANGUINETTO": "H944",
  "SANLURI": "H974",
  "SANNAZZARO DE BURGONDI": "I048",
  "SANNICANDRO DI BARI": "I053",
  "SANNICOLA": "I059",
  "SANREMO": "I138",
  "SANSEPOLCRO": "I155",
  "SANTA BRIGIDA": "I168",
  "SANTA CATERINA ALBANESE": "I171",
  "SANTA CATERINA DELLO IONIO": "I170",
  "SANTA CATERINA VILLARMOSA": "I169",
  "SANTA CESAREA TERME": "I172",
  "SANTA CRISTINA DASPROMONTE": "I176",
  "SANTA CRISTINA E BISSONE": "I175",
  "SANTA CRISTINA GELA": "I174",
  "SANTA CRISTINA VALGARDENA": "I173",
  "SANTA CROCE CAMERINA": "I178",
  "SANTA CROCE DEL SANNIO": "I179",
  "SANTA CROCE DI MAGLIANO": "I181",
  "SANTA CROCE SULLARNO": "I177",
  "SANTA DOMENICA TALAO": "I183",
  "SANTA DOMENICA VITTORIA": "I184",
  "SANTA ELISABETTA": "I185",
  "SANTA FIORA": "I187",
  "SANTA FLAVIA": "I188",
  "SANTA GIULETTA": "I203",
  "SANTA GIUSTA": "I205",
  "SANTA GIUSTINA": "I206",
  "SANTA GIUSTINA IN COLLE": "I207",
  "SANTA LUCE": "I217",
  "SANTA LUCIA DEL MELA": "I220",
  "SANTA LUCIA DI PIAVE": "I221",
  "SANTA LUCIA DI SERINO": "I219",
  "SANTA MARGHERITA DI BELICE": "I224",
  "SANTA MARGHERITA DI STAFFORA": "I230",
  "SANTA MARGHERITA LIGURE": "I225",
  "SANTA MARIA A MONTE": "I232",
  "SANTA MARIA A VICO": "I233",
  "SANTA MARIA CAPUA VETERE": "I234",
  "SANTA MARIA COGHINAS": "M284",
  "SANTA MARIA DEL CEDRO": "C717",
  "SANTA MARIA DEL MOLISE": "I238",
  "SANTA MARIA DELLA VERSA": "I237",
  "SANTA MARIA DI LICODIA": "I240",
  "SANTA MARIA DI SALA": "I242",
  "SANTA MARIA HOE": "I243",
  "SANTA MARIA IMBARO": "I244",
  "SANTA MARIA LA CARITA": "M273",
  "SANTA MARIA LA FOSSA": "I247",
  "SANTA MARIA LA LONGA": "I248",
  "SANTA MARIA MAGGIORE": "I249",
  "SANTA MARIA NUOVA": "I251",
  "SANTA MARINA": "I253",
  "SANTA MARINA SALINA": "I254",
  "SANTA MARINELLA": "I255",
  "SANTA NINFA": "I291",
  "SANTA PAOLINA": "I301",
  "SANTA SEVERINA": "I308",
  "SANTA SOFIA": "I310",
  "SANTA SOFIA DEPIRO": "I309",
  "SANTA TERESA DI RIVA": "I311",
  "SANTA TERESA GALLURA": "I312",
  "SANTA VENERINA": "I314",
  "SANTA VITTORIA DALBA": "I316",
  "SANTA VITTORIA IN MATENANO": "I315",
  "SANTADI": "I182",
  "SANTAGAPITO": "I189",
  "SANTAGATA BOLOGNESE": "I191",
  "SANTAGATA DE GOTI": "I197",
  "SANTAGATA DEL BIANCO": "I198",
  "SANTAGATA DI ESARO": "I192",
  "SANTAGATA DI MILITELLO": "I199",
  "SANTAGATA DI PUGLIA": "I193",
  "SANTAGATA FELTRIA": "I201",
  "SANTAGATA FOSSILI": "I190",
  "SANTAGATA LI BATTIATI": "I202",
  "SANTAGATA SUL SANTERNO": "I196",
  "SANTAGNELLO": "I208",
  "SANTALBANO STURA": "I210",
  "SANTALESSIO CON VIALONE": "I213",
  "SANTALESSIO IN ASPROMONTE": "I214",
  "SANTALESSIO SICULO": "I215",
  "SANTALFIO": "I216",
  "SANTAMBROGIO DI TORINO": "I258",
  "SANTAMBROGIO DI VALPOLICELLA": "I259",
  "SANTAMBROGIO SUL GARIGLIANO": "I256",
  "SANTANASTASIA": "I262",
  "SANTANATOLIA DI NARCO": "I263",
  "SANTANDREA APOSTOLO DELLO IONIO": "I266",
  "SANTANDREA DEL GARIGLIANO": "I265",
  "SANTANDREA DI CONZA": "I264",
  "SANTANDREA FRIUS": "I271",
  "SANTANGELO A CUPOLO": "I277",
  "SANTANGELO A FASANELLA": "I278",
  "SANTANGELO A SCALA": "I280",
  "SANTANGELO ALLESCA": "I279",
  "SANTANGELO DALIFE": "I273",
  "SANTANGELO DEI LOMBARDI": "I281",
  "SANTANGELO DEL PESCO": "I282",
  "SANTANGELO DI BROLO": "I283",
  "SANTANGELO DI PIOVE DI SACCO": "I275",
  "SANTANGELO IN PONTANO": "I286",
  "SANTANGELO IN VADO": "I287",
  "SANTANGELO LE FRATTE": "I288",
  "SANTANGELO LIMOSANO": "I289",
  "SANTANGELO LODIGIANO": "I274",
  "SANTANGELO LOMELLINA": "I276",
  "SANTANGELO MUXARO": "I290",
  "SANTANGELO ROMANO": "I284",
  "SANTANNA ARRESI": "M209",
  "SANTANNA DALFAEDO": "I292",
  "SANTANTIMO": "I293",
  "SANTANTIOCO": "I294",
  "SANTANTONINO DI SUSA": "I296",
  "SANTANTONIO ABATE": "I300",
  "SANTANTONIO DI GALLURA": "M276",
  "SANTAPOLLINARE": "I302",
  "SANTARCANGELO": "I305",
  "SANTARCANGELO DI ROMAGNA": "I304",
  "SANTARCANGELO TRIMONTE": "F557",
  "SANTARPINO": "I306",
  "SANTARSENIO": "I307",
  "SANTE MARIE": "I326",
  "SANTEGIDIO ALLA VIBRATA": "I318",
  "SANTEGIDIO DEL MONTE ALBINO": "I317",
  "SANTELENA": "I319",
  "SANTELENA SANNITA": "B466",
  "SANTELIA A PIANISI": "I320",
  "SANTELIA FIUMERAPIDO": "I321",
  "SANTELPIDIO A MARE": "I324",
  "SANTENA": "I327",
  "SANTERAMO IN COLLE": "I330",
  "SANTEUFEMIA A MAIELLA": "I332",
  "SANTEUFEMIA DASPROMONTE": "I333",
  "SANTEUSANIO DEL SANGRO": "I335",
  "SANTEUSANIO FORCONESE": "I336",
  "SANTHIA": "I337",
  "SANTI COSMA E DAMIANO": "I339",
  "SANTILARIO DELLO IONIO": "I341",
  "SANTILARIO DENZA": "I342",
  "SANTIPPOLITO": "I344",
  "SANTO STEFANO AL MARE": "I365",
  "SANTO STEFANO BELBO": "I367",
  "SANTO STEFANO DAVETO": "I368",
  "SANTO STEFANO DEL SOLE": "I357",
  "SANTO STEFANO DI CADORE": "C919",
  "SANTO STEFANO DI CAMASTRA": "I370",
  "SANTO STEFANO DI MAGRA": "I363",
  "SANTO STEFANO DI ROGLIANO": "I359",
  "SANTO STEFANO DI SESSANIO": "I360",
  "SANTO STEFANO IN ASPROMONTE": "I371",
  "SANTO STEFANO LODIGIANO": "I362",
  "SANTO STEFANO QUISQUINA": "I356",
  "SANTO STEFANO ROERO": "I372",
  "SANTO STEFANO TICINO": "I361",
  "SANTOLCESE": "I346",
  "SANTOMENNA": "I260",
  "SANTOMERO": "I348",
  "SANTOMOBONO TERME": "M333",
  "SANTONOFRIO": "I350",
  "SANTOPADRE": "I351",
  "SANTORESTE": "I352",
  "SANTORSO": "I353",
  "SANTORSOLA TERME": "I354",
  "SANTU LUSSURGIU": "I374",
  "SANTURBANO": "I375",
  "SANZA": "I410",
  "SANZENO": "I411",
  "SAONARA": "I418",
  "SAPONARA": "I420",
  "SAPPADA": "I421",
  "SAPRI": "I422",
  "SARACENA": "I423",
  "SARACINESCO": "I424",
  "SARCEDO": "I425",
  "SARCONI": "I426",
  "SARDARA": "I428",
  "SARDIGLIANO": "I429",
  "SAREGO": "I430",
  "SARENTINO": "I431",
  "SAREZZANO": "I432",
  "SAREZZO": "I433",
  "SARMATO": "I434",
  "SARMEDE": "I435",
  "SARNANO": "I436",
  "SARNICO": "I437",
  "SARNO": "I438",
  "SARNONICO": "I439",
  "SARONNO": "I441",
  "SARRE": "I442",
  "SARROCH": "I443",
  "SARSINA": "I444",
  "SARTEANO": "I445",
  "SARTIRANA LOMELLINA": "I447",
  "SARULE": "I448",
  "SARZANA": "I449",
  "SASSANO": "I451",
  "SASSARI": "I452",
  "SASSELLO": "I453",
  "SASSETTA": "I454",
  "SASSINORO": "I455",
  "SASSO DI CASTALDA": "I457",
  "SASSO MARCONI": "G972",
  "SASSOCORVARO AUDITORE": "M413",
  "SASSOFELTRIO": "I460",
  "SASSOFERRATO": "I461",
  "SASSUOLO": "I462",
  "SATRIANO": "I463",
  "SATRIANO DI LUCANIA": "G614",
  "SAURIS": "I464",
  "SAUZE DI CESANA": "I465",
  "SAUZE DOULX": "I466",
  "SAVA": "I467",
  "SAVELLI": "I468",
  "SAVIANO": "I469",
  "SAVIGLIANO": "I470",
  "SAVIGNANO IRPINO": "I471",
  "SAVIGNANO SUL PANARO": "I473",
  "SAVIGNANO SUL RUBICONE": "I472",
  "SAVIGNONE": "I475",
  "SAVIORE DELLADAMELLO": "I476",
  "SAVOCA": "I477",
  "SAVOGNA": "I478",
  "SAVOGNA DISONZO": "I479",
  "SAVOIA DI LUCANIA": "H730",
  "SAVONA": "I480",
  "SCAFA": "I482",
  "SCAFATI": "I483",
  "SCAGNELLO": "I484",
  "SCALA": "I486",
  "SCALA COELI": "I485",
  "SCALDASOLE": "I487",
  "SCALEA": "I489",
  "SCALENGHE": "I490",
  "SCALETTA ZANCLEA": "I492",
  "SCAMPITELLA": "I493",
  "SCANDALE": "I494",
  "SCANDIANO": "I496",
  "SCANDICCI": "B962",
  "SCANDOLARA RAVARA": "I497",
  "SCANDOLARA RIPA DOGLIO": "I498",
  "SCANDRIGLIA": "I499",
  "SCANNO": "I501",
  "SCANO DI MONTIFERRO": "I503",
  "SCANSANO": "I504",
  "SCANZANO JONICO": "M256",
  "SCANZOROSCIATE": "I506",
  "SCAPOLI": "I507",
  "SCARLINO": "I510",
  "SCARMAGNO": "I511",
  "SCARNAFIGI": "I512",
  "SCARPERIA E SAN PIERO": "M326",
  "SCENA": "I519",
  "SCERNI": "I520",
  "SCHEGGIA E PASCELUPO": "I522",
  "SCHEGGINO": "I523",
  "SCHIAVI DI ABRUZZO": "I526",
  "SCHIAVON": "I527",
  "SCHIGNANO": "I529",
  "SCHILPARIO": "I530",
  "SCHIO": "I531",
  "SCHIVENOGLIA": "I532",
  "SCIACCA": "I533",
  "SCIARA": "I534",
  "SCICLI": "I535",
  "SCIDO": "I536",
  "SCIGLIANO": "D290",
  "SCILLA": "I537",
  "SCILLATO": "I538",
  "SCIOLZE": "I539",
  "SCISCIANO": "I540",
  "SCLAFANI BAGNI": "I541",
  "SCONTRONE": "I543",
  "SCOPA": "I544",
  "SCOPELLO": "I545",
  "SCOPPITO": "I546",
  "SCORDIA": "I548",
  "SCORRANO": "I549",
  "SCORZE": "I551",
  "SCURCOLA MARSICANA": "I553",
  "SCURELLE": "I554",
  "SCURZOLENGO": "I555",
  "SEBORGA": "I556",
  "SECINARO": "I558",
  "SECLI": "I559",
  "SECUGNAGO": "I561",
  "SEDEGLIANO": "I562",
  "SEDICO": "I563",
  "SEDILO": "I564",
  "SEDINI": "I565",
  "SEDRIANO": "I566",
  "SEDRINA": "I567",
  "SEFRO": "I569",
  "SEGARIU": "I570",
  "SEGGIANO": "I571",
  "SEGNI": "I573",
  "SEGONZANO": "I576",
  "SEGRATE": "I577",
  "SEGUSINO": "I578",
  "SELARGIUS": "I580",
  "SELCI": "I581",
  "SELEGAS": "I582",
  "SELLA GIUDICARIE": "M360",
  "SELLANO": "I585",
  "SELLERO": "I588",
  "SELLIA": "I589",
  "SELLIA MARINA": "I590",
  "SELVA DEI MOLINI": "I593",
  "SELVA DI CADORE": "I592",
  "SELVA DI PROGNO": "I594",
  "SELVA DI VAL GARDENA": "I591",
  "SELVAZZANO DENTRO": "I595",
  "SELVINO": "I597",
  "SEMESTENE": "I598",
  "SEMIANA": "I599",
  "SEMINARA": "I600",
  "SEMPRONIANO": "I601",
  "SENAGO": "I602",
  "SENALE-SAN FELICE": "I603",
  "SENALES": "I604",
  "SENEGHE": "I605",
  "SENERCHIA": "I606",
  "SENIGA": "I607",
  "SENIGALLIA": "I608",
  "SENIS": "I609",
  "SENISE": "I610",
  "SENNA COMASCO": "I611",
  "SENNA LODIGIANA": "I612",
  "SENNARIOLO": "I613",
  "SENNORI": "I614",
  "SENORBI": "I615",
  "SEPINO": "I618",
  "SEQUALS": "I621",
  "SERAVEZZA": "I622",
  "SERDIANA": "I624",
  "SEREGNO": "I625",
  "SEREN DEL GRAPPA": "I626",
  "SERGNANO": "I627",
  "SERIATE": "I628",
  "SERINA": "I629",
  "SERINO": "I630",
  "SERLE": "I631",
  "SERMIDE E FELONICA": "I632",
  "SERMONETA": "I634",
  "SERNAGLIA DELLA BATTAGLIA": "I635",
  "SERNIO": "I636",
  "SEROLE": "I637",
  "SERRA DAIELLO": "I642",
  "SERRA DE CONTI": "I643",
  "SERRA RICCO": "I640",
  "SERRA SAN BRUNO": "I639",
  "SERRA SAN QUIRICO": "I653",
  "SERRA SANTABBONDIO": "I654",
  "SERRACAPRIOLA": "I641",
  "SERRADIFALCO": "I644",
  "SERRALUNGA DALBA": "I646",
  "SERRALUNGA DI CREA": "I645",
  "SERRAMANNA": "I647",
  "SERRAMAZZONI": "F357",
  "SERRAMEZZANA": "I648",
  "SERRAMONACESCA": "I649",
  "SERRAPETRONA": "I651",
  "SERRARA FONTANA": "I652",
  "SERRASTRETTA": "I655",
  "SERRATA": "I656",
  "SERRAVALLE A PO": "I662",
  "SERRAVALLE DI CHIENTI": "I661",
  "SERRAVALLE LANGHE": "I659",
  "SERRAVALLE PISTOIESE": "I660",
  "SERRAVALLE SCRIVIA": "I657",
  "SERRAVALLE SESIA": "I663",
  "SERRE": "I666",
  "SERRENTI": "I667",
  "SERRI": "I668",
  "SERRONE": "I669",
  "SERSALE": "I671",
  "SERVIGLIANO": "C070",
  "SESSA AURUNCA": "I676",
  "SESSA CILENTO": "I677",
  "SESSAME": "I678",
  "SESSANO DEL MOLISE": "I679",
  "SESTA GODANO": "E070",
  "SESTINO": "I681",
  "SESTO": "I687",
  "SESTO AL REGHENA": "I686",
  "SESTO CALENDE": "I688",
  "SESTO CAMPANO": "I682",
  "SESTO ED UNITI": "I683",
  "SESTO FIORENTINO": "I684",
  "SESTO SAN GIOVANNI": "I690",
  "SESTOLA": "I689",
  "SESTRI LEVANTE": "I693",
  "SESTRIERE": "I692",
  "SESTU": "I695",
  "SETTALA": "I696",
  "SETTEFRATI": "I697",
  "SETTIME": "I698",
  "SETTIMO MILANESE": "I700",
  "SETTIMO ROTTARO": "I701",
  "SETTIMO SAN PIETRO": "I699",
  "SETTIMO TORINESE": "I703",
  "SETTIMO VITTONE": "I702",
  "SETTINGIANO": "I704",
  "SETZU": "I705",
  "SEUI": "I706",
  "SEULO": "I707",
  "SEVESO": "I709",
  "SEZZADIO": "I711",
  "SEZZE": "I712",
  "SFRUZ": "I714",
  "SGONICO": "I715",
  "SGURGOLA": "I716",
  "SIAMAGGIORE": "I717",
  "SIAMANNA": "I718",
  "SIANO": "I720",
  "SIAPICCIA": "I721",
  "SICIGNANO DEGLI ALBURNI": "M253",
  "SICULIANA": "I723",
  "SIDDI": "I724",
  "SIDERNO": "I725",
  "SIENA": "I726",
  "SIGILLO": "I727",
  "SIGNA": "I728",
  "SILANDRO": "I729",
  "SILANUS": "I730",
  "SILEA": "F116",
  "SILIGO": "I732",
  "SILIQUA": "I734",
  "SILIUS": "I735",
  "SILLANO GIUNCUGNANO": "M347",
  "SILLAVENGO": "I736",
  "SILVANO DORBA": "I738",
  "SILVANO PIETRA": "I739",
  "SILVI": "I741",
  "SIMALA": "I742",
  "SIMAXIS": "I743",
  "SIMBARIO": "I744",
  "SIMERI CRICHI": "I745",
  "SINAGRA": "I747",
  "SINALUNGA": "A468",
  "SINDIA": "I748",
  "SINI": "I749",
  "SINIO": "I750",
  "SINISCOLA": "I751",
  "SINNAI": "I752",
  "SINOPOLI": "I753",
  "SIRACUSA": "I754",
  "SIRIGNANO": "I756",
  "SIRIS": "I757",
  "SIRMIONE": "I633",
  "SIROLO": "I758",
  "SIRONE": "I759",
  "SIRTORI": "I761",
  "SISSA TRECASALI": "M325",
  "SIURGUS DONIGALA": "I765",
  "SIZIANO": "E265",
  "SIZZANO": "I767",
  "SLUDERNO": "I771",
  "SMERILLO": "I774",
  "SOAVE": "I775",
  "SOCCHIEVE": "I777",
  "SODDI": "I778",
  "SOGLIANO AL RUBICONE": "I779",
  "SOGLIANO CAVOUR": "I780",
  "SOGLIO": "I781",
  "SOIANO DEL LAGO": "I782",
  "SOLAGNA": "I783",
  "SOLARINO": "I785",
  "SOLARO": "I786",
  "SOLAROLO": "I787",
  "SOLAROLO RAINERIO": "I790",
  "SOLARUSSA": "I791",
  "SOLBIATE ARNO": "I793",
  "SOLBIATE CON CAGNO": "M412",
  "SOLBIATE OLONA": "I794",
  "SOLDANO": "I796",
  "SOLEMINIS": "I797",
  "SOLERO": "I798",
  "SOLESINO": "I799",
  "SOLETO": "I800",
  "SOLFERINO": "I801",
  "SOLIERA": "I802",
  "SOLIGNANO": "I803",
  "SOLOFRA": "I805",
  "SOLONGHELLO": "I808",
  "SOLOPACA": "I809",
  "SOLTO COLLINA": "I812",
  "SOLZA": "I813",
  "SOMAGLIA": "I815",
  "SOMANO": "I817",
  "SOMMA LOMBARDO": "I819",
  "SOMMA VESUVIANA": "I820",
  "SOMMACAMPAGNA": "I821",
  "SOMMARIVA DEL BOSCO": "I822",
  "SOMMARIVA PERNO": "I823",
  "SOMMATINO": "I824",
  "SOMMO": "I825",
  "SONA": "I826",
  "SONCINO": "I827",
  "SONDALO": "I828",
  "SONDRIO": "I829",
  "SONGAVAZZO": "I830",
  "SONICO": "I831",
  "SONNINO": "I832",
  "SORA": "I838",
  "SORAGA DI FASSA": "I839",
  "SORAGNA": "I840",
  "SORANO": "I841",
  "SORBO SAN BASILE": "I844",
  "SORBO SERPICO": "I843",
  "SORBOLO MEZZANI": "M411",
  "SORDEVOLO": "I847",
  "SORDIO": "I848",
  "SORESINA": "I849",
  "SORGA": "I850",
  "SORGONO": "I851",
  "SORI": "I852",
  "SORIANELLO": "I853",
  "SORIANO CALABRO": "I854",
  "SORIANO NEL CIMINO": "I855",
  "SORICO": "I856",
  "SORISO": "I857",
  "SORISOLE": "I858",
  "SORMANO": "I860",
  "SORRADILE": "I861",
  "SORRENTO": "I862",
  "SORSO": "I863",
  "SORTINO": "I864",
  "SOSPIRO": "I865",
  "SOSPIROLO": "I866",
  "SOSSANO": "I867",
  "SOSTEGNO": "I868",
  "SOTTO IL MONTE GIOVANNI XXIII": "I869",
  "SOVER": "I871",
  "SOVERATO": "I872",
  "SOVERE": "I873",
  "SOVERIA MANNELLI": "I874",
  "SOVERIA SIMERI": "I875",
  "SOVERZENE": "I876",
  "SOVICILLE": "I877",
  "SOVICO": "I878",
  "SOVIZZO": "I879",
  "SOVRAMONTE": "I673",
  "SOZZAGO": "I880",
  "SPADAFORA": "I881",
  "SPADOLA": "I884",
  "SPARANISE": "I885",
  "SPARONE": "I886",
  "SPECCHIA": "I887",
  "SPELLO": "I888",
  "SPERLINGA": "I891",
  "SPERLONGA": "I892",
  "SPERONE": "I893",
  "SPESSA": "I894",
  "SPEZZANO ALBANESE": "I895",
  "SPEZZANO DELLA SILA": "I896",
  "SPIAZZO": "I899",
  "SPIGNO MONFERRATO": "I901",
  "SPIGNO SATURNIA": "I902",
  "SPILAMBERTO": "I903",
  "SPILIMBERGO": "I904",
  "SPILINGA": "I905",
  "SPINADESCO": "I906",
  "SPINAZZOLA": "I907",
  "SPINEA": "I908",
  "SPINEDA": "I909",
  "SPINETE": "I910",
  "SPINETO SCRIVIA": "I911",
  "SPINETOLI": "I912",
  "SPINO DADDA": "I914",
  "SPINONE AL LAGO": "I916",
  "SPINOSO": "I917",
  "SPIRANO": "I919",
  "SPOLETO": "I921",
  "SPOLTORE": "I922",
  "SPONGANO": "I923",
  "SPORMAGGIORE": "I924",
  "SPORMINORE": "I925",
  "SPOTORNO": "I926",
  "SPRESIANO": "I927",
  "SPRIANA": "I928",
  "SQUILLACE": "I929",
  "SQUINZANO": "I930",
  "STAFFOLO": "I932",
  "STAGNO LOMBARDO": "I935",
  "STAITI": "I936",
  "STALETTI": "I937",
  "STANGHELLA": "I938",
  "STARANZANO": "I939",
  "STATTE": "M298",
  "STAZZANO": "I941",
  "STAZZEMA": "I942",
  "STAZZONA": "I943",
  "STEFANACONI": "I945",
  "STELLA": "I946",
  "STELLA CILENTO": "G887",
  "STELLANELLO": "I947",
  "STELVIO": "I948",
  "STENICO": "I949",
  "STERNATIA": "I950",
  "STEZZANO": "I951",
  "STIENTA": "I953",
  "STIGLIANO": "I954",
  "STIGNANO": "I955",
  "STILO": "I956",
  "STIMIGLIANO": "I959",
  "STINTINO": "M290",
  "STIO": "I960",
  "STORNARA": "I962",
  "STORNARELLA": "I963",
  "STORO": "I964",
  "STRA": "I965",
  "STRADELLA": "I968",
  "STRAMBINELLO": "I969",
  "STRAMBINO": "I970",
  "STRANGOLAGALLI": "I973",
  "STREGNA": "I974",
  "STREMBO": "I975",
  "STRESA": "I976",
  "STREVI": "I977",
  "STRIANO": "I978",
  "STRONA": "I980",
  "STRONCONE": "I981",
  "STRONGOLI": "I982",
  "STROPPIANA": "I984",
  "STROPPO": "I985",
  "STROZZA": "I986",
  "STURNO": "I990",
  "SUARDI": "B014",
  "SUBBIANO": "I991",
  "SUBIACO": "I992",
  "SUCCIVO": "I993",
  "SUEGLIO": "I994",
  "SUELLI": "I995",
  "SUELLO": "I996",
  "SUISIO": "I997",
  "SULBIATE": "I998",
  "SULMONA": "I804",
  "SULZANO": "L002",
  "SUMIRAGO": "L003",
  "SUMMONTE": "L004",
  "SUNI": "L006",
  "SUNO": "L007",
  "SUPERSANO": "L008",
  "SUPINO": "L009",
  "SURANO": "L010",
  "SURBO": "L011",
  "SUSA": "L013",
  "SUSEGANA": "L014",
  "SUSTINENTE": "L015",
  "SUTERA": "L016",
  "SUTRI": "L017",
  "SUTRIO": "L018",
  "SUVERETO": "L019",
  "SUZZARA": "L020",
  "TACENO": "L022",
  "TADASUNI": "L023",
  "TAGGIA": "L024",
  "TAGLIACOZZO": "L025",
  "TAGLIO DI PO": "L026",
  "TAGLIOLO MONFERRATO": "L027",
  "TAIBON AGORDINO": "L030",
  "TAINO": "L032",
  "TAIPANA": "G736",
  "TALAMELLO": "L034",
  "TALAMONA": "L035",
  "TALANA": "L036",
  "TALEGGIO": "L037",
  "TALLA": "L038",
  "TALMASSONS": "L039",
  "TAMBRE": "L040",
  "TAORMINA": "L042",
  "TARANO": "L046",
  "TARANTA PELIGNA": "L047",
  "TARANTASCA": "L048",
  "TARANTO": "L049",
  "TARCENTO": "L050",
  "TARQUINIA": "D024",
  "TARSIA": "L055",
  "TARTANO": "L056",
  "TARVISIO": "L057",
  "TARZO": "L058",
  "TASSAROLO": "L059",
  "TAURANO": "L061",
  "TAURASI": "L062",
  "TAURIANOVA": "L063",
  "TAURISANO": "L064",
  "TAVAGNACCO": "L065",
  "TAVAGNASCO": "L066",
  "TAVAZZANO CON VILLAVESCO": "F260",
  "TAVENNA": "L069",
  "TAVERNA": "L070",
  "TAVERNERIO": "L071",
  "TAVERNOLA BERGAMASCA": "L073",
  "TAVERNOLE SUL MELLA": "C698",
  "TAVIANO": "L074",
  "TAVIGLIANO": "L075",
  "TAVOLETO": "L078",
  "TAVULLIA": "L081",
  "TEANA": "L082",
  "TEANO": "L083",
  "TEGGIANO": "D292",
  "TEGLIO": "L084",
  "TEGLIO VENETO": "L085",
  "TELESE TERME": "L086",
  "TELGATE": "L087",
  "TELTI": "L088",
  "TELVE": "L089",
  "TELVE DI SOPRA": "L090",
  "TEMPIO PAUSANIA": "L093",
  "TEMU": "L094",
  "TENNA": "L096",
  "TENNO": "L097",
  "TEOLO": "L100",
  "TEORA": "L102",
  "TERAMO": "L103",
  "TERDOBBIATE": "L104",
  "TERELLE": "L105",
  "TERENTO": "L106",
  "TERENZO": "E548",
  "TERGU": "M282",
  "TERLANO": "L108",
  "TERLIZZI": "L109",
  "TERME VIGLIATORE": "M210",
  "TERMENO SULLA STRADA DEL VINO": "L111",
  "TERMINI IMERESE": "L112",
  "TERMOLI": "L113",
  "TERNATE": "L115",
  "TERNENGO": "L116",
  "TERNI": "L117",
  "TERNO DISOLA": "L118",
  "TERRACINA": "L120",
  "TERRAGNOLO": "L121",
  "TERRALBA": "L122",
  "TERRANOVA DA SIBARI": "L124",
  "TERRANOVA DEI PASSERINI": "L125",
  "TERRANOVA DI POLLINO": "L126",
  "TERRANOVA SAPPO MINULIO": "L127",
  "TERRANUOVA BRACCIOLINI": "L123",
  "TERRASINI": "L131",
  "TERRASSA PADOVANA": "L132",
  "TERRAVECCHIA": "L134",
  "TERRAZZO": "L136",
  "TERRE DADIGE": "M407",
  "TERRE DEL RENO": "M381",
  "TERRE ROVERESCHE": "M379",
  "TERRICCIOLA": "L138",
  "TERRUGGIA": "L139",
  "TERTENIA": "L140",
  "TERZIGNO": "L142",
  "TERZO": "L143",
  "TERZO DAQUILEIA": "L144",
  "TERZOLAS": "L145",
  "TERZORIO": "L146",
  "TESERO": "L147",
  "TESIMO": "L149",
  "TESSENNANO": "L150",
  "TESTICO": "L152",
  "TETI": "L153",
  "TEULADA": "L154",
  "TEVEROLA": "L155",
  "TEZZE SUL BRENTA": "L156",
  "THIENE": "L157",
  "THIESI": "L158",
  "TIANA": "L160",
  "TICENGO": "L164",
  "TICINETO": "L165",
  "TIGGIANO": "L166",
  "TIGLIETO": "L167",
  "TIGLIOLE": "L168",
  "TIGNALE": "L169",
  "TINNURA": "L172",
  "TIONE DEGLI ABRUZZI": "L173",
  "TIONE DI TRENTO": "L174",
  "TIRANO": "L175",
  "TIRES": "L176",
  "TIRIOLO": "L177",
  "TIROLO": "L178",
  "TISSI": "L180",
  "TITO": "L181",
  "TIVOLI": "L182",
  "TIZZANO VAL PARMA": "L183",
  "TOANO": "L184",
  "TOCCO CAUDIO": "L185",
  "TOCCO DA CASAURIA": "L186",
  "TOCENO": "L187",
  "TODI": "L188",
  "TOFFIA": "L189",
  "TOIRANO": "L190",
  "TOLENTINO": "L191",
  "TOLFA": "L192",
  "TOLLEGNO": "L193",
  "TOLLO": "L194",
  "TOLMEZZO": "L195",
  "TOLVE": "L197",
  "TOMBOLO": "L199",
  "TON": "L200",
  "TONARA": "L202",
  "TONCO": "L203",
  "TONENGO": "L204",
  "TONEZZA DEL CIMONE": "D717",
  "TORA E PICCILLI": "L205",
  "TORANO CASTELLO": "L206",
  "TORANO NUOVO": "L207",
  "TORBOLE CASAGLIA": "L210",
  "TORCEGNO": "L211",
  "TORCHIARA": "L212",
  "TORCHIAROLO": "L213",
  "TORELLA DEI LOMBARDI": "L214",
  "TORELLA DEL SANNIO": "L215",
  "TORGIANO": "L216",
  "TORGNON": "L217",
  "TORINO": "L219",
  "TORINO DI SANGRO": "L218",
  "TORITTO": "L220",
  "TORLINO VIMERCATI": "L221",
  "TORNACO": "L223",
  "TORNARECCIO": "L224",
  "TORNATA": "L225",
  "TORNIMPARTE": "L227",
  "TORNO": "L228",
  "TORNOLO": "L229",
  "TORO": "L230",
  "TORPE": "L231",
  "TORRACA": "L233",
  "TORRALBA": "L235",
  "TORRAZZA COSTE": "L237",
  "TORRAZZA PIEMONTE": "L238",
  "TORRAZZO": "L239",
  "TORRE ANNUNZIATA": "L245",
  "TORRE BERETTI E CASTELLARO": "L250",
  "TORRE BOLDONE": "L251",
  "TORRE BORMIDA": "L252",
  "TORRE CAJETANI": "L243",
  "TORRE CANAVESE": "L247",
  "TORRE DARESE": "L256",
  "TORRE DE BUSI": "L257",
  "TORRE DE NEGRI": "L262",
  "TORRE DE PASSERI": "L263",
  "TORRE DE PICENARDI": "L258",
  "TORRE DE ROVERI": "L265",
  "TORRE DEL GRECO": "L259",
  "TORRE DI MOSTO": "L267",
  "TORRE DI RUGGIERO": "L240",
  "TORRE DI SANTA MARIA": "L244",
  "TORRE DISOLA": "L269",
  "TORRE LE NOCELLE": "L272",
  "TORRE MONDOVI": "L241",
  "TORRE ORSAIA": "L274",
  "TORRE PALLAVICINA": "L276",
  "TORRE PELLICE": "L277",
  "TORRE SAN GIORGIO": "L278",
  "TORRE SAN PATRIZIO": "L279",
  "TORRE SANTA SUSANNA": "L280",
  "TORREANO": "L246",
  "TORREBELVICINO": "L248",
  "TORREBRUNA": "L253",
  "TORRECUSO": "L254",
  "TORREGLIA": "L270",
  "TORREGROTTA": "L271",
  "TORREMAGGIORE": "L273",
  "TORRENOVA": "M286",
  "TORRESINA": "L281",
  "TORRETTA": "L282",
  "TORREVECCHIA PIA": "L285",
  "TORREVECCHIA TEATINA": "L284",
  "TORRI DEL BENACO": "L287",
  "TORRI DI QUARTESOLO": "L297",
  "TORRI IN SABINA": "L286",
  "TORRICE": "L290",
  "TORRICELLA": "L294",
  "TORRICELLA DEL PIZZO": "L296",
  "TORRICELLA IN SABINA": "L293",
  "TORRICELLA PELIGNA": "L291",
  "TORRICELLA SICURA": "L295",
  "TORRICELLA VERZATE": "L292",
  "TORRIGLIA": "L298",
  "TORRILE": "L299",
  "TORRIONI": "L301",
  "TORRITA DI SIENA": "L303",
  "TORRITA TIBERINA": "L302",
  "TORTOLI": "A355",
  "TORTONA": "L304",
  "TORTORA": "L305",
  "TORTORELLA": "L306",
  "TORTORETO": "L307",
  "TORTORICI": "L308",
  "TORVISCOSA": "L309",
  "TOSCOLANO-MADERNO": "L312",
  "TOSSICIA": "L314",
  "TOVO DI SANTAGATA": "L316",
  "TOVO SAN GIACOMO": "L315",
  "TRABIA": "L317",
  "TRADATE": "L319",
  "TRAMATZA": "L321",
  "TRAMBILENO": "L322",
  "TRAMONTI": "L323",
  "TRAMONTI DI SOPRA": "L324",
  "TRAMONTI DI SOTTO": "L325",
  "TRAMUTOLA": "L326",
  "TRANA": "L327",
  "TRANI": "L328",
  "TRAONA": "L330",
  "TRAPANI": "L331",
  "TRAPPETO": "L332",
  "TRAREGO VIGGIONA": "L333",
  "TRASACCO": "L334",
  "TRASAGHIS": "L335",
  "TRASQUERA": "L336",
  "TRATALIAS": "L337",
  "TRAVACO SICCOMARIO": "I236",
  "TRAVAGLIATO": "L339",
  "TRAVEDONA-MONATE": "L342",
  "TRAVERSELLA": "L345",
  "TRAVERSETOLO": "L346",
  "TRAVES": "L340",
  "TRAVESIO": "L347",
  "TRAVO": "L348",
  "TRE VILLE": "M361",
  "TREBASELEGHE": "L349",
  "TREBISACCE": "L353",
  "TRECASE": "M280",
  "TRECASTAGNI": "L355",
  "TRECASTELLI": "M318",
  "TRECATE": "L356",
  "TRECCHINA": "L357",
  "TRECENTA": "L359",
  "TREDOZIO": "L361",
  "TREGLIO": "L363",
  "TREGNAGO": "L364",
  "TREIA": "L366",
  "TREISO": "L367",
  "TREMESTIERI ETNEO": "L369",
  "TREMEZZINA": "M341",
  "TREMOSINE SUL GARDA": "L372",
  "TRENTINARA": "L377",
  "TRENTO": "L378",
  "TRENTOLA DUCENTA": "L379",
  "TRENZANO": "L380",
  "TREPPO GRANDE": "L382",
  "TREPPO LIGOSULLO": "M399",
  "TREPUZZI": "L383",
  "TREQUANDA": "L384",
  "TRESANA": "L386",
  "TRESCORE BALNEARIO": "L388",
  "TRESCORE CREMASCO": "L389",
  "TRESIGNANA": "M409",
  "TRESIVIO": "L392",
  "TRESNURAGHES": "L393",
  "TREVENZUOLO": "L396",
  "TREVI": "L397",
  "TREVI NEL LAZIO": "L398",
  "TREVICO": "L399",
  "TREVIGLIO": "L400",
  "TREVIGNANO": "L402",
  "TREVIGNANO ROMANO": "L401",
  "TREVILLE": "L403",
  "TREVIOLO": "L404",
  "TREVISO": "L407",
  "TREVISO BRESCIANO": "L406",
  "TREZZANO ROSA": "L408",
  "TREZZANO SUL NAVIGLIO": "L409",
  "TREZZO SULLADDA": "L411",
  "TREZZO TINELLA": "L410",
  "TREZZONE": "L413",
  "TRIBANO": "L414",
  "TRIBIANO": "L415",
  "TRIBOGNA": "L416",
  "TRICARICO": "L418",
  "TRICASE": "L419",
  "TRICERRO": "L420",
  "TRICESIMO": "L421",
  "TRIEI": "L423",
  "TRIESTE": "L424",
  "TRIGGIANO": "L425",
  "TRIGOLO": "L426",
  "TRINITA": "L427",
  "TRINITA DAGULTU E VIGNOLA": "L428",
  "TRINITAPOLI": "B915",
  "TRINO": "L429",
  "TRIORA": "L430",
  "TRIPI": "L431",
  "TRISOBBIO": "L432",
  "TRISSINO": "L433",
  "TRIUGGIO": "L434",
  "TRIVENTO": "L435",
  "TRIVIGLIANO": "L437",
  "TRIVIGNANO UDINESE": "L438",
  "TRIVIGNO": "L439",
  "TRIVOLZIO": "L440",
  "TRODENA NEL PARCO NATURALE": "L444",
  "TROFARELLO": "L445",
  "TROIA": "L447",
  "TROINA": "L448",
  "TROMELLO": "L449",
  "TRONTANO": "L450",
  "TRONZANO LAGO MAGGIORE": "A705",
  "TRONZANO VERCELLESE": "L451",
  "TROPEA": "L452",
  "TROVO": "L453",
  "TRUCCAZZANO": "L454",
  "TUBRE": "L455",
  "TUFARA": "L458",
  "TUFILLO": "L459",
  "TUFINO": "L460",
  "TUFO": "L461",
  "TUGLIE": "L462",
  "TUILI": "L463",
  "TULA": "L464",
  "TUORO SUL TRASIMENO": "L466",
  "TURANIA": "G507",
  "TURANO LODIGIANO": "L469",
  "TURATE": "L470",
  "TURBIGO": "L471",
  "TURI": "L472",
  "TURRI": "L473",
  "TURRIACO": "L474",
  "TURRIVALIGNANI": "L475",
  "TURSI": "L477",
  "TUSA": "L478",
  "TUSCANIA": "L310",
  "UBIALE CLANEZZO": "C789",
  "UBOLDO": "L480",
  "UCRIA": "L482",
  "UDINE": "L483",
  "UGENTO": "L484",
  "UGGIANO LA CHIESA": "L485",
  "UGGIATE-TREVANO": "L487",
  "ULA TIRSO": "L488",
  "ULASSAI": "L489",
  "ULTIMO": "L490",
  "UMBERTIDE": "D786",
  "UMBRIATICO": "L492",
  "URAGO DOGLIO": "L494",
  "URAS": "L496",
  "URBANA": "L497",
  "URBANIA": "L498",
  "URBE": "L499",
  "URBINO": "L500",
  "URBISAGLIA": "L501",
  "URGNANO": "L502",
  "URI": "L503",
  "URURI": "L505",
  "URZULEI": "L506",
  "USCIO": "L507",
  "USELLUS": "L508",
  "USINI": "L509",
  "USMATE VELATE": "L511",
  "USSANA": "L512",
  "USSARAMANNA": "L513",
  "USSASSAI": "L514",
  "USSEAUX": "L515",
  "USSEGLIO": "L516",
  "USSITA": "L517",
  "USTICA": "L519",
  "UTA": "L521",
  "UZZANO": "L522",
  "VACCARIZZO ALBANESE": "L524",
  "VACONE": "L525",
  "VACRI": "L526",
  "VADENA": "L527",
  "VADO LIGURE": "L528",
  "VAGLI SOTTO": "L533",
  "VAGLIA": "L529",
  "VAGLIO BASILICATA": "L532",
  "VAGLIO SERRA": "L531",
  "VAIANO": "L537",
  "VAIANO CREMASCO": "L535",
  "VAIE": "L538",
  "VAILATE": "L539",
  "VAIRANO PATENORA": "L540",
  "VAJONT": "M265",
  "VAL BREMBILLA": "M334",
  "VAL DELLA TORRE": "L555",
  "VAL DI CHY": "M405",
  "VAL DI NIZZA": "L562",
  "VAL DI VIZZE": "L564",
  "VAL DI ZOLDO": "M374",
  "VAL LIONA": "M384",
  "VAL MASINO": "L638",
  "VAL REZZO": "H259",
  "VALBONDIONE": "L544",
  "VALBREMBO": "L545",
  "VALBRENTA": "M423",
  "VALBREVENNA": "L546",
  "VALBRONA": "L547",
  "VALCHIUSA": "M415",
  "VALDAGNO": "L551",
  "VALDAONE": "M343",
  "VALDAORA": "L552",
  "VALDASTICO": "L554",
  "VALDENGO": "L556",
  "VALDERICE": "G319",
  "VALDIDENTRO": "L557",
  "VALDIERI": "L558",
  "VALDILANA": "M417",
  "VALDINA": "L561",
  "VALDISOTTO": "L563",
  "VALDOBBIADENE": "L565",
  "VALDUGGIA": "L566",
  "VALEGGIO": "L568",
  "VALEGGIO SUL MINCIO": "L567",
  "VALENTANO": "L569",
  "VALENZA": "L570",
  "VALENZANO": "L571",
  "VALERA FRATTA": "L572",
  "VALFABBRICA": "L573",
  "VALFENERA": "L574",
  "VALFLORIANA": "L575",
  "VALFORNACE": "M382",
  "VALFURVA": "L576",
  "VALGANNA": "L577",
  "VALGIOIE": "L578",
  "VALGOGLIO": "L579",
  "VALGRANA": "L580",
  "VALGREGHENTINO": "L581",
  "VALGRISENCHE": "L582",
  "VALGUARNERA CAROPEPE": "L583",
  "VALLADA AGORDINA": "L584",
  "VALLANZENGO": "L586",
  "VALLARSA": "L588",
  "VALLATA": "L589",
  "VALLE AGRICOLA": "L594",
  "VALLE AURINA": "L595",
  "VALLE CANNOBINA": "M404",
  "VALLE CASTELLANA": "L597",
  "VALLE DELLANGELO": "G540",
  "VALLE DI CADORE": "L590",
  "VALLE DI CASIES": "L601",
  "VALLE DI MADDALONI": "L591",
  "VALLE LOMELLINA": "L593",
  "VALLE SALIMBENE": "L617",
  "VALLE SAN NICOLAO": "L620",
  "VALLEBONA": "L596",
  "VALLECORSA": "L598",
  "VALLECROSIA": "L599",
  "VALLEDOLMO": "L603",
  "VALLEDORIA": "L604",
  "VALLEFIORITA": "I322",
  "VALLEFOGLIA": "M331",
  "VALLELAGHI": "M362",
  "VALLELONGA": "L607",
  "VALLELUNGA PRATAMENO": "L609",
  "VALLEMAIO": "L605",
  "VALLEPIETRA": "L611",
  "VALLERANO": "L612",
  "VALLERMOSA": "L613",
  "VALLEROTONDA": "L614",
  "VALLESACCARDA": "L616",
  "VALLEVE": "L623",
  "VALLI DEL PASUBIO": "L624",
  "VALLINFREDA": "L625",
  "VALLIO TERME": "L626",
  "VALLO DELLA LUCANIA": "L628",
  "VALLO DI NERA": "L627",
  "VALLO TORINESE": "L629",
  "VALLORIATE": "L631",
  "VALMACCA": "L633",
  "VALMADRERA": "L634",
  "VALMONTONE": "L639",
  "VALMOREA": "L640",
  "VALMOZZOLA": "L641",
  "VALNEGRA": "L642",
  "VALPELLINE": "L643",
  "VALPERGA": "L644",
  "VALPRATO SOANA": "B510",
  "VALSAMOGGIA": "M320",
  "VALSAVARENCHE": "L647",
  "VALSINNI": "D513",
  "VALSOLDA": "C936",
  "VALSTRONA": "L651",
  "VALTOPINA": "L653",
  "VALTORTA": "L655",
  "VALTOURNENCHE": "L654",
  "VALVA": "L656",
  "VALVARRONE": "M395",
  "VALVASONE ARZENE": "M346",
  "VALVERDE": "L658",
  "VALVESTINO": "L468",
  "VANDOIES": "L660",
  "VANZAGHELLO": "L664",
  "VANZAGO": "L665",
  "VANZONE CON SAN CARLO": "L666",
  "VAPRIO DADDA": "L667",
  "VAPRIO DAGOGNA": "L668",
  "VARALLO": "L669",
  "VARALLO POMBIA": "L670",
  "VARANO BORGHI": "L671",
  "VARANO DE MELEGARI": "L672",
  "VARAPODIO": "L673",
  "VARAZZE": "L675",
  "VARCO SABINO": "L676",
  "VAREDO": "L677",
  "VARENNA": "L680",
  "VARESE": "L682",
  "VARESE LIGURE": "L681",
  "VARISELLA": "L685",
  "VARMO": "L686",
  "VARNA": "L687",
  "VARSI": "L689",
  "VARZI": "L690",
  "VARZO": "L691",
  "VASANELLO": "A701",
  "VASIA": "L693",
  "VASTO": "E372",
  "VASTOGIRARDI": "L696",
  "VAUDA CANAVESE": "L698",
  "VAZZANO": "L699",
  "VAZZOLA": "L700",
  "VECCHIANO": "L702",
  "VEDANO AL LAMBRO": "L704",
  "VEDANO OLONA": "L703",
  "VEDELAGO": "L706",
  "VEDESETA": "L707",
  "VEDUGGIO CON COLZANO": "L709",
  "VEGGIANO": "L710",
  "VEGLIE": "L711",
  "VEGLIO": "L712",
  "VEJANO": "L713",
  "VELESO": "L715",
  "VELEZZO LOMELLINA": "L716",
  "VELLETRI": "L719",
  "VELLEZZO BELLINI": "L720",
  "VELO DASTICO": "L723",
  "VELO VERONESE": "L722",
  "VELTURNO": "L724",
  "VENAFRO": "L725",
  "VENARIA REALE": "L727",
  "VENAROTTA": "L728",
  "VENASCA": "L729",
  "VENAUS": "L726",
  "VENDONE": "L730",
  "VENEGONO INFERIORE": "L733",
  "VENEGONO SUPERIORE": "L734",
  "VENETICO": "L735",
  "VENEZIA": "L736",
  "VENIANO": "L737",
  "VENOSA": "L738",
  "VENTASSO": "M364",
  "VENTICANO": "L739",
  "VENTIMIGLIA": "L741",
  "VENTIMIGLIA DI SICILIA": "L740",
  "VENTOTENE": "L742",
  "VENZONE": "L743",
  "VERANO": "L745",
  "VERANO BRIANZA": "L744",
  "VERBANIA": "L746",
  "VERBICARO": "L747",
  "VERCANA": "L748",
  "VERCEIA": "L749",
  "VERCELLI": "L750",
  "VERCURAGO": "L751",
  "VERDELLINO": "L752",
  "VERDELLO": "L753",
  "VERDERIO": "M337",
  "VERDUNO": "L758",
  "VERGATO": "L762",
  "VERGHERETO": "L764",
  "VERGIATE": "L765",
  "VERMEZZO CON ZELO": "M424",
  "VERMIGLIO": "L769",
  "VERNANTE": "L771",
  "VERNASCA": "L772",
  "VERNATE": "L773",
  "VERNAZZA": "L774",
  "VERNIO": "L775",
  "VERNOLE": "L776",
  "VEROLANUOVA": "L777",
  "VEROLAVECCHIA": "L778",
  "VEROLENGO": "L779",
  "VEROLI": "L780",
  "VERONA": "L781",
  "VERONELLA": "D193",
  "VERRAYES": "L783",
  "VERRES": "C282",
  "VERRETTO": "L784",
  "VERRONE": "L785",
  "VERRUA PO": "L788",
  "VERRUA SAVOIA": "L787",
  "VERTEMATE CON MINOPRIO": "L792",
  "VERTOVA": "L795",
  "VERUCCHIO": "L797",
  "VERVIO": "L799",
  "VERZEGNIS": "L801",
  "VERZINO": "L802",
  "VERZUOLO": "L804",
  "VESCOVANA": "L805",
  "VESCOVATO": "L806",
  "VESIME": "L807",
  "VESPOLATE": "L808",
  "VESSALICO": "L809",
  "VESTENANOVA": "L810",
  "VESTIGNE": "L811",
  "VESTONE": "L812",
  "VETRALLA": "L814",
  "VETTO": "L815",
  "VEZZA DALBA": "L817",
  "VEZZA DOGLIO": "L816",
  "VEZZANO LIGURE": "L819",
  "VEZZANO SUL CROSTOLO": "L820",
  "VEZZI PORTIO": "L823",
  "VIADANA": "L826",
  "VIADANICA": "L827",
  "VIAGRANDE": "L828",
  "VIALE": "L829",
  "VIALFRE": "L830",
  "VIANO": "L831",
  "VIAREGGIO": "L833",
  "VIARIGI": "L834",
  "VIBO VALENTIA": "F537",
  "VIBONATI": "L835",
  "VICALVI": "L836",
  "VICARI": "L837",
  "VICCHIO": "L838",
  "VICENZA": "L840",
  "VICO DEL GARGANO": "L842",
  "VICO EQUENSE": "L845",
  "VICO NEL LAZIO": "L843",
  "VICOFORTE": "L841",
  "VICOLI": "L846",
  "VICOLUNGO": "L847",
  "VICOPISANO": "L850",
  "VICOVARO": "L851",
  "VIDDALBA": "M259",
  "VIDIGULFO": "L854",
  "VIDOR": "L856",
  "VIDRACCO": "L857",
  "VIESTE": "L858",
  "VIETRI DI POTENZA": "L859",
  "VIETRI SUL MARE": "L860",
  "VIGANO": "L866",
  "VIGANO SAN MARTINO": "L865",
  "VIGARANO MAINARDA": "L868",
  "VIGASIO": "L869",
  "VIGEVANO": "L872",
  "VIGGIANELLO": "L873",
  "VIGGIANO": "L874",
  "VIGGIU": "L876",
  "VIGHIZZOLO DESTE": "L878",
  "VIGLIANO BIELLESE": "L880",
  "VIGLIANO DASTI": "L879",
  "VIGNALE MONFERRATO": "L881",
  "VIGNANELLO": "L882",
  "VIGNATE": "L883",
  "VIGNOLA": "L885",
  "VIGNOLA-FALESINA": "L886",
  "VIGNOLE BORBERA": "L887",
  "VIGNOLO": "L888",
  "VIGNONE": "L889",
  "VIGO DI CADORE": "L890",
  "VIGODARZERE": "L892",
  "VIGOLO": "L894",
  "VIGOLZONE": "L897",
  "VIGONE": "L898",
  "VIGONOVO": "L899",
  "VIGONZA": "L900",
  "VIGUZZOLO": "L904",
  "VILLA BARTOLOMEA": "L912",
  "VILLA BASILICA": "L913",
  "VILLA BISCOSSI": "L917",
  "VILLA CARCINA": "L919",
  "VILLA CASTELLI": "L920",
  "VILLA CELIERA": "L922",
  "VILLA COLLEMANDINA": "L926",
  "VILLA CORTESE": "L928",
  "VILLA DADDA": "L929",
  "VILLA DALME": "A215",
  "VILLA DEL BOSCO": "L933",
  "VILLA DEL CONTE": "L934",
  "VILLA DI BRIANO": "D801",
  "VILLA DI CHIAVENNA": "L907",
  "VILLA DI SERIO": "L936",
  "VILLA DI TIRANO": "L908",
  "VILLA DOGNA": "L938",
  "VILLA ESTENSE": "L937",
  "VILLA FARALDI": "L943",
  "VILLA GUARDIA": "L956",
  "VILLA LAGARINA": "L957",
  "VILLA LATINA": "A081",
  "VILLA LITERNO": "L844",
  "VILLA MINOZZO": "L969",
  "VILLA SAN GIOVANNI": "M018",
  "VILLA SAN GIOVANNI IN TUSCIA": "H913",
  "VILLA SAN PIETRO": "I118",
  "VILLA SAN SECONDO": "M019",
  "VILLA SANTA LUCIA": "L905",
  "VILLA SANTA LUCIA DEGLI ABRUZZI": "M021",
  "VILLA SANTA MARIA": "M022",
  "VILLA SANTANGELO": "M023",
  "VILLA SANTANTONIO": "I298",
  "VILLA SANTINA": "L909",
  "VILLA SANTO STEFANO": "I364",
  "VILLA VERDE": "A609",
  "VILLABASSA": "L915",
  "VILLABATE": "L916",
  "VILLACHIARA": "L923",
  "VILLACIDRO": "L924",
  "VILLADEATI": "L931",
  "VILLADOSE": "L939",
  "VILLADOSSOLA": "L906",
  "VILLAFALLETTO": "L942",
  "VILLAFRANCA DASTI": "L945",
  "VILLAFRANCA DI VERONA": "L949",
  "VILLAFRANCA IN LUNIGIANA": "L946",
  "VILLAFRANCA PADOVANA": "L947",
  "VILLAFRANCA PIEMONTE": "L948",
  "VILLAFRANCA SICULA": "L944",
  "VILLAFRANCA TIRRENA": "L950",
  "VILLAFRATI": "L951",
  "VILLAGA": "L952",
  "VILLAGRANDE STRISAILI": "L953",
  "VILLALAGO": "L958",
  "VILLALBA": "L959",
  "VILLALFONSINA": "L961",
  "VILLALVERNIA": "L963",
  "VILLAMAGNA": "L964",
  "VILLAMAINA": "L965",
  "VILLAMAR": "L966",
  "VILLAMARZANA": "L967",
  "VILLAMASSARGIA": "L968",
  "VILLAMIROGLIO": "L970",
  "VILLANDRO": "L971",
  "VILLANOVA BIELLESE": "L978",
  "VILLANOVA CANAVESE": "L982",
  "VILLANOVA DALBENGA": "L975",
  "VILLANOVA DARDENGHI": "L983",
  "VILLANOVA DASTI": "L984",
  "VILLANOVA DEL BATTISTA": "L973",
  "VILLANOVA DEL GHEBBO": "L985",
  "VILLANOVA DEL SILLARO": "L977",
  "VILLANOVA DI CAMPOSAMPIERO": "L979",
  "VILLANOVA MARCHESANA": "L988",
  "VILLANOVA MONDOVI": "L974",
  "VILLANOVA MONFERRATO": "L972",
  "VILLANOVA MONTELEONE": "L989",
  "VILLANOVA SOLARO": "L990",
  "VILLANOVA SULLARDA": "L980",
  "VILLANOVA TRUSCHEDU": "L991",
  "VILLANOVA TULO": "L992",
  "VILLANOVAFORRU": "L986",
  "VILLANOVAFRANCA": "L987",
  "VILLANTERIO": "L994",
  "VILLANUOVA SUL CLISI": "L995",
  "VILLAPERUCCIO": "M278",
  "VILLAPIANA": "B903",
  "VILLAPUTZU": "L998",
  "VILLAR DORA": "L999",
  "VILLAR FOCCHIARDO": "M007",
  "VILLAR PELLICE": "M013",
  "VILLAR PEROSA": "M014",
  "VILLAR SAN COSTANZO": "M015",
  "VILLARBASSE": "M002",
  "VILLARBOIT": "M003",
  "VILLAREGGIA": "M004",
  "VILLARICCA": "G309",
  "VILLAROMAGNANO": "M009",
  "VILLAROSA": "M011",
  "VILLASALTO": "M016",
  "VILLASANTA": "M017",
  "VILLASIMIUS": "B738",
  "VILLASOR": "M025",
  "VILLASPECIOSA": "M026",
  "VILLASTELLONE": "M027",
  "VILLATA": "M028",
  "VILLAURBANA": "M030",
  "VILLAVALLELONGA": "M031",
  "VILLAVERLA": "M032",
  "VILLE DANAUNIA": "M363",
  "VILLE DI FIEMME": "M431",
  "VILLENEUVE": "L981",
  "VILLESSE": "M043",
  "VILLETTA BARREA": "M041",
  "VILLETTE": "M042",
  "VILLIMPENTA": "M044",
  "VILLONGO": "M045",
  "VILLORBA": "M048",
  "VILMINORE DI SCALVE": "M050",
  "VIMERCATE": "M052",
  "VIMODRONE": "M053",
  "VINADIO": "M055",
  "VINCHIATURO": "M057",
  "VINCHIO": "M058",
  "VINCI": "M059",
  "VINOVO": "M060",
  "VINZAGLIO": "M062",
  "VIOLA": "M063",
  "VIONE": "M065",
  "VIPITENO": "M067",
  "VIRLE PIEMONTE": "M069",
  "VISANO": "M070",
  "VISCHE": "M071",
  "VISCIANO": "M072",
  "VISCO": "M073",
  "VISONE": "M077",
  "VISSO": "M078",
  "VISTARINO": "M079",
  "VISTRORIO": "M080",
  "VITA": "M081",
  "VITERBO": "M082",
  "VITICUSO": "M083",
  "VITO DASIO": "M085",
  "VITORCHIANO": "M086",
  "VITTORIA": "M088",
  "VITTORIO VENETO": "M089",
  "VITTORITO": "M090",
  "VITTUONE": "M091",
  "VITULANO": "M093",
  "VITULAZIO": "M092",
  "VIU": "M094",
  "VIVARO": "M096",
  "VIVARO ROMANO": "M095",
  "VIVERONE": "M098",
  "VIZZINI": "M100",
  "VIZZOLA TICINO": "M101",
  "VIZZOLO PREDABISSI": "M102",
  "VO": "M103",
  "VOBARNO": "M104",
  "VOBBIA": "M105",
  "VOCCA": "M106",
  "VODO CADORE": "M108",
  "VOGHERA": "M109",
  "VOGHIERA": "M110",
  "VOGOGNA": "M111",
  "VOLANO": "M113",
  "VOLLA": "M115",
  "VOLONGO": "M116",
  "VOLPAGO DEL MONTELLO": "M118",
  "VOLPARA": "M119",
  "VOLPEDO": "M120",
  "VOLPEGLINO": "M121",
  "VOLPIANO": "M122",
  "VOLTA MANTOVANA": "M125",
  "VOLTAGGIO": "M123",
  "VOLTAGO AGORDINO": "M124",
  "VOLTERRA": "M126",
  "VOLTIDO": "M127",
  "VOLTURARA APPULA": "M131",
  "VOLTURARA IRPINA": "M130",
  "VOLTURINO": "M132",
  "VOLVERA": "M133",
  "VOTTIGNASCO": "M136",
  "ZACCANOPOLI": "M138",
  "ZAFFERANA ETNEA": "M139",
  "ZAGARISE": "M140",
  "ZAGAROLO": "M141",
  "ZAMBRONE": "M143",
  "ZANDOBBIO": "M144",
  "ZANE": "M145",
  "ZANICA": "M147",
  "ZAPPONETA": "M267",
  "ZAVATTARELLO": "M150",
  "ZECCONE": "M152",
  "ZEDDIANI": "M153",
  "ZELBIO": "M156",
  "ZELO BUON PERSICO": "M158",
  "ZEME": "M161",
  "ZENEVREDO": "M162",
  "ZENSON DI PIAVE": "M163",
  "ZERBA": "M165",
  "ZERBO": "M166",
  "ZERBOLO": "M167",
  "ZERFALIU": "M168",
  "ZERI": "M169",
  "ZERMEGHEDO": "M170",
  "ZERO BRANCO": "M171",
  "ZEVIO": "M172",
  "ZIANO DI FIEMME": "M173",
  "ZIANO PIACENTINO": "L848",
  "ZIBIDO SAN GIACOMO": "M176",
  "ZIGNAGO": "M177",
  "ZIMELLA": "M178",
  "ZIMONE": "M179",
  "ZINASCO": "M180",
  "ZOAGLI": "M182",
  "ZOCCA": "M183",
  "ZOGNO": "M184",
  "ZOLA PREDOSA": "M185",
  "ZOLLINO": "M187",
  "ZONE": "M188",
  "ZOPPE DI CADORE": "M189",
  "ZOPPOLA": "M190",
  "ZOVENCEDO": "M194",
  "ZUBIENA": "M196",
  "ZUCCARELLO": "M197",
  "ZUGLIANO": "M199",
  "ZUGLIO": "M200",
  "ZUMAGLIA": "M201",
  "ZUMPANO": "M202",
  "ZUNGOLI": "M203",
  "ZUNGRI": "M204",
};

export function belfioreCode(comune) {
  if (!comune) return null;
  const key = comune
    .normalize("NFD").replace(/[\u0300-\u036f]/g, "")
    .toUpperCase().replace(/['`\u2019]/g, "").replace(/\s+/g, " ").trim();
  return BELFIORE[key] || null;
}
